// ADL
import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from '../formAux.js';
import 'jquery-ui/ui/widgets/slider';

var descriptor = [];

var scriptMode = 'adl';

var closeIcon = '';
var searchIcon = '';


var b;
var brushMaxSize;
var brushMinSize;
var bSel;
var changed;
var corner;
var getBoxes;
var getSelected;
var ocrLinks;
var oselected;
var polygonDiff;
var polygonIntersection;
var polygonUnion;
var rattribs;
var reviewMode;
var scrollLeft;
var scrollTop;
var setLocked;
var setOver;
var setSelected;
var setVisible;
var showFrameSelectTid;
var submitAnnotations;
var td;
var td2;

window.zoom = 1;
window.offx = 0;
window.offy = 0;
window.baseWidth = 0;
window.baseHeight = 0;

// ADLEND

// EXPORTSTART


var playMode = false;
var captureOveride = false;
var popupHeight = 300;
var popupWidth = 300;

var declined = false;

var lineMode = false;
var mainLeftOffset = 0;


var hotKeys = {};


// $('#imageoverlay').css({width:px(800)});;
$('#controlpanel').hide();
$('#vnext').on('click',function(){ pause(); showFrame( trackData.currentFrame+1, 1 ); });
$('#vprev').on('click',function(){ pause(); showFrame( trackData.currentFrame-1 ); });
$('#vstart').on('click',function(){ pause(); showFrame( 0 ); });
$('#vend').on('click',function(){ pause(); showFrame( 100000000 ); });
$('#vpause').hide().on('click', pause);
$('#vplay').on('click', play);


var myAlert = function( title, message )
{
	$('.modal-title').html(title);
	$('.modal-body').html(message);
	$("#myModal").modal()
}

var myAlertClose = function(){}

function offset(el)
{
	// console.log( el );
	if( !el || !el[0] ) return null;
    var rect = el[0].getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function paletteWheel( div, brightness )
{
	if( !brightness ) brightness = 1;
	var floor = 0;
	if( brightness > 1 ){
		floor = brightness-1;
		brightness = 1;
	}
	floor *= 255;
  	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
    var colors = [];
    function interpolate(v)
    {
        v *= steps.length-1;
        var i = Math.floor(v);
        var r = v-i;
        var ir = 1-r;
        // console.log( 'v', v, 'i', i, 'r', r );
        return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
    }
    for( var d = 0 ; d < div ; d++ )
    {
        var c = interpolate( d/div);
        var hc = '#' + c.map( v => Math.min(Math.floor(floor+v*brightness),255).toString(16).padStart(2,'0')).join('');
        colors.push( hc );
    }
    return colors;
}


function saveClipboard( txt )
{
	var input = $('<textarea>').val(txt).css({position:'absolute',top:px(-10000),left:px(-100000)});
	$(document.body).append(input);
	input.select();
	// input.setSelectionRange(0, 99999999);
	document.execCommand("copy");
	setTimeout( function(){
		input.remove();
	}, 100 );
}


function list2Tree( list )
{
	list = clone(list);
	var treeList = [];
	var ids = {};
	for( var i = 0 ; i < list.length ; i++ )
	{
		ids[list[i].id] = list[i];
		list[i].sub_labels = [];
	}

	for( var i = 0 ; i < list.length ; i++ )
	{
		if( list[i].parent ) ids[list[i].parent].sub_labels.push( list[i] );
		else treeList.push( list[i] );
	}
	for( var i = 0 ; i < list.length ; i++ )
	{
		delete list[i].parent;
		delete list[i].spath;
		// delete list[i].id;
	}
	return treeList;
}

function tree2List( tree )
{
	tree = clone(tree);
	var list = [];
	var nb = 1;
	function walk( o, parent, path )
	{
		if( !parent )
		{
			path = [];
		}
		path = clone(path);
		path.push( o.label );
		if( !o.id ) o.id = 'newid_'+(nb++);
		o.spath = path.join('|');
		o.parent = parent;
		var subs = o.sub_labels;
		if( !subs ) subs = [];
		delete o.sub_labels;
		list.push( o );
		subs.forEach( function(s){
			walk( s, o.id, path );
		})
	}
	tree.forEach( function(t){ walk( t, null );});
	return list;
}


var palette = [
	'#D37108',
	// '#D3B108',
	'#AED308',
	'#08D385',
	'#08BFD3',
	'#0845D3',
	'#7E08D3',
	'#D308BF',
	'#D3086A',
];

function getColor( s )
{
	s = s.replace(/\..*/,'');
	var l = s.split('');
	var n = 4969;
	for( var i = 0 ; i < l.length ; i++ )
	{
		n *= 7;
		n += i*19+l[i].charCodeAt(0)*11;
		n = n % 7919;
		// console.log(l[i].charCodeAt(0), n )
	}
	// console.log( n % palette.length );
	return palette[n % palette.length];
}

$('#loadbtn').on('click', function()
{
	localStorage.clear();
	try
	{
		trackData = JSON.parse($('#loadJSON').val());
		preload( trackData );
		$('#imageoverlay').hide();
		$('#controlpanel').hide();

	}
	catch(e){ alert( 'invalid JSON' ); };
});


// bind events on the control panel inputs
$('#loop').on('change',function(ev){ bbox.config({loop:this.checked}) });
$('#movelock').on('change',function(ev){ bbox.config({movelock:this.checked}) });
$('#capture').on('change',function(ev)
{
	bbox.config({capture:this.checked})
	trackData.frames[trackData.currentFrame].tags.capture = this.checked;
});
$('#dotColor').on('change',function(ev){ bbox.config({dotColor:this.value}) });
$('#dotSelectedColor').on('change',function(ev){ bbox.config({dotSelectedColor:this.value}) });
$('#pathColor').on('change',function(ev){ bbox.config({pathColor:this.value}) });
$('#clear').on('click', clearToEnd );
$('#annotationlabel').on('change',function(){ trackData.label = $(this).val().trim(); saveTrackData() } );

var bbox = null; // bbox object
var frameRate = 5;
var playTid = null;
$('#fps').val(frameRate).on('change',function(){
	var f = $(this).val();
	f = parseFloat(f);
	if( !isNaN(f) && f > 0 && f < 100 )
		frameRate = f;
	$(this).val(frameRate);
});

function px(v) { return Math.round(v)+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }

function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object && !(o instanceof Array);}
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }



// this is the file upload function. It will load the image and call the bbox
// also show the image and the control panel
function getImgFile()
{
	var reader  = new FileReader();
	var input = $('#imgfile')[0].files[0];
	var fileName = $('#imgfile')[0].value;
	fileName = fileName.replace(/.*\//,'');
	fileName = fileName.replace(/.*\\/,'');
	var imgPreview = $('#imgpreview');
	reader.onloadend = function(ev)
	{
		imgPreview.prop({
							src:reader.result,
							fileName: fileName
						});
		imgPreview.on('load',function()
		{
			bbox = new BBox({
								imageObj:imgPreview, 
								onchange: savePoints, 
								capture:$('#capture').prop('checked'), 
								dotColor:$('#dotColor').val(), 
								dotSelectedColor:$('#dotSelectedColor').val(), 
								pathColor:$('#pathColor').val(), 
								selected: selected,
							});
		});
		$('#imageoverlay').show();
		$('#controlpanel').show();
	}
	reader.readAsDataURL(input);
}


var annotationsJSON = null;
var currentCurve = null;

// callback from the bbox object
// this will get the jsonCode and set it to be downloaded by the Download button in the control panel
function savePoints(jsonCode)
{
	annotationsJSON = jsonCode;
	currentCurve = {boxes:clone(jsonCode.boxes),loop:jsonCode.loop};
	console.log( JSON.stringify(currentCurve) );
}


// you can preload any image and call the bbox on it

var trackData = null;

// localStorage.clear();
// if( localStorage.getItem('trackData') )
// {
// 	trackData = JSON.parse(localStorage.getItem('trackData'));
// 	console.log( 'TRACKDATA', trackData );
// 	preload( init );
// }
// else
// 	loadImages( baseImage, baseImageFrames, init );

//trackData = JSON.parse($('#document-image').html());
var zoom = 1;
var offx = 0;
var offy = 0;
var baseWidth = 0;
var baseHeight = 0;

var coco = new COCO();


function init( descriptor )
{
	start();
	showSave('Session started', window.descriptor.sessionStart * 1000)
	$('#imageoverlay').show();
	$('#controlpanel').show();
	$('#annotationlabel').val( trackData.label ? trackData.label : '' );
	showFrame( 0 )
}


var idCt = new Date().getTime();
function tmpId( baseId )
{
	if( baseId ) return 'tmpid_' + baseId;
	var id = idCt++;
	// console.log( 'tmpId', id );
	return "tmpid_" + id;
}

var simpIds = {};
var simpCt = 0;
function simplifyId(id)
{
	if( !id ) return null;
	var sid = id && id in simpIds ? simpIds[id] : 'b' + simpCt++;
	simpIds[id] = sid;
	return sid;
}

/*
 * Loads n frames
 */
function loadImages( firstImage, numImg, callback )
{
	var data = { frames:[], currentFrame:0 };
	var imbase = firstImage;
	var match = firstImage.match(/[0-9]+\.(png|jpg|gif|bmp)/);
	if( !match )
	{
		alert( 'invalid first image' );
		return;
	}
	console.log( 'MATCH', match );
	var ext = match[1];
	match = match[0];
	var fcount = parseInt(match);
	var pad = match.length-4;
	for( var i = 0 ; i < numImg ; i++ )
	{
		var seq = (fcount+i).toString().padStart(pad,'0') + '.' + ext;
		var file = firstImage.replace(match,seq);
// 		console.log( 'FFFFFFFFFFFFFf', file, match, pad );
		data.frames.push({url:file, seq_id: i+1});
	}
	trackData = data;
	console.log( JSON.stringify('FRAMES', trackData.frames) );
	preload( trackData );
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return 0;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function desc2Flat( desc )
{
	var flat = [];
	if( desc.image_attrs )
		flat.push( {label:"#image",type:'image',optional:1,attrs:desc.image_attrs, parent: null });
	function addRecursive( objs, parent )
	{
		if( !objs ) return;
		var path = parent ? parent.path : [];
		objs.forEach( function(o){
			var nobj = {};
			var attrs = o.attrs;
			if( attrs )
			{
				attrs.forEach( function(a)
				{
					a.optional = bool(a.optional);
				})
			}
			nobj.label = o.label;
			nobj.type = o.type;
			nobj.linkto = o.linkto;
			nobj.optional = bool(o.optional);
			nobj.shape = o.shape;
			nobj.attrs = o.attrs;
			nobj.title = o.title;
			nobj.title = o.title;
			nobj.path = clone(path);
			nobj.path.push( o.label )
			nobj.parent = parent;
			nobj.sparent = path.join('|');
			nobj.spath = nobj.path.join('|');
			nobj.color = o.color;
			flat.push( nobj );
			// console.log( 'PATH', path );
			addRecursive( o.sub_labels, nobj );
		});
	}
	addRecursive( desc.object_labels, null );
	var wheel = paletteWheel(flat.length-1, 1);
	console.log( 'paletteWheel', wheel, flat )
	window.labelColor = {};
	flat.forEach( (f,idx) => {
		if( !f.color ) f.color = wheel[idx-1];
		window.labelColor[f.label] = f.color;
	});
	return flat;
}


function preload( descriptor )
{
	try {
		$('.imgdisplay').css({background:'#ccc',padding:0});
		trackData = descriptor || JSON.parse($('#document-image').html().replace(/&amp;/g, '&'));
		$("#imgtitle").html( trackData.title ? trackData.title : '' );
		trackData.currentFrame = 0;
	
		var data = trackData;
		if( !data.frames )
		{
			data.frames = [ data.scene ];
		}
	
		// data.frames = [data.objects];
		// console.log( 'FDESC', data.fdesc );
		var framesLeft = data.frames.length;
		function imgDone()
		{
			--framesLeft;
	// 		console.log( framesLeft );
			var img = this;
			var scene = data.frames[img.frame];
			// console.log( 'ONLOAD', img.src, img.width, img.height );
			if( !scene.url && scene.annotations ) // if COCO format
			{
				if( !scene.images[0].width )
				{
					scene.images[0].width = img.width;
					scene.images[0].height = img.height;
				}
				scene = data.frames[img.frame] = coco.toScene( scene );
			}
			scene.img = img;
			if( !framesLeft ) init();
		}
		for( var i = 0 ; i < data.frames.length ; i++ )
		{
			var scene = data.frames[i];
			var file = scene.url || scene.images[0].file_name || scene.images[0].path || scene.images[0].coco_url;
			var img = new Image;
			img.onload = imgDone;
			img.frame = i;
			img.src = file;
		}
		data.fdesc = desc2Flat(data.descriptor);
	}
	catch( e ) {}
}

var oWidth = 0;
var oHeight = 0;

function showFrame( frame, next )
{
	try {
		var data = trackData;
		if( frame < 0 ) frame = 0;
		if( frame >= data.frames.length ) frame = data.frames.length-1;
		clearTimeout(data.tid);
		data.currentFrame = frame;
	// 	console.log( 'showFrame', data, frame, data.frames[frame] );
		if( !window.oWidth )
		{
			var im = new Image;
			im.src = data.frames[frame].url;
			$(im).on('load', function(){ getOrig(this) } );
	
			function getOrig( im )
			{
				window.oWidth = im.width;
				window.oHeight = im.height;
				console.log( 'ORIG', window.oWidth, window.oHeight )
				if( !$('#imgpreview').prop('src') )
				{
					$('#imgpreview').prop('src',data.frames[frame].url );
					$('#imgpreview').on('load', function()
					{
						showFrame( frame, next );
					});
					return;
				}
			}
		}
		var fObj = data.frames[frame]
		var bPoints = fObj.boxes;
		// console.log( 'BPOINTS', bPoints );
		var bSelected = fObj.selected;
	// 	console.log( 'CURVE', frame, next, JSON.stringify(tags) );
		var capture = fObj.capture;
		$('#capture').prop('checked',capture);
	
		// console.log( 'bPoints', bPoints, trackData );
		bbox = new BBox({
								imageObj:$('#imgpreview'), 
								onchange: save, 
								capture:capture, 
								boxes:bPoints,
								selected:bSelected, 
								dotColor:$('#dotColor').val(), 
								dotSelectedColor:$('#dotSelectedColor').val(), 
								pathColor:$('#pathColor').val(), 
								image_attrs: fObj.image_attrs,
								review_mode: data.review_mode,
						});
		function save(jsonData)
		{
			// console.log( 'SAVE', jsonData );
			// return;
			data.frames[frame] = jsonData;
			clearTimeout(data.tid);
			data.tid = setTimeout( function()
			{
				saveTrackData();
			}, 500 );
		}
		var sval = Math.round(frame/data.frames.length*100);
	// 	console.log( 'sval', sval );
	} catch (e) { $(window).off('resize', showFrame) }
	
	$(window).scrollTop(0)
}

function clearToEnd()
{
	// if( confirm( 'This will clear all points from this frame to the end. Are you sure?' ) )
	if( 1 )
	{
		bbox.reset()
		for( var i = trackData.currentFrame ; i < trackData.frames.length ; i++ )
			delete trackData.frames[i].tags;
	}
}


function pause()
{
	playMode = captureOveride = false;
	$('#vpause').hide();
	$('#vplay').show();
	clearTimeout( playTid );
	showFrame( trackData.currentFrame );
}

function play()
{
	playMode = true;
	$('#vplay').hide();
	$('#vpause').show();
	function fnext()
	{
		if( trackData.currentFrame < trackData.frames.length-1 )
			var nf = trackData.currentFrame+1;
		else
		{
			var nf = 0;
		}
		showFrame( nf );

		playTid = setTimeout( fnext, 1000/frameRate );
	}
	playTid = setTimeout( fnext, 1000/frameRate );
}


function saveTrackData()
{
	var data = clone(trackData);
	for( var i = 0 ; i < data.frames.length ; i++ )
	{
		delete data.frames[i].img;
	}
	localStorage.setItem('trackData', JSON.stringify(data) );
	var out = clone(data.frames[0]);
	// out.boxes = list2Tree(data.frames[0].boxes);
	delete out.capture;
	trackData.annotations = out;
	// console.log( 'saveData', out );
	// console.log( 'saveData', JSON.stringify(out, null, ' ') );
}

function exportData(check)
{
	if( declined ) check = false;
	var exportCOCO = trackData.descriptor.exportCOCO || false;

	var a = clone(trackData.annotations);
	var ret = a;

	if( declined )
	{
		if( 0 && check && $('#annotator_notes').val().trim() == '' ) // dont require a reason for now
		{
			// myAlert('Submit Error', 'Please inform the reason for declining the task', 'Ok', function(){
			// 	setTimeout( function(){ $('#annotator_notes')[0].focus() }, 300 );
			// } );
			return null;
		}
		ret.taskDeclined = true;
		ret.declineReason = $('#annotator_notes').val().trim();
		check = false;
	}
	if( check && !window.bboxCheck() ) return null;



    if( reviewMode )
	{
		if( !$('#reviewer_rate').val() && check )
		{
			myAlert('Submit Error', 'Please assign the quality of the annotations' );
			return null;
		}
		if( $('#reviewer_rate').val() == 'Adjust' && !$('#reviewer_notes').val().trim() && check )
		{
			myAlert('Submit Error', 'Please add a note to the annotator with your requests' );
			return null;
		}
		ret.review = {rate:$('#reviewer_rate').val(),note:$('#reviewer_notes').val()}
	}
   	if ($('#annotator_notes').length && $('#annotator_notes').val().trim() > '') {
		if (!ret.attributes) ret.attributes = {};
		ret.attributes["Aditional Notes"] = $('#annotator_notes').val().trim();
	}


	if( trackData.review_mode )
	{

		a.review_status = $('#review_allok').prop('checked') ? "OK" : "NOT OK";
		a.review_comments = $('#comment').val();
	}

	// cleans x2, y2 from check points before exporting
	function cleanKeyPoints( o )
	{
		if( !o ) return;
		o.forEach( function(b){
			delete b.colorize;
			delete b.locked;
			if( b.type == 'keypoint' )
			{
				delete b.x2;
				delete b.y2;
			}
			cleanKeyPoints( b.sub_labels );
		});
	}
	cleanKeyPoints( a.boxes );

	if (exportCOCO) {
		var cocoData = coco.toCoco(a)
		console.log('cocos', cocoData )
		// var scene = coco.toScene( cocoData );
		if (document.location.href.indexOf('localhost') >= 0) saveClipboard( JSON.stringify(cocoData, null, '\t') );
		return cocoData;
	}

 
	a.image_attrs = image_attrs;
	a.jobStart = trackData.scene.jobStart;
	a.sessionTime = (getsec()-trackData.scene.sessionStart);
	// console.log( 'TIME2', getsec(), trackData.scene.sessionStart )
	a.elapsedTime = trackData.scene.elapsedTime + a.sessionTime;
    a.tsSeconds = true;
	a.updateTime = getsec();
	// if (document.location.href.indexOf('localhost') >= 0) saveClipboard( JSON.stringify(a.boxes) )
	if (document.location.href.indexOf('localhost') >= 0) saveClipboard( JSON.stringify(a) )
	// console.log( 'exportData', a )
	return a;
}


function COCO() {
	var width;
	var height;
	var area;
	var wheel = paletteWheel(10, 1);
	var colorNum = 0;

	function denorm(o) {
		if (!isarray(o)) return;
		var flatten = false;
		for (var i = 0; i < o.length; i++) {
			if (isarray(o[i])) o[i] = denorm(o[i]);
			else o[i] *= (i & 1) ? height : width;
		}
		return o;
	}
	function norm(o) {
		if (!isarray(o)) return;
		var flatten = false;
		for (var i = 0; i < o.length; i++) {
			if (isarray(o[i])) o[i] = norm(o[i]);
			else o[i] /= (i & 1) ? height : width;
		}
		return o;
	}
	function inv(o) {
		var out = [];
		for (var i = o.length - 1; i >= 0; i--) out.push(o[i]);
		return out;
	}
	function clockWise( p )
	{
		var sum = 0;
		for( var i = 0 ; i < p.length-1 ; i++ )
		{
			var s = (p[i+1][0]-p[i][0])*(p[i+1][1]-p[i][1]);
			sum += s;
		}
		// console.log( 'clockWise', p, sum )
		return sum >= 0;
	}
	function mergeHoles(plist) {
		// return plist;
		var pts = [];
		var stack = [];
		console.log('merge', plist.length)
		for (var i = 0; i < plist.length; i++) {
			if( !clockWise( plist[i])) plist[i] = inv(plist[i])
			if (i) {
				stack.push(pts.pop());
				stack.push(pts[pts.length - 1]);
				// if( clockWise( plist[i]) )
				if( i & 1 )
				{
					plist[i] = inv(plist[i]);
					console.log( 'IIIIIIINV', i)
				}
			}
			plist[i].forEach(p => pts.push(p))
		}
		while (stack.length) pts.push(stack.pop());
		var out = [];
		pts.forEach(p => out = out.concat(p));
		return out;
	}
	function splitHoles(plist) {
		var out = [];
		for (var i = 0; i < plist.length; i++) {
			var pts = [];
			var already = {};
			var poligs = [[]]
			for (var j = 0; j < plist[i].length; j += 2) {
				var p = [plist[i][j], plist[i][j + 1]];
				var sp = p.toString();
				if (already[sp]) {
					console.log('sp', sp, 'repeated, current', poligs[0].length, already[sp]);
					var np = [p];
					do {
						var tmp = poligs[0].pop();
						np.push(tmp);
					} while (tmp.toString() != sp);
					poligs.push(np);
					j += 2;
					continue;
				}
				else already[sp] = poligs[0].length;
				poligs[0].push(p);
			}
			out.push(poligs);
		}
		return out;
	}
	function toScene( cocos )
	{
		console.log( 'converting from COCO fromat' )
		var img = cocos.images[0];
		width = img.width;
		height = img.height;
		area = width*height;
		var scene = {
			"url": img.path || img.file_name || img.coco_url,
			"imageWidth": width,
			"imageHeight": height,
			"image_attrs": img.attributes || null,
			"selected": null,
			"boxes": [],
		}
		var ccateg = {};
		for( var c of cocos.categories )
		{
			ccateg[c.id] = c.name;
			var olabel = trackData.descriptor.object_labels.find( o => o.label == c.name );
			if (!olabel) {
				var newLabel = {
					"label": c.name,
					"type": c.type || "polygon",
					"optional": c.optional || "Yes",
					"ccolor": c.color || wheel[colorNum++ % wheel.length],
					"attrs": c.attrs || [],
				}
				console.log( 'add new label', newLabel );
				trackData.descriptor.object_labels.push( newLabel );
			}
		}
		for( var a of cocos.annotations )
		{
			var label = ccateg[a.category_id]
			var an = {
				"x1": a.bbox[0], "y1": a.bbox[1], "x2": a.bbox[2], "y2": a.bbox[3],
				"id": "b" + a.id,
				"type": a.type || "polygon",
				"area": a.area / area,
				"shape": null,
				"attrs": a.attributes || {},
				// "title": label + '_' + a.id,
				"title": label,

				"label": label,
				"sub_labels": [],
			};
			if( an.type == 'polygon' )
			{
				an.shape = norm(splitHoles( a.segmentation ));
			}
			scene.boxes.push( an );
		}
		console.log( 'scene', scene, ccateg );
		return scene;
	}

	function toCoco( a )
	{
		console.log( 'converting to COCO fromat' )
		var ccategs = {};
		width = a.imageWidth;
		height = a.imageHeight;
		area = width*height;

		var cocos = {
			"info": {
				"description": "",
				"year": "",
				"date_created": "",
				"contributor": "",
				"version": "",
				"url": ""
			},
			"licenses": [{
				"name": "",
				"url": "",
				"id": 0
			}],
			"images": [{
				"file_name": a.url,
				"width": width,
				"height": height,
				"license": 0,
				"date_captured": 0,
				"coco_url": "",
				"id": 1
			}],
			"categories": [],
			"annotations": [],
		}
		if (a.image_attrs) {
			cocos.images[0].attributes = a.image_attrs
		}
		// cocos.images[0].file_name = a.url.replace(/^.*\//, ''); 
		if (trackData.descriptor.object_labels) trackData.descriptor.object_labels.forEach((c,idx) => {
			var ccat = {
				"id": idx+1,
				"name": c.label,
				"supercategory": "",
			};
			if( c.attrs && c.attrs.length )
			{
				ccat.attributes = c.attrs;
			}
			ccat.type = c.type;
			if( c.ccolor) ccat.color = c.ccolor;
			ccategs[ccat.name] = ccat.id;
			cocos.categories.push( ccat );
		});

		a.boxes.forEach( (b,idx) => {
			var can = {
				"segmentation": null,
				"iscrowd": 0,
				"category_id": ccategs[b.label],
				"bbox": [b.x1,b.y1,b.x2,b.y2],
				"area": b.area*area,
				"image_id": 1,
				"id": idx,
			}
			if( b.type == "polygon" )
			{
				can.segmentation = denorm(clone(b.shape));
				console.log( 'PRE', clone(can.segmentation) )
				for (let i = 0; i < can.segmentation.length; i++) {
					can.segmentation[i] = mergeHoles(can.segmentation[i]);
				}
				console.log( 'POS', can.segmentation )
				console.log( 'SPLIT', splitHoles( can.segmentation ) );
			}
			else
				can.segmentation = [ b.x1, b.y1, b.x2, b.y1, b.x2, b.y2, b.x1, b.y2 ];
			if( b.attrs ) can.attributes = b.attrs;
			cocos.annotations.push( can );
		})

		if( a.review_status || a.review_comments )
		{
			cocos.review = {};
			if( a.review_status ) cocos.review.status = a.review_status;
			if( a.review_comments ) cocos.review.comments = a.review_comments;
		}

		return cocos;
	}

	this.toScene = toScene;
	this.toCoco = toCoco;
}



/*
 * BBox Object
 * Date: Aug 28, 2019
 *
 * this object will receive a preview image, and will let the user draw tagsd polylines over it.
 * the control points will be saved and will be passed on as a callback function.
 * Optionaly the user can retrieve the control points by calling the method 'getPoints'
 *
 * Configurarion:
 * imageObj: preview image
 * dotColor: color of the control points
 * dotSelectedColor: color of the selected control point
 * pathColor: color of the path tagsd
 * onchange: callback function that will receive the current jsonCode
 * zoom: current zoom
 * x: starting x offset
 * y: starting y offset
 * Methods:
 * config(cfg): change configuration
 * reset: reset the points
 * getPoints: return the control points array
 *
 * Interface:
 * The user may click over the image to add boxes. As controlpoints are added a tagsd polyline is drawn.
 * The user may move any control point.
 * They may also delete a selected controlpoint by pressing 'del'
 * To insert a controlpoing between 2 other ones, just press 'ctrl' while clicking.
 */
var image_attrs = null;

var selected = null;
function BBox(initConfig)
{
	var draw = null;
	var svg = null;
	var path = null;
	var mode = 0;
	var rotationHandle = null;
    var rotationStartAngle = 0;
    var centerPoint = {x: 0, y: 0};
	oselected = selected; 
	selected = null;
	var over = null;
	var cfg = {capture:false,dotColor:'red',dotSelectedColor:'blue',pathColor:'green',zoom:window.zoom,offx:window.offx,offy:window.offy};
	var origWidth = 0;
	var origHeight = 0;
	var origAspect = 0;
	var boxWidth = 0;
	var boxHeight = 0;
	var fileName = '';
	var jsonCode = null;
	var changed = false;
	var scale = 1;
	var aspect = 1;
	var boxes = [];
	var boxesHidden = null;
	var pathColor = {};
	var pathLinkto = {};
	var pathObj = {};
	var allTypes = {};
	var compSize = 1;

	window.getBoxes = function(){ return boxes };
	window.drawBoxes = drawBoxes;
	window.setSelected = setSelected;
	window.getSelected = function(){ return selected };
	window.setOver = setOver;
	window.setVisible = setVisible;
	window.setLocked = setLocked;

	function drawRotationHandle(box) {
		if (box.id !== selected) return;
		// Calculate center point
		centerPoint.x = box.x + box.w/2;
		centerPoint.y = box.y + box.h/2;
		// Draw rotation handle above the box
		var handleSize = 8;
		var handleY = box.y - handleSize - 5;
		rotationHandle = $('<div>')
		  .addClass('rotation-handle')
		  .css({
			position: 'absolute',
			left: px((box.x + box.w/2) * boxWidth - handleSize/2),
			top: px(handleY * boxHeight),
			width: px(handleSize),
			height: px(handleSize),
			cursor: 'url(rotate.png) 12 12, auto',
			background: '#fff',
			border: '2px solid #00f',
			borderRadius: '50%',
			zIndex: 100
		  });
		draw.append(rotationHandle);
	  }
	  function startRotation(ev) {
		if (!selected) return;
		mode = 5; // Rotation mode
		var box = boxes[selectedIdx()];
		// Calculate initial angle between mouse and center
		var mouseX = eventX(ev) * boxWidth;
		var mouseY = eventY(ev) * boxHeight;
		var centerX = (box.x + box.w/2) * boxWidth;
		var centerY = (box.y + box.h/2) * boxHeight;
		rotationStartAngle = Math.atan2(mouseY - centerY, mouseX - centerX) - 
							(box.rotation || 0);
		mouseMoveStart();
	  }
	  function rotateBox(ev) {
		if (mode !== 5) return;
		var box = boxes[selectedIdx()];
		var mouseX = eventX(ev) * boxWidth;
		var mouseY = eventY(ev) * boxHeight;
		var centerX = (box.x + box.w/2) * boxWidth;
		var centerY = (box.y + box.h/2) * boxHeight;
		// Calculate new angle
		var angle = Math.atan2(mouseY - centerY, mouseX - centerX);
		box.rotation = angle - rotationStartAngle;
		changed = true;
		drawBoxes();
	  }

	window.bboxCheck = function() {
		var missing = checkBoxUncomplete();
		if (missing ) {
			myAlert('Submit Error', 'There are anotations with uncomplete data. Please check and complete');
			selected = missing;
			drawBoxes();
			if (!checkForceLabel()) boxDetails(selected);
			return false;
		}
		if (image_attrs )
			for (let a in image_attrs) {
				if (image_attrs[a] === null) {
					myAlert('Submit Error', "Please assign the required attributes for the image.")
					return false;
				}
			}
		return true;
	}

	// init the object. Get the preview image parameters and add a draw canvas over it
	function init()
	{
		
        $('#maincolumn').show();

		$('#zoomin').off('mousedown').on('mousedown', function(){ setPosImg( window.lastPageX, window.lastPageY ); tboxPress('zoomin'); zoomIn();} );
		$('#zoomout').off('mousedown').on('mousedown', function(){ setPosImg( window.lastPageX, window.lastPageY ); tboxPress('zoomout'); zoomOut();} );
		$('#panmode').off('mousedown').on('mousedown', function(){ panMode(window.panMode?0:1)} );
		$('#boxmode').off('mousedown').on('mousedown', setAdd );
		$('#brushmode').off('mousedown').on('mousedown', setAdd );
		$('#polymode').off('mousedown').on('mousedown', setAdd );
		$('#opacitymode').off('mousedown').on('mousedown', setOpacity );
		$('#brightmode').off('mousedown').on('mousedown', setBrightness );
		$('#erasemode').off('mousedown').on('mousedown', setEraseMode );
		$('#allsubs').off('mousedown').on('mousedown', function(){ allSubsMode(window.allSubsMode?0:1)} );
		$('#btndelete').off('mousedown').on('mousedown', function(){
			tboxPress('delete');
			if( selected )
			{
				delBox(selected);
				changed = true;
				drawBoxes();
			}
		} );
		$('#btnundo').off('mousedown').on('mousedown', function(){ tboxPress('undo'); undo(); } );
		$('#btnredo').off('mousedown').on('mousedown', function(){ tboxPress('redo'); redo(); } );
// 		console.log( 'init', initConfig );
// Add rotation mode button handler here
$('#enableRotation').off('mousedown').on('mousedown', function() {
    window.rotationMode = !window.rotationMode;
    $(this).toggleClass('toolbox-press', window.rotationMode);
    drawBoxes(); 
});
window.rotationMode = false;
    $('#enableRotation').removeClass('toolbox-press');
		var zoom = cfg.zoom;
		// console.log( 'ZOOM', zoom )
		loadConfig(initConfig);
		boxWidth = cfg.imageObj.width();
		boxHeight = cfg.imageObj.height();
		cfg.imageObj.css({position:'relative',left:px(cfg.offx),top:px(cfg.offy)});

		fileName = cfg.imageObj.prop('fileName');
		if( !fileName )
		{
			fileName = cfg.imageObj.prop('src');
			// fileName = fileName.replace(/.*\//,'');
			// fileName = fileName.replace(/.*\\/,'');
		}

		// var im = $(new Image);
		// im.prop('src',cfg.imageObj.prop('src'));
		// im.on('load',function()
		initImg();

		function initImg()
		{
			if( !window.oWidth ) return;
			console.log('trackData.fdesc------->',trackData.fdesc);
			
			trackData.fdesc.forEach(function(t){
				allTypes[t.type] = 1;
				pathColor[t.spath] = t.color;
				pathLinkto[t.spath] = t.linkto;
				pathObj[t.spath] = t;
			});
			origWidth = window.oWidth;
			origHeight = window.oHeight;
			origAspect = aspect = origHeight/origWidth;
			compSize = origWidth/2200;

			var rw = 300;
			var lw = 80;
			var mw = $('main').width()-rw-lw;
			// baseWidth = $('.imgdisplay').width();
			baseWidth = mw;
			baseHeight = baseWidth*aspect;
			// var hrest = $('#toolbox').outerHeight()+30;
			var hrest = 0;
			var eh = $('main').position().top;
			if( scriptMode == "adl" ) eh += 30;
			var maxH = $(window).height()-hrest-eh;
			// console.log( 'MAXH', maxH )
			if( baseHeight > maxH )
			{
				baseWidth *= maxH/baseHeight;
				baseHeight *= maxH/baseHeight;
			}

			var imageoverlay = $('#imageoverlay');
			// if( !baseWidth && window.oWidth )
			// {
			// 	baseWidth = cfg.imageObj.width();
			// 	baseHeight = cfg.imageObj.height();
			// }
			// var imageoverlay = cfg.imageObj.parent();
			imageoverlay.css({background:'#333333',width: baseWidth, height:baseHeight})
			boxWidth = baseWidth*zoom;
			boxHeight = baseHeight*zoom;
			var h = $(window).height();
			$('.middlecol').css({width:mw,height:h, top:0, left: lw})
			$('.rightcol').css({width:rw,height:maxH, top:0, left:lw+mw})
			$('.leftcol').css({width:lw,height:h,top:0, left:0})
			$('.leftcol').off('scroll').on('scroll', function(){
				setBrushSize();
				setOpacity(window.opacityMode)
				setBrightness(window.brightMode)
			});
			$(document.body).css({overflow:'hidden'})
			// origWidth = this.width;
			// origHeight = this.height;

			$(cfg.imageObj).css({width:px(boxWidth),height:px(boxHeight)});
			var drawid = 'draw'+cfg.imageObj.prop('id');
			var svgid = 'svg'+cfg.imageObj.prop('id');
			if( !$('#'+drawid).length )
			{
				draw = $('<div>').prop('id',drawid).show();
				svg = $('<svg viewBox="0 0 '+ origWidth + ' '+ origHeight + '">').prop('id',svgid).addClass('svgarea').attr('width',origWidth).attr('height',origHeight).show();
				$(cfg.imageObj[0].parentNode).append(draw,svg);
			}
			else
			{
				draw = $('#'+drawid);
				svg = $('#'+svgid);
			}
			// console.log( 'svg', svgid )
			// console.log( 'draw', draw );
			draw.css({ width:boxWidth, height:boxHeight, position:'absolute', left:px(cfg.offx),top:px(cfg.offy) });
			svg.css({ width:boxWidth, height:boxHeight, position:'absolute', left:px(cfg.offx),top:px(cfg.offy) });
			draw.html('');
			draw.off('mousedown').on('mousedown',mouseDownEvent);
			draw.off('mouseover').on('mouseover',mouseOverEvent);
			draw.off('mouseout').on('mouseout',mouseOutEvent);
			$(document.body).off('keydown').on('keydown',keyDownEvent);
			$(document.body).off('keyup').on('keyup',keyUpEvent);

			$('.imgdisplay').off('mousewheel').bind('mousewheel', function(ev){
				if( window.zooming ) return;
				if(ev.originalEvent.wheelDelta /120 > 0)
				{
					var px = eventX(ev);
					var py = eventY(ev);
					var pageX = ev.pageX;
					var pageY = ev.pageY;
					// console.log('scrolling up !', px, py );
					window.posLoadImg = {act:'posImg', px: px, py:py, pageX:pageX, pageY:pageY};
					zoomIn(1);
				}
				else
				{
					var px = eventX(ev);
					var py = eventY(ev);
					var pageX = ev.pageX;
					var pageY = ev.pageY;
					// console.log('scrolling down !', px, py );
					window.posLoadImg = {act:'posImg', px: px, py:py, pageX:pageX, pageY:pageY};
					zoomOut(1);
				}
				return false;
			});


			scale = boxWidth/origWidth;
			// console.log( 'scale', scale );
			reset();
			if( cfg.boxes )
			{
				var cboxes = tree2List( cfg.boxes );
				// cboxes = cfg.boxes;
				boxes = [];
				cboxes.forEach( function(b){
					if( !b ) return;

					if( !defined(b.x2))
					{
						b.x2 = b.x1;
						b.y2 = b.y1;
					}
					// Convert rotation from degrees to radians for internal use

					let rotationRadians = 0;

					if (typeof b.rotation !== 'undefined' && b.rotation !== null) {

						rotationRadians = (b.rotation * Math.PI / 180);

					}
					var nb = {
						x:b.x1/origWidth,
						y:b.y1/origHeight,
						w:(b.x2-b.x1)/origWidth,
						h:(b.y2-b.y1)/origHeight,
						label: b.label,
						oid: b.id,
						id: tmpId(b.id),
						parent: b.parent ? tmpId(b.parent) : null,
						outside_image: b.outside_image || {},
						occluded: b.occluded || {},
						invisible:b.invisible || false,
						locked:b.locked || false,
						colorize: 'colorize' in b ? b.colorize : ckColorize(b),
						sparent: '',
						spath:b.spath,
						shape: b.shape,
						attrs:b.attrs,
						title:b.title,
						type: b.type ? b.type : 'box',
						rotation: rotationRadians,
					};
					if( !b.oid ) b.oid = b.id;
					if( nb.type == 'polygon' && !nb.area )
					{
						nb.area = polyArea( nb.shape ).area;
						// console.log( 'calc area', nb.id, nb.label, nb.area, nb.x, nb.y )
					}
					// console.log( 'oid', b.oid, b.id )
					boxes.push(nb);
				});
				delete cfg.boxes;
				// console.log( 'cvf.selected', cfg.selected )
				if( cfg.selected )
				{
					selected = tmpId(cfg.selected);
					clearTimeout( window.showFrameSelectTid );
					showFrameSelectTid = setTimeout( function(){
						boxDetails( selected );
					}, 200 )
				}
				// if( oselected ) selected = oselected;
				drawBoxes();
				checkTagPos();
				saveStack();
				clearTimeout( window.drawUpdateTid );
				window.drawUpdate = true;
				window.drawUpdateTid = setTimeout( function(){
					window.drawUpdate = false;
					if( window.pendingOver ) window.pendingOver();
					window.pendingOver = null;
				}, 500 )
			}
			// console.log( 'CLONE', cfg )
			if( !image_attrs ) {
				image_attrs = clone(cfg.image_attrs||{});
			} 
			review_mode = cfg.review_mode;
			if( !review_mode ) $('#review').hide();
			setTimeout( function(){
				imageAttrs();
				panMode( window.panMode );
			}, 500 );
			if( window.zooming )
			{
				stack = window.stackSave.stack;
				stackPos = window.stackSave.stackPos;
			}
			window.zooming = false;
			if( window.posLoadImg )
			{
				var pi = window.posLoadImg;
				if( pi.act = 'posImg' )
				posImg( pi.px, pi.py, pi.pageX, pi.pageY );
				else
				reframeImage();
				window.posLoadImg = null;
			}
		}
		if( !window.brushSize ) window.brushSize = 70;
		if( !Object.keys(allTypes).length ) return;
		// setAdd.apply( $('#brushmode'))
		// var defMode = window.addMode || 'brushmode';
		var defMode = window.addMode || 'polymode';
		if( !window.opacityMode )
		{
			window.opacityMode = 0;
			window.opacityVal = 50;
		}
		if( !window.brightMode )
		{
			window.brightMode = 0;
			window.brightVal = 50;
		}
		if( !allTypes.polygon )
		{
			defMode = 'boxmode';
			$('.segmentation-mode').hide();
		}
		if( !allTypes.box )
		{
			$('.box-mode').hide();
		}
		if( window.polyDraw ) polyDraw();
		setBrushSize();
		if( !window.addMode ) window.addMode = defMode;
		setAdd.apply( $('#'+defMode) )
		window.vertexSelected = window.vertexMove = null;
	// );
	}

	var stack = [];
	var stackPos = 0;
	function saveStack()
	{
		stack.splice( stackPos, 1000 );
		stack[stackPos++] = { selected: selected, boxes: clone(boxes), polyDraw: clone(window.polyDraw || null) };
		// console.log( 'saveStack', stack, stackPos, selected, 'boxes', boxes );
	}

	function getStack(){ return stack; }
	window.getStack = getStack;

	function undo()
	{
		if( stackPos > 2 )
		{
			stackPos--;
			selected = stack[stackPos-1].selected;
			console.log('stack->',stack);
			console.log("Pos",stackPos);

			console.log('before-boxes',boxes);

			boxes = stack[stackPos-1].boxes;
			console.log('trackdata',trackData);
			

			console.log('after-boxes->',boxes);
			console.log('trackdata',trackData);

			window.polyDraw = clone(stack[stackPos-1].polyDraw);
			console.log( 'undo', stackPos, stack.length, selected, 'boxes', boxes );
			drawBoxes();
			boxList(boxes)
			if( window.polyDraw ) polyDraw();
			hideDetails();
			hideChooseLabel();
			if( selected && !checkForceLabel() ) boxDetails( selected );
		}
	}

	function redo()
	{
		if( stackPos < stack.length )
		{
			selected = stack[stackPos].selected;
			boxes = stack[stackPos].boxes;
			window.polyDraw = clone(stack[stackPos].polyDraw);
			stackPos += 1;
			console.log( 'redo', stackPos, stack.length, selected, 'boxes', boxes );
			drawBoxes();
			if( window.polyDraw ) polyDraw();
			hideDetails();
			boxList(boxes);
			if( selected && !checkForceLabel() ) boxDetails( selected );
		}
	}


	function findIdx( id )
	{
		try {
			for( var i = 0 ; i < boxes.length ; i++ )
			{
				if( boxes[i].id == id ) return i;
			}
			// console.error( 'selectedIdx: id not found', id );
			return -1;
		} catch (e) {
			return -1;
		}
	}

	function selectedIdx()
	{
		if( !selected )
		{
			console.error( 'selectedIdx: no selection');
			console.trace();
			return 0;
		}
		return findIdx( selected );
	}

	// reset variables
	function reset()
	{
		draw.html('');
		boxes = [];
		path = null;
		drawBoxes();
// 		alert( 'reset' );
	}

	// draw the tags polyline based on the current control points
	var drawTid = null;
	var lockOffsets = [];

	function getOffsets(basePoint)
	{
		lockOffsets = [];
		for( var i = 0 ; i < boxes.length ; i++ )
		{
			var dp = {x:(boxes[i].x-basePoint.x),y:(boxes[i].y-basePoint.y)}
			lockOffsets.push(dp);
		}
		// console.log( 'getOffsets', selected, lockOffsets );
		return lockOffsets;
	}

	function drawLine( x1, y1, x2, y2, color )
	{
		var dx = (x2-x1)*boxWidth;
		var dy = (y2-y1)*boxHeight;
		var d = Math.sqrt(dx*dx+dy*dy);
		var angle = -Math.atan2( dx, dy )*180/Math.PI;
		// angle = -45;
		var css = {
			position: 'absolute',
			left: x1*boxWidth,
			top: y1*boxHeight,
			width: 0.5,
			height: d,
			background: color,
			zIndex: 0,
			pointerEvents: 'none',
			// border: '0.5px solid '+color,
			transform: 'rotate('+angle+'deg)',
			transformOrigin: 'top left',
		};
		var line = $('<DIV>').css(css);
		draw.append( line );
		// console.log( 'draw', draw, 'line', line[0], css)
	}


	function checkTagPos()
	{
		boxes.forEach( b => {

		})
	}

	this.checkTagPos = checkTagPos;

	function opacity( v )
	{
		var ov = v;
		if( window.opacityVal > 50 )
		{
			v += (1-v)*((window.opacityVal-50)/50)
		}
		else
		{
			v *= (window.opacityVal)/50;
		}
		return Math.round(v*255).toString(16).padStart(2,'0');
	}
	window.opacity = opacity;

	var lastOver = null;
	function drawBoxes()
	{
		if( $('#box-details').length && !selected ) hideDetails();
		var linkto = {};
		// var choosing = $('.choose-visible').length > 0;
		function addLink( from, to )
		{
			if( to )
			{
				var key = to+from.parent;
				if( !linkto[key] ) linkto[key] = {from:[]};
				linkto[key].from.push(from);
			}
			var key = from.label+from.parent;
			if( !linkto[key] ) linkto[key] = {to:from,from:[]};
			else linkto[key].to = from;
		}
		sortBoxes();
		window.xxxbox = boxes;
		if( !draw ) return;
		// $('#box-details').remove();
		// $('#choose-label').remove();
		// hideChooseLabel();
		// if( mode != 0 ) hideDetails();
		labObj = null;
		var forceLabel = -1;
		draw.html('');
		svg.html('');

		var bselParent = null;
		var bsel = null;
		var visible = {};
		var ignore = {};
		var locked = {};
		var bsel = null;
		var target = null;
		var targetIdx = -1;
		boxes.forEach( b => {
			if( !b ) return;
			ignore[b.id] = b.invisible == true
			locked[b.id] = b.locked == true;
		});
		if( selected || over )
		{
			target = selected ? selected : over;
			targetIdx = findIdx( target );
			ignore[target] = false;
			locked[target] = false;
		}
		boxes.forEach( b => {
			if( !b ) return;
			if( b.parent ){
				ignore[b.id] = ignore[b.parent];
				locked[b.id] = locked[b.parent];
			}
		});
		if( targetIdx >= 0 )
		{
			// console.log( 'targetIdx', targetIdx );
			bsel = boxes[targetIdx];
			// console.log( 'BSEL', bsel.spath );
			if( bsel.parent ) bselParent = boxes[findIdx(bsel.parent)];
			var btmp = bsel;
			visible[target] = 1;
			while( btmp.parent )
			{
				visible[btmp.parent] = 1;
				btmp = boxes[findIdx(btmp.parent)];
			}
			// console.log( 'visible----------->', visible[target], 'selected', selected  )
		}
		if( window.allSubsMode )
		{
			
				boxes.forEach( function(b){
					if( !b ) return;					
					visible[b.id] = 1;
				});
		}
		boxes.forEach( function(b,idx){
			if( !b ) return;
			if( window.tabPressed && b.hidden ) return;
			if( ignore[b.id] ) return;
			b.hidden = false;
			var invisible = !visible[b.id];
			if( b.parent == null ) invisible = false;
			if( bsel && b.parent == bsel.id )
			{
				invisible = false;
				visible[b.id] = 1;
			}
			// draw a bounding box
			// alert( boxWidth );

			var x = b.x*boxWidth;
			var y = b.y*boxHeight;
			var w = b.w*boxWidth;
			var h = b.h*boxHeight;
			var ww = w;
			var hh = h;
			if( w < 0 )
			{
				w = -w;
				x -= w;
			}
			if( h < 0 )
			{
				h = -h;
				y -= h;
			}
			b.pos = {x:x,y:y,w:w,h:h};

			var baseClass = b.type == 'keypoint' ? 'kpoint' : 'bbox';
			var color;
			if( b.type == 'polygon' )
			{
				var color = pathColor[b.label] || '#aa0000';
				var dclick = window.doubleClick;
				// console.log( 'pathColor', b,  color)
				var transp = opacity( 0.2 );
				var vertex = 0;
				var stroke = 0;
				if( b.id == target || b.locked )
				{
					transp = opacity( 0.4 );
					stroke = 1/window.zoom;
				}
				if( selected == b.id )
				{
					stroke = 2/window.zoom;
					transp = opacity( 0.5 );
				}
				if( b.id == selected && dclick )
				{
					transp = opacity( 0.4 );
					vertex = 1;
					stroke = 5/window.zoom;
				}
				var fill = color + transp;
				if( b.locked ) fill = '';
				// console.log('drawPolygon', b.id, polyToScreen(b.shape), stroke, color );
				b.drawParams = {stroke:stroke, color:color, fill:fill, vertex: vertex};
				drawPolygon( b.id, polyToScreen(b.shape), stroke, color, fill, vertex);
				if( b.id == selected && dclick )
					setVertexEvents( b.id );

			}
			else {
				if( b.type == 'keypoint' )
				{
					w = h = 12;
				}
				if( lineMode )
				{
					var box = $('<SVG>').prop('id', 'bbox_'+b.id)
					.prop('btype',b.type)
					.prop('box', true)
					.prop('bid',b.id)
					.addClass(baseClass)
					.css({zIndex:10,top:px(y),left:px(x),width:px(w),height:px(h)});
				}
				else {
					var box = $('<DIV>').prop('id', 'bbox_'+b.id)
					.prop('btype',b.type)
					.prop('box', true)
					.prop('bid',b.id)
					.addClass(baseClass)
					.css({zIndex:10,top:px(y),left:px(x),width:px(w),height:px(h)});
				}
				if( visible[b.id] )
				{
					
					if( b.type == 'keypoint' )
					{
						addLink( b );
						//dhinesh
						// if( pathLinkto[b.spath] ) addLink( b, pathLinkto[b.spath] );
						if(pathLinkto[b.spath]){
							if( pathLinkto[b.spath] ) addLink( b, pathLinkto[b.spath] );
						}
						else{
							let match = Object.keys(pathLinkto).find(key => key.split('|')[1] === b.spath);
							if( pathLinkto[match] ) addLink( b, pathLinkto[match] );
						}
						
					}
					box.addClass(baseClass+'sel');
						//dhinesh
					    // var bcolor = b.colorize || pathColor[b.spath];
						if(pathColor[b.spath]){
							var bcolor = b.colorize || pathColor[b.spath];
						}
						else{
							let match = Object.keys(pathLinkto).find(key => key.split('|')[1] === b.spath);
							var bcolor = b.colorize || pathColor[match];
						}	

					if( bcolor )
					{
						if( b.type == 'keypoint' )
						box.css({background:bcolor});
						else
						box.css({borderColor:bcolor});
					}
				}
				if( b.id == target ) box.addClass(baseClass+'target');


				if( b.id == selected && mode == 0 )
				{
					// var handleSize = 8;
				// 	var rotHandle = $('<DIV>')
                //     .addClass('rotation-handle')
                //     .prop('rothandle', true) 
                //     .prop('bid', b.id)
                //     .css({
                //        position: 'absolute',
                //        left: px(w/2 - handleSize/2),
                //        top: px(-handleSize - 5), 
                //        width: px(handleSize),
                //        height: px(handleSize),
                //        cursor: 'e-resize',
                //        background: '#fff',
                //        border: '2px solid #00f',
                //        borderRadius: '50%',
                //        zIndex: 100
                //      });

                //    box.append(rotHandle);
				if (b.type !== 'keypoint' && window.rotationMode) { 
					var handleSize = 8;
					var rotHandle = $('<DIV>')
						.addClass('rotation-handle')
						.prop('rothandle', true) 
						.prop('bid', b.id)
						.css({
							position: 'absolute',
							left: px(w/2 - handleSize/2),
							top: px(-handleSize - 5), 
							width: px(handleSize),
							height: px(handleSize),
							cursor: 'e-resize',
							background: '#fff',
							border: '2px solid #00f',
							borderRadius: '50%',
							zIndex: 100
						});
					box.append(rotHandle);
				}
					let m = 4;
					// var blab = $('<DIV>').attr('contenteditable',b.id==selected).prop('label',true).prop('bid',b.id).addClass('blabel').css({zIndex:1,top:px(h),left:px(0),wwidth:px(w)}).html(b.label);
					var cb0 = $('<DIV>').prop('corner',true).prop('bid',b.id).prop('cid',0).addClass('bboxctrl').css({background:color,zIndex:10,top:px(0),left:px(0)})
					var cb1 = $('<DIV>').prop('corner',true).prop('bid',b.id).prop('cid',1).addClass('bboxctrl').css({zIndex:10,top:px(0),left:px(w-m)})
					var cb2 = $('<DIV>').prop('corner',true).prop('bid',b.id).prop('cid',2).addClass('bboxctrl').css({zIndex:10,top:px(h-m),left:px(w-m)})
					var cb3 = $('<DIV>').prop('corner',true).prop('bid',b.id).prop('cid',3).addClass('bboxctrl').css({zIndex:10,top:px(h-m),left:px(0)})
					box.append( cb0, cb1, cb2, cb3 );
				}
				if (b.type !== 'keypoint' && b.rotation) { // Remove window.rotationMode check
					box.css({
						transform: `rotate(${b.rotation}rad)`,
						transformOrigin: `${w/2}px ${h/2}px`
					});
				}
				if( b.type == 'keypoint' && b.attrs && bool(b.attrs.occluded) )
				box.addClass('kpointoccluded');
				// if( invisible ) box.css({opacity:0});
				if( invisible ) return;
				if( locked[b.id] ) box.addClass( 'nopointer' );
				draw.append( box );
			}
		});
		for( var k in linkto )
		{
			var lt = linkto[k]
			if( lt.to && lt.from.length > 0 )
			{
				// console.log( 'LINKTO', lt.to, lt.from )
				lt.from.forEach( from => {
					var color = from.colorize || pathColor[from.spath] || '#ffff00';
					// var color = pathColor[from.spath] || '#ffff00';
					// color = 'red';
					drawLine( from.x, from.y, lt.to.x, lt.to.y, color )
				})
			}
		}

		if( changed )
		{
			saveData();
			updateBoxList();
		}
	}

	function allSubsMode( v )
	{
		$('#allsubs').removeClass('toolbox-selected');
		if( v ) $('#allsubs').addClass('toolbox-selected');
		window.allSubsMode = v;
		console.log( "allSubsMode--->",window.allSubsMode )
		drawBoxes();
	}


	function setAdd(ev)
	{
		var mode = $(this).prop('id');
		// console.log( this,  mode )
		$('.toolbox-press').removeClass('toolbox-press');
		window.pandMode = 0;
		window.addMode = mode;
		console.log( 'setAdd----->', window.addMode )
		$('#'+window.addMode).addClass('toolbox-press');
		
		$('#'+window.addMode).on('click', function() {
			if (window.addMode === "brushmode" && $('#sliderbrushpanel').length) {
				$('#sliderbrushpanel').toggle();
			}
		});
		setBrushSize();
		setOpacity(window.opacityMode);
		setBrightness(window.brightMode)
		if( window.addMode.match(/(brushmode|polymode)/) ){
			if( ev ) polyDrawReset();
			mouseMoveStart();
		}
		else mouseMoveEnd();
	}

	function setOpacity(m)
	{
		if( typeof(m) != 'number' ) window.opacityMode = window.opacityMode ? 0 : 1;
		if( !window.opacityMode )
		{
			$('#slideropacitypanel').hide();
			$('#opacitymode').removeClass('toolbox-press');
			return;
		}
		$('#opacitymode').addClass('toolbox-press');
		var sliderPan = $('#slideropacitypanel');
		if( !sliderPan.length )
		{
			var sliderPan = $('<DIV>').prop('id','slideropacitypanel').addClass('brushslider');
			sliderPan.html('- <div id="oslider"></div> +')
			$(document.body).append(sliderPan)
		}
		var bpos = $('#opacitymode')[0].getBoundingClientRect();
		var top = bpos.top+ bpos.height/2+$(window).scrollTop()-10;
		var left = bpos.left+bpos.width+3;
		// console.log( 'bpos', bpos, top, left )
		sliderPan.css({top: top, left: left })
		$('#slideropacitypanel').show();
		if( !window.brushSize ) window.brushSize = brushMinSize+(brushMaxSize-brushMinSize)/3;
		$('#oslider').slider({
			value:window.opacityVal,
			min: 0,
			max: 100,
			step: 1,
			slide: function( event, ui ) {
				window.opacityVal = ui.value;
				drawBoxes();
				// window.brushCursor = brushCircle();
				// console.log( ui.value );
			}
		});
	}

	function setBrightness(m)
	{
		// console.log( typeof(m) )
		if( typeof(m) != 'number' ) window.brightMode = window.brightMode ? 0 : 1;
		if( !window.brightMode )
		{
			$('#sliderbrightpanel').hide();
			$('#brightmode').removeClass('toolbox-press');
			return;
		}
		$('#brightmode').addClass('toolbox-press');
		var sliderPan = $('#sliderbrightpanel');
		if( !sliderPan.length )
		{
			var sliderPan = $('<DIV>').prop('id','sliderbrightpanel').addClass('brushslider');
			sliderPan.html('- <div id="btslider"></div> +')
			$(document.body).append(sliderPan)
		}
		var bpos = $('#brightmode')[0].getBoundingClientRect();
		var top = bpos.top+ bpos.height/2+$(window).scrollTop()-10;
		var left = bpos.left+bpos.width+3;
		// console.log( 'bpos', bpos, top, left )
		sliderPan.css({top: top, left: left })
		$('#sliderbrightpanel').show();
		if( !window.brushSize ) window.brushSize = brushMinSize+(brushMaxSize-brushMinSize)/3;
		$('#btslider').slider({
			value:window.brightVal,
			min: 0,
			max: 100,
			step: 1,
			slide: function( event, ui ) {
				window.brightVal = ui.value;
				$('#imgpreview').css({filter:'brightness('+window.brightVal/50+')'})
				// window.brushCursor = brushCircle();
				// console.log( ui.value );
			}
		});
	}


	function setBrushSize()
	{
		if( window.addMode != 'brushmode' )
		{
			$('#sliderbrushpanel').hide();
			return;
		}
		var sliderPan = $('#sliderbrushpanel');
		if( !sliderPan.length )
		{
			var sliderPan = $('<DIV>').prop('id','sliderbrushpanel').addClass('brushslider');
			sliderPan.html('<svg style="height: 30%" data-v-320ec513="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-circle fa-w-16"><path data-v-320ec513="" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg><div id="bslider"></div><svg data-v-320ec513="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-circle fa-w-16"><path data-v-320ec513="" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>')
			$(document.body).append(sliderPan)
		}
		var bpos = $('#brushmode')[0].getBoundingClientRect();
		var top = bpos.top+ bpos.height/2+$(window).scrollTop()-10;
		var left = bpos.left+bpos.width+3;
		// console.log( 'bpos', bpos, top, left )
		sliderPan.css({top: top, left: left })

		if (window.zoom){
			$('#sliderbrushpanel').hide();
		}
	
		var brushMinSize = 5;
		var brushMaxSize = 100;
		if( !window.brushSize ) window.brushSize = brushMinSize+(brushMaxSize-brushMinSize)/3;
		$('#bslider').slider({
			value:window.brushSize,
			min: brushMinSize,
			max: brushMaxSize,
			step: 1,
			slide: function( event, ui ) {
				window.brushSize = ui.value;
				window.brushCursor = brushCircle();
				// console.log( ui.value );
			}
		});
	}

	function setEraseMode( v )
	{
		$('#erasemode').removeClass('toolbox-selected')
		if( typeof(v) != 'number' ) v = window.eraseMode ? 0 : 1;
		window.eraseMode = v;
		if( v ) $('#erasemode').addClass('toolbox-selected')
	}

	function panMode( v )
	{
		// console.log( 'panMode', v )
		if( v && window.zoom == 1 )
		{
			v = 0;
		}
		$('.toolbox-press').removeClass('toolbox-press');
		if( v )
		{
			$('#sliderbrushpanel').hide();
			$('#slideropacitypanel').hide();
			$('#sliderbrightpanel').hide();
			$('#panmode').addClass('toolbox-press');
		}
		else {
			setAdd.apply($('#'+window.addMode)[0])
			// $('#'+window.addMode).addClass('toolbox-press');
		}
		if( v == 0 )
		{
			if( window.vertexMove )
			{
				window.vertexMove = null;
				changed = true;
				drawBoxes();
			}
			if( selected || over ) boxDetails( selected || over )
			checkForceLabel();
		}
		// console.log( 'PANMODE', v );
		window.panMode = v;
	}

	function tboxPress( label )
	{
		$('#'+label).addClass('toolbox-press');
		setTimeout( function(){
			$('#'+label).removeClass('toolbox-press');
		}, 200 );
	}

	function ckColorize( b )
	{
		if( !b.attrs ) return null;
		var colorize = trackData.descriptor.colorize_attributes;
		for( var a in b.attrs )
		{
			if( colorize[a] && colorize[a][b.attrs[a]] )
			{
				return colorize[a][b.attrs[a]];
			}
		}
		return null;
	}

	function setColorize( b )
	{
		b.colorize = ckColorize( b );
		drawBoxes()
		return null;
	}

	function saveData() {
		try {
			clearTimeout(drawTid);
			saveStack();
		} catch (err) {
			console.error("Error clearing timeout or saving stack:", err);
			return; // Exit the function if critical setup fails
		}
	
		function val(x) {
			return parseFloat(x.toFixed(4));
		}
	
		drawTid = setTimeout(() => {
			try {
				jsonCode = {};
				jsonCode.url = fileName;
				jsonCode.imageWidth = origWidth;
				jsonCode.imageHeight = origHeight;
				jsonCode.selected = simplifyId(selected);
	
				jsonCode.boxes = [];
				for (var i = 0; i < boxes.length; i++) {
					try {
						var bi = boxes[i];
						// Convert rotation from radians to degrees and normalize to 0-360
						let rotationDegrees = 0;
                        if (typeof bi.rotation !== 'undefined' && bi.rotation !== null) {
                        rotationDegrees = Math.round((bi.rotation * 180 / Math.PI) % 360);
                        if (rotationDegrees < 0) rotationDegrees += 360;
                     }
						var bo = {
							x1: val(bi.x * origWidth),
							y1: val(bi.y * origHeight),
							x2: val((bi.x + bi.w) * origWidth),
							y2: val((bi.y + bi.h) * origHeight),
							id: simplifyId(bi.id),
							type: bi.type,
							oid: bi.oid,
							area: bi.area,
							parent: simplifyId(bi.parent),
							outside_image: bi.outside_image || {},
							occluded: bi.occluded || {},
							invisible: bi.invisible || false,
							locked: bi.locked || false,
							colorize: 'colorize' in bi ? bi.colorize : ckColorize(bi),
							spath: bi.spath,
							shape: bi.shape,
							attrs: bi.attrs,
							title: bi.title,
							label: bi.label,
							// rotation: bi.rotation,
							rotation: rotationDegrees,
						};
						jsonCode.boxes.push(bo);
					} catch (boxError) {
						console.error(`Error processing box at index ${i}:`, boxError);
					}
				}
	
				try {
					jsonCode.boxes = list2Tree(jsonCode.boxes);
					jsonCode.image_attrs = image_attrs;
					jsonCode.capture = cfg.capture ? true : false;
					if (cfg.onchange) cfg.onchange(jsonCode);
					updateAnnotations();
				} catch (innerErr) {
					console.error("Error processing JSON data or updating annotations:", innerErr);
				}
			} catch (err) {
				console.error("Error in saveData timeout function:", err);
			}
		}, 1);
	
		try {
			changed = false;
		} catch (err) {
			console.error("Error setting changed flag:", err);
		}
	}
	
	$('#reviewer_rate').off('change').on('change', saveData );
	$('#reviewer_notes').off('change').on('change', saveData );
	$('#annotator_notes').off('change').on('change', saveData );


	function selAll( div )
	{
		var sel, range;
		if (window.getSelection && document.createRange) {
			range = document.createRange();
			range.selectNodeContents(div);
			sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(range);
		} else if (document.body.createTextRange) {
			range = document.body.createTextRange();
			range.moveToElementText(div);
			range.select();
		}
	}

	function getAttrs( path )
	{
		for( var i = 0 ; i < trackData.fdesc.length ; i++ )
		{
			if( trackData.fdesc[i].spath == path )
				return clone(trackData.fdesc[i].attrs || []);
		}
		return [];
	}
	function getSubs( path )
	{
		var subs = [];
		for( var i = 0 ; i < trackData.fdesc.length ; i++ )
		{
			if( trackData.fdesc[i].sparent == path )
				subs.push( trackData.fdesc[i] );
		}
		return subs;
	}

	function hideDetails()
	{
		$('.box-detail-hover').remove();
		$('#box-details').remove();
	}

	function checkBoxUncomplete()
	{
		for( var i = 0 ; i < boxes.length ; i++ )
		{
			var b = boxes[i];
			if( !b.attrs ) b.attrs = {};
			rattribs = getAttrs(b.spath);
			for( var j = 0 ; j < rattribs.length ; j++ )
			{
				var a = rattribs[j]
				// console.log( 'checkattr', b, a )
				if( !a.optional && !b.attrs[a.label] )
				return b.id;
			}
			var subs = getSubs(b.spath);
			var children = {};
			var id = b.id;
			boxes.forEach( function(b){ if( b.parent == id ) children[b.spath] = 1});
			var missing = [];
			if( !b.outside_image ) b.outside_image = {};
			if( !b.occluded ) b.occluded = {};
			subs.forEach( function(s){ if( !s.optional && !children[s.spath] && !b.outside_image[s.label] && !b.occluded[s.label] ) missing.push(s)});
			if( missing.length ) return b.id;
		}
		return null;
	}

	function imageAttrs()
	{
		var div = $('#image_attrs');
		div.html('');
		var fdesc = trackData.fdesc;
		var iattrs = null;
		for( var i = 0 ; i < fdesc.length ; i++ )
		{
			if( fdesc[i].type == 'image' )
			{
				iattrs = fdesc[i].attrs;
				break;
			}
		}
		if( iattrs )
		{
			var choose = $('<DIV>').addClass('choose');
			choose.append($('<DIV>').addClass('choosetitle').addClass('chooselabel').html('Image Attributes'));
			choose.css({width:px(div.width())})
			div.append( choose );
			// console.log( 'image_attrs', image_attrs, 'iattrs', iattrs );

			iattrs.forEach( function(a){
				a.optional = bool(a.optional);
				if( !( a.label in image_attrs) && !a.optional ) image_attrs[a.label] = null;
				var label = a.label;
				if( !a.optional ) label = '*'+label;
				label += ':';
				var aline = $('<div>').addClass('detail-attr');
				if( image_attrs[a.label] === null ) aline.addClass('detail-required');
				var tb = $('<tabel>');
				aline.append(tb);
				var tr = $('<tr>');
				tb.append(tr);
				td = $('<tr>');
				td.append($('<tr>').addClass('attr-title').html(label));
				td2 = $('<td>');
				tr.append( td, td2 );
				if( !a.options ) a.options = ["no", "yes"];
				a.options.forEach(function(aopt,idx){
					var o = $('<span>').addClass('attr-opt').html(aopt);
					if( image_attrs[a.label] == aopt ) o.addClass('selected-opt');
					o.click(function(){
						if( blockEdit ) return taskLocked();
						if( review_mode ) return;

						if( image_attrs[a.label] == aopt ) delete image_attrs[a.label];
						else image_attrs[a.label] = aopt;
						imageAttrs();
						saveData();
					})
					td2.append( o )
				});
				choose.append(aline);
			});

			div.css({height:px(choose.height())});


		}
	}

	function popPos( target, width, height )
	{
	    var boxRect = $(target)[0].getBoundingClientRect();
		var mh = $(window).height();

	    var y = boxRect.y+$(window).scrollTop();
	    var x = boxRect.x+boxRect.width+10;
		// console.log( 'target', x, y, 'width', width, 'height', height )
	    // if( x+popupWidth > screen.availWidth )	x = boxRect.x-popupWidth;
	    if( x+popupWidth > $(window).width() ) x = boxRect.x-popupWidth;
	    if( x < 0 ) x = 0;
		if( y+height > mh ) y = mh-popupHeight;
		if( y < 0 ) y = 0;

	    return {top: y, left: x};
	}

	function changeSelectedLabel()
	{
		if( !selected ) return;
		var bSel = boxes[selectedIdx()];
		for( var b of boxes ) {
			if( b.parent == bSel.id ) {
				myAlert( '', "This box has sub elements. The box label can't be changed" );
				return;
			}
		}
		console.log( 'CHANGESELECTEDLABEL', bSel )
		bSel.label = bSel.attrs = '';
		changed = true;
		hideDetails();
		drawBoxes();
		checkForceLabel();
	}

	function boxDetailsHover( b )
	{
		$('.box-detail-hover').remove();
		var div = $('<DIV>').addClass('box-detail-hover');
		console.log('b.title->',b.title,'b.label',b.label);
		
		var txt = '<div>' + (b.title || b.label) + '</div>' + battr(b);
		div.html( txt );
		div.on('click',changeSelectedLabel)
		$(document.body).append(div);
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		var pos = draw[0].getBoundingClientRect();
		var top = (b.y)*boxHeight;
		var left = (b.x+b.w)*boxWidth;
		var divH = div.outerHeight();
		var divW = div.outerWidth();
		var winW = $('#imageoverlay').width();
		if( b.type == 'polygon' )
		{
			var spoly = polyToScreenBox(b.shape);
			var mr = polyMaxRight( spoly, top + divH )
			// console.log( 'spoly', spoly, mr, left )
			if( mr ) left = mr+12;
		}
		top += pos.top+scrollTop;
		left += pos.left+scrollLeft
		if( b.type != 'polygon' ) left += 20;
		// console.log( 'left', left, 'divW', divW, origWidth, boxWidth )
		// console.log( 'top', left, 'divW', divW, origWidth, boxWidth )
		div.css( {top: top, left:left})
		var dPos = div[0].getBoundingClientRect();
		var wPos = $('#imageoverlay')[0].getBoundingClientRect();
		if( dPos.top < wPos.top) top += wPos.top-dPos.top;
		if( dPos.left < wPos.left) left += wPos.left-dPos.left;
		if( dPos.left+divW > wPos.left+wPos.width) left -= (dPos.left+divW)-(wPos.left+wPos.width);
		if( dPos.top+divH > wPos.top+wPos.height) left -= (dPos.top+divH)-(wPos.top+wPos.width);
		div.css( {top: top, left:left})
		// console.log( 'boxDetailsHover', div.height()/origHeight );
	}

	function boxDetails( id )
	{
		if( window.doubleClick ) return;
		// $('#box-details').remove();
		if( window.moveMode ) return;
		var bsel = boxes[findIdx(id)];
		if( !bsel ) return;
		hideDetails();

		console.log( 'details---->', bsel );
		if( id != selected && bsel.label ) return boxDetailsHover( bsel );
		var div = $('#bbox_'+id);
		if( !div.length )
		{
			div = placeHolderDiv(bsel);
			if( div ) setTimeout( function(){ div.remove() }, 1 );
		}
		// delete bsel.attrs;
		if( !bsel.attrs ) bsel.attrs = {};
		rattribs = getAttrs(bsel.spath);
		// console.log( 'BOXDETAILS', div, id, bsel.spath, bsel.attrs );


		var choose = $('<DIV>').addClass('choose').addClass('attrs').css({width:popupWidth, hheight:popupHeight});
		if( !bsel.spath ) return;
		var tit = $('<DIV>').addClass('choosetitle').addClass('chooselabel').html(bsel.title || bsel.spath.replace(/\|/g,' / '));
		tit.on('click',changeSelectedLabel)

		choose.append(tit);
		var pos = offset($(div));
		var overlay = $('#imageoverlay');
		var overPos = offset(overlay);
		if( !pos || !overPos ) return;
		var ow = overlay.width();
		var oh = overlay.height();
		var x = pos.left;
		var y = pos.top;
		var w = $(div).width();
		var h = $(div).height();
		var labCt = 0;
		$(document.body).append(choose);
		choose.prop('id','box-details');
		// var xmargin = id == selected && bsel.type == 'box'? 10 : 6;
		// var chooseX = x+w+xmargin;
		// var chooseY = y-1;
		// if( (chooseY-overPos.top + popupHeight) > oh )
		// 	chooseY-= popupHeight - 20;
		// if( (chooseX-overPos.left + popupWidth ) > ow )
		// 	chooseX -= popupWidth + w + xmargin*2



		if( rattribs.length )
		{
			var attributes = $('<div>').addClass('detail-section').html('Attributes');
			choose.append(attributes);
		}

		rattribs.forEach( function(a){
			if( !( a.label in bsel.attrs) && !a.optional ) bsel.attrs[a.label] = null;
			var label = a.label;
			if( !a.optional ) label = '*'+label;
			label += ':';
			var aline = $('<div>').addClass('detail-attr');
			if( bsel.attrs[a.label] === null ) aline.addClass('detail-required');
			var tb = $('<TABLE>');
			aline.append(tb);
			var tr = $('<tr>');
			tb.append(tr);
			td = $('<td>');
			td.append($('<span>').addClass('attr-title').html(label));
			td2 = $('<td>');
			tr.append( td, td2 );
			if( !a.options ) a.options = ["no", "yes"];
			a.options.forEach(function(aopt,idx){
				var o = $('<span>').addClass('attr-opt').html(aopt);
				if( bsel.attrs[a.label] == aopt ) o.addClass('selected-opt');
				o.click(function(){
					if( review_mode ) return;
					if( bsel.attrs[a.label] == aopt ) delete bsel.attrs[a.label];
					else bsel.attrs[a.label] = aopt;
					setColorize(bsel);
					boxDetails(id);
					saveData();
				})
				td2.append( o )
			});
			choose.append(aline);
		});
		if( !bsel.outside_image ) bsel.outside_image = {}
		if( !bsel.occluded ) bsel.occluded = {}
		var subs = getSubs(bsel.spath);
		var children = {};
		boxes.forEach( function(b){ if( b.parent == id ) children[b.spath] = 1});
		var missing = [];
		subs.forEach( function(s){ if( !s.optional && !children[s.spath] && !bsel.outside_image[s.label] && !bsel.occluded[s.label] ) missing.push(s)});
		console.log( 'CHILDREN', children, 'subs', subs, 'missing', missing );

		if( !rattribs.length && !missing.length )
		{
			hideDetails();
			return boxDetailsHover( bsel );
		}
		if( missing.length )
		{
			var requiredChildren = $('<div>').addClass('detail-section').html('Missing Sub-objects');
			choose.append(requiredChildren);
			missing.forEach( function(m){
				var type = m.type;
				if( type == 'keypoint' ) type = 'KP';
				var miss = $('<DIV>').addClass('detail-missing').html('<span>'+m.label + ' (' + type + ')</span>');

				if( trackData.enableOutsideImage !== false ) {
					var o = $('<span>').addClass('attr-opt').css({marginLeft:px(10)}).html('outside');
					if( bsel.outside_image[m.label] ) o.addClass('selected-opt');
					o.click(function(){
						if( bsel.outside_image[m.label]  ) delete bsel.outside_image[m.label];
						else bsel.outside_image[m.label] = 1;
						boxDetails(id);
						saveData();
					})
					miss.append(o);
				}
				if( trackData.enableOccluded !== false ) {
					var o = $('<span>').addClass('attr-opt').css({marginLeft:px(10)}).html('occluded');
					if( bsel.occluded[m.label] ) o.addClass('selected-opt');
					o.click(function(){
						if( bsel.occluded[m.label]  ) delete bsel.occluded[m.label];
						else bsel.occluded[m.label] = 1;
						boxDetails(id);
						saveData();
					})
					miss.append(o);
				}



				choose.append(miss);
			});
		}
		var cpos = popPos( $('#bbox_'+id), popupWidth, choose.height() );
		var chooseX = cpos.left;
		var chooseY = cpos.top;
		choose.css({top:px(chooseY), left:px(chooseX)})
	}

	function hideChooseLabel()
	{
		$('#choose-label').remove();
	}

	function titleNum( label )
	{
		var max = 0;
		var titles = {}
		for( var b of boxes )
		{
			if( b.label == label )
			{
				if( b.title )
				{
					titles[b.title] = 1;
				}
			}
		}
		for( var i = 1 ; i < 1000 ; i++ )
		{
			// var tit = label + '_' + i;
			var tit = label;


			if( !titles[tit] ) return tit;
		}
		return label;
	}

	function chooseLabel(div) {
		try {
			hideChooseLabel();
			var choose = $('<DIV>').addClass('choose').addClass('choose-visible');
			var bid = $(div).prop('bid');
			selected = bid;
			bSel = boxes[selectedIdx()];
			var labelTaken = {};
	
			if (bSel.parent != null) {
				try {
					boxes.forEach(function (b) {
						if (b != bSel && b.parent == bSel.parent) {
							labelTaken[b.label] = 1;
						}
					});
				} catch (err) {
					console.error("Error iterating through boxes for labelTaken:", err);
				}
			}
	
			var sparent = bSel.sparent;
	
			choose.append($('<DIV>').addClass('choosetitle').addClass('chooselabel').html('Choose Label'));
			choose.css({ width: px(popupWidth), hheight: px(popupHeight) });
			
			var pos, overPos;
			try {
				pos = offset($(div));
				var overlay = $('#imageoverlay');
				overPos = offset(overlay);
				if (!pos || !overPos) return;
			} catch (err) {
				console.error("Error getting positions for choose label:", err);
				return;
			}
	
			var ow = overlay.width();
			var oh = overlay.height();
			var x = pos.left;
			var y = pos.top;
			var w = $(div).width();
			var h = $(div).height();
			var labCt = 0;
	
			$(document.body).append(choose);
			choose.prop('id', 'choose-label');
	
			var keys = '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
			hotKeys = {};
	
			try {
				trackData.fdesc.forEach(function (l) {
					if (window.GlobalVars.PDFProjectType === "Key Point") {
						if (l && l.label) {
							for (let box of boxes) {
								if (box.label === l.label || l.label === l.spath) return;
							}
						}
					}
	
					if (l.label === "#image") return;
	
					if (window.GlobalVars.PDFProjectType !== "Key Point") {
						if (l.sparent != sparent || l.type != bSel.type) return;
					}
	
					var hk = keys.shift();
					if (labelTaken[l.label]) return;
	
					var circ = '<i class="fa fa-circle" style="color: ' + window.labelColor[l.label] + '"></i> ';
					var opt = $('<div>').addClass('chooseopt')
						.html(circ + l.label + '<span class="bbhotkey">' + hk + '</span>')
						.prop('label', l.label)
						.prop('spath', l.spath.includes('|') ? l.spath.split('|')[1] : l.spath);
					choose.append(opt);
	
					let o = opt;
					hotKeys[hk.charCodeAt(0)] = function (s) {
						try {
							var icon = o.find('.bbhotkey');
							icon.addClass('bbhotkeypressed');
							if (s) {
								chooseopt.apply(o, []);
								hotKeys = {};
							}
						} catch (e) {
							console.error("Error handling hotkey press:", e);
						}
					};
	
					opt.off('mousedown').on('mousedown', chooseopt);
					labCt++;
				});
			} catch (err) {
				console.error("Error iterating through trackData.fdesc:", err);
			}
	
			function chooseopt() {
				try {
					var bSel = boxes[findIdx(bid)];
					bSel.label = $(this).prop('label');
					bSel.title = '';
					if (allTypes.polygon) bSel.title = titleNum(bSel.label);
					bSel.spath = $(this).prop('spath');
	
					changed = 1;
					if (bSel.type == 'keypoint') {
						selected = bSel.parent;
						var par = boxes[findIdx(selected)];
	
						if (window.GlobalVars.PDFProjectType === "Key Point") {
							if (bSel && bSel.label) {
								saveTrackData();
							}
						} else {
							delete par.occluded[bSel.label];
							delete par.outside_image[bSel.label];
						}
					}
	
					drawBoxes();
					hideChooseLabel();
					boxDetails(selected);
				} catch (err) {
					console.error("Error in chooseopt:", err);
				}
			}
	
			var cpos;
			try {
				cpos = popPos($('#bbox_' + bid), popupWidth, choose.height());
				choose.css({ top: px(cpos.top), left: px(cpos.left) });
			} catch (err) {
				console.error("Error positioning choose label popup:", err);
			}
	
			return labCt;
		} catch (err) {
			console.error("Error in chooseLabel:", err);
		}
	}
	

	function eventX(ev){ try{return (ev.pageX-draw.offset().left)/draw.width();} catch{ return 0; }}
	function eventY(ev){ try{return (ev.pageY-draw.offset().top)/draw.height();} catch{ return 0; }}
	// mousedown event
	var lx = 0;
	var ly = 0;
	var labObj = null;
	var lastBox = null;
	var parentBox = null;
	var parentPath = '';

	var titOut = null;
	function updateOver(id)
	{
		// console.log( 'uover', id )
		// console.trace();
		clearTimeout( titOut );
		titOut = setTimeout( function(){
			// console.log( 'updateover tm', id )
			over = id;
			// if( over != lastOver )
			{
				$('.blist').removeClass('bover');
				$('.blist_'+over).addClass('bover');
				lastOver = over;
				// console.log( 'OVER', over ? boxes[findIdx(over)] : null );
				if( over ) boxDetails( over );
				else if( !selected ) hideDetails();
				drawBoxes();
			}
		}, 100);
	}

	function panelVisible()
	{
		return $('#choose-label').length > 0;
		return $('#choose-label').length > 0 || $('#box-details').length > 0;
	}

	function mouseOverEvent(ev)
	{
		if( window.drawUpdate )
		{
			window.pendingOver = function(){
				mouseOverEvent(ev);
			}
			return;
		}
		
		// return;
		// if( selected || mode != 0 || panelVisible() || !$(ev.target).prop('box'))
		if( selected || mode != 0 || !$(ev.target).prop('box'))
		{
			
			if( over != null ) updateOver(null);
			return;
		}
		else
		{
			var o = $(ev.target).prop('bid');
			// console.log( 'overbid', o, over)
			if( o != over )	updateOver(o);
		}
		ev.preventDefault();
	}

	function mouseOutEvent(ev)
	{
		if( window.drawUpdate ) return;
		// console.log( 'mouseout', ev.target)
		// return;
		if( panelVisible() ) return;
		// over = false;
		updateOver(null);
	}

	function setOver( id )
	{
		if( selected ) return;
		var idx = findIdx(id);
		// console.log( 'IDX', idx, id )
		if( idx == -1 ) return updateOver(null);
		if( boxes[idx].invisible ) return;
		// over = id;
		updateOver(id);
	}

	var setVisibleTid = null;
	function setVisible( id, state )
	{
		clearTimeout( setVisibleTid )
		var idx = findIdx(id);
		if( idx == -1 ) return;
		if( id == selected ) selected = null;
		boxes[idx].invisible = state;
		if( state ) over = null;
		// console.log( 'setVisible', id, state )
		setVisibleTid = setTimeout( function(){
			changed = true;
			hideDetails();
			drawBoxes();
		}, 1);
	}

	var setLockedTid = null;
	function setLocked( id, state )
	{
		clearTimeout( setLockedTid )
		// console.log( 'setLocked', id, state )
		var idx = findIdx(id);
		if( idx == -1 ) return;
		if( id == selected ) selected = null;
		boxes[idx].locked = state;
		if( state ) over = null;
		setLockedTid = setTimeout( function(){
			changed = true;
			hideDetails();
			drawBoxes();
		}, 1)
	}


	function setSelected( id )
	{

		if(window.addMode =='polymode' || window.addMode =='brushmode'){
			if( selected == id ) selected = null;
			else selected = id;
			var idx = findIdx(id);
		}
		else{
		if( selected == id ) selected = null;
		else selected = id;
		var idx = findIdx(id);
		// if( idx >= 0 ) boxes[idx].invisible = false;
		console.log( 'setSelected', id );
		changed = true;
		drawBoxes();
		boxDetails( selected );
	}
	}

	function unSelect(ev)
	{
		if( $(ev.target).hasClass('imgdisplay') && selected )
		{
			selected = null;
			changed = true;
			hideDetails();
			drawBoxes();
		}
	}

	function mouseDownEvent(ev)
	{
		var x = eventX(ev);
		var y = eventY(ev);
		// Handle rotation
		if ($(ev.target).prop('rothandle')) {
			if (blockEdit) return taskLocked();
			if (review_mode) return;
			if (!window.rotationMode) return;
			
			mode = 5; // rotation mode
			var box = boxes[selectedIdx()];
			if (box.type === 'keypoint') return;
			// Calculate box center in normalized coordinates
			centerPoint = {
				x: box.x + box.w/2,
				y: box.y + box.h/2
			};
			
			// Calculate initial angle from center to mouse
			var mouseX = x;
			var mouseY = y;
			rotationStartAngle = Math.atan2(
				mouseY - centerPoint.y, 
				mouseX - centerPoint.x
			) - (box.rotation || 0);
			
			mouseMoveStart();
			$(document).off('mouseup').on('mouseup', mouseUp);
			return;
		}

		// if( window.shiftPressed )
		if( window.panMode || ev.which == 3 )
		{
			mode = 4;
			var pos = cfg.imageObj.position();
			var offx = pos.left;
			var offy = pos.top;
			window.lockX = ev.pageX-offx;
			window.lockY = ev.pageY-offy;
			mouseMoveStart();
			$(document).off('mouseup').on('mouseup',mouseUp);
			hideDetails()
			hideChooseLabel();

			return false;
		}

		// if( panelVisible() ) return;
		function startDrag()
		{
			mode = 2;
			lx = x-boxes[selectedIdx()].x;
			ly = y-boxes[selectedIdx()].y;
			drawBoxes();
			mouseMoveStart();
			$(document).off('mouseup').on('mouseup',mouseUp);
		}
		if( $(ev.target).prop('box') && !window.keyPointMode )
		{
			if( review_mode ) return;
			if( $(ev.target).prop('bid') == selected &&
			( boxes[selectedIdx()].type == 'keypoint' || window.moveMode ))
			{
				startDrag();
				return;
			}
			else lastBox = $(ev.target).prop('bid');
		}


		if( $(ev.target).prop('label'))
		{
			if( blockEdit ) return taskLocked();
			if( review_mode ) return;
			mode = 3;
			selected = $(ev.target).prop('bid');
			drawBoxes();
			// $(ev.target).attr('contenteditable',true);
			setTimeout( function(){
				labObj = $('#label_'+selected)[0];
				if( labObj ) chooseLabel( labObj.parentNode );
			}, 1 );
			return;
		}
		else if(  $(ev.target).prop('corner') )
		{
			if( blockEdit ) return taskLocked();
			if( review_mode ) return;
			selected = $(ev.target).prop('bid');
			var cid = $(ev.target).prop('cid');
			corner = cid;
			var bx = boxes[selectedIdx()].x;
			var by = boxes[selectedIdx()].y;
			console.log( 'corner', bx, by, cid );
			if( cid == 0 || cid == 3 ) bx += boxes[selectedIdx()].w;
			if( cid == 0 || cid == 1 ) by += boxes[selectedIdx()].h;
			boxes[selectedIdx()].x = bx;
			boxes[selectedIdx()].y = by;
			console.log( 'corner2', bx, by, cid );
			mode = 1;
		}
		else if( window.addMode.match(/(brushmode|polymode)/) && !window.panMode )
		{
			if( blockEdit ) return taskLocked();
			return brushDown( x, y );
		}
		else
		{
			corner = 2;
			mode = 1;
			// if( window.keyPointMode && selected )
			if( $(ev.target).prop('bid') )
			{
				// alert( 1);
				if( selected == $(ev.target).prop('bid') )
				{
					lastBox = $(ev.target).prop('bid');
					parentBox = selected;
					parentPath = boxes[selectedIdx()].spath;
					if( boxes[selectedIdx()].type == 'keypoint' )
					{
						parentBox = boxes[selectedIdx()].parent;
					}
					// console.log( 'parentBox', parentBox, 'parentPath', parentPath );
				}
				else {
					selected = $(ev.target).prop('bid');
					mode = 0;
					if( window.moveMode )
					{
						mode = 2;
						startDrag();
						return;
					}
					fixSelected();
					drawBoxes();
					draw.off('mouseup').on('mouseup',mouseUp);
					boxDetails( selected );
					return;
				}
			}
			else
			{
				parentBox = null;
				parentPath = '';
			}
			if( blockEdit ) return taskLocked();
			if( !review_mode )
			{
				var id = tmpId();
				var nBox = {x:x, y:y, w:0, h:0, id: id, oid: id, label: '', parent: parentBox, sparent: parentPath, rotation: 0 };
				// console.log( 'NEWBOX', JSON.stringify(nBox));
				boxes.push( nBox );

				selected = id;
			}
			drawBoxes();
		}
		if( blockEdit ) return taskLocked();
		mouseMoveStart();
		$(document).off('mouseup').on('mouseup',mouseUp);
		return;
	}

	// moves the selected controlpoint to the coordinates
	function moveSelected(x = 0, y = 0) {
		try {
			if (!selected) return;
			if (x > 1) x = 1; 
			if (x < 0) x = 0;
			if (y > 1) y = 1; 
			if (y < 0) y = 0;
			if (mode == 4) return;
	
			var bSel = boxes[selectedIdx()];
			if (mode == 1) {
				bSel.w = x - bSel.x;
				bSel.h = y - bSel.y;
				if (window.squareMode || window.shiftPressed) {
					if (corner & 1)
						bSel.w = -bSel.h * aspect;
					else
						bSel.h = bSel.w / aspect;
				}
			} else if (mode == 2) {
				bSel.x = x - lx;
				bSel.y = y - ly;
			}
			// changed = true;
		} catch (error) {
			console.error("Error in moveSelected:", error);
		}
	}
	

	function fixSelected()
	{
		if( lineMode ) return;
		if( !selected ) return;
		var bSel = boxes[selectedIdx()];
		if(bSel && bSel.w && bSel.h){
			if( bSel.w < 0 )
				{
					bSel.w = -bSel.w;
					bSel.x -= bSel.w;
				}
				if( bSel.h < 0 )
				{
					bSel.h = -bSel.h;
					bSel.y -= bSel.h;
				}
		}

		var minx = 3/boxWidth;
		var miny = 3/boxHeight;
		
			if( !bSel.type ) bSel.type = 'box';
		
		

		// if( bSel.w < minx || bSel.h < miny )
		// 	{
		// 		if( !bSel.parent )
		// 		{
		// 			boxes.splice(selectedIdx(),1);
		// 			if( lastBox ) selected = lastBox;
		// 			else selected = null;
		// 		}
		// 		else {
		// 			bSel.type = 'keypoint';
		// 			bSel.w = bSel.h = 0;
		// 		}
		// 	}
		if(bSel && bSel.type){
		if (window.GlobalVars.PDFProjectType === "Key Point"){
			bSel.type = 'keypoint';
			bSel.w = bSel.h = 0;
		}
		else{
					if( bSel.w < minx || bSel.h < miny )
			{
				if( !bSel.parent )
				{
					boxes.splice(selectedIdx(),1);
					if( lastBox ) selected = lastBox;
					else selected = null;
				}
				else {
					bSel.type = 'keypoint';
					bSel.w = bSel.h = 0;
				}
			}

		}
	}

	}
	function posImg( x, y, pageX, pageY )
	{
		window.lastPageX = pageX;
		window.lastPageY = pageY;
		var pos = cfg.imageObj.position();
		var offx = pos.left;
		var offy = pos.top;
		var iw = cfg.imageObj.width();
		var ih = cfg.imageObj.height();
		var left = (x*iw+offx)+draw.offset().left;
		var top = (y*ih+offy)+draw.offset().top;
		left = pageX-left;
		top = pageY-top;
		// console.log( 'posIMG', x, y, pageX, pageY, left, top )

		draw.css({ left:px(left),top:px(top) });
		svg.css({ left:px(left),top:px(top) });
		cfg.imageObj.css({ left:px(left),top:px(top) });
		// console.log( 'posImg', x, y, 'iw', iw, 'ih', ih, 'page', pageX, pageY, 'off', offx, offy, 'lefttop', left, top );
		// function eventX(ev){ return (ev.pageX-draw.offset().left)/draw.width();}
		// function eventY(ev){ return (ev.pageY-draw.offset().top)/draw.height();}
		reframeImage();

	}

	function reframeImage()
	{
		// return;
		var pos = cfg.imageObj.position();
		var offx = pos.left;
		var offy = pos.top;
		var iw = cfg.imageObj.width();
		var ih = cfg.imageObj.height();
		var pw = $('#imageoverlay').width();
		var ph = $('#imageoverlay').height();
		if( offx > 0 ) offx = 0;
		if( offy > 0 ) offy = 0;
		if( offx+iw < pw ) offx += (pw-offx-iw);
		if( offy+ih < ph ) offy += (ph-offy-ih);
		draw.css({ left:px(offx),top:px(offy) });
		svg.css({ left:px(offx),top:px(offy) });
		cfg.imageObj.css({ left:px(offx),top:px(offy) });
		// window.offx = offx;
		// window.offy = offy;
	}

	// create new SVG element
	function makeSVG(tag, attrs)
	{
		try {
			var el= document.createElementNS('http://www.w3.org/2000/svg', tag);
			for (var k in attrs)
			el.setAttribute(k, attrs[k]);
			return el;
		} catch(e){ return null }
	}

	function removeSVG( id )
	{
		try {
			do {
				var o = svg[0].getElementById(id);
				if( o ) o.remove();
			} while(o);
		} catch(e){}
	}

	function setVertexEvents( id )
	{
		var vid = id + '_vertex';
		var oid = id + '_outline';
		// console.log( 'setVertexEvents', vid );
		try {
			do {
				var o = svg[0].getElementById(vid);
				if( o )
				{
					o.id = '#tmp#';
					$(o).css({pointerEvents:'all',cursor: 'pointer'})
					$(o).on('mouseover',vertexEvent)
					$(o).on('mouseout',vertexEvent)
					$(o).on('mousedown',vertexEvent)
				}
			} while(o);
			do {
				var o = svg[0].getElementById('#tmp#');
				if( o ) o.id = vid;
			} while(o);

			do {
				var o = svg[0].getElementById(oid);
				if( o )
				{
					o.id = '#tmp#';
					$(o).css({pointerEvents:'all',cursor: 'pointer'})
					$(o).on('mouseover',edgeEvent)
					$(o).on('mouseout',edgeEvent)
					$(o).on('mousedown',edgeEvent)
				}
			} while(o);
			do {
				var o = svg[0].getElementById('#tmp#');
				if( o ) o.id = oid;
			} while(o);
		} catch(e){}

	}

	function vertexDel()
	{
		if( !window.vertexSelected ) return;
		var bsel = boxes[findIdx(selected)];
		var v = window.vertexSelected;
		var poly = bsel.shape[v.pidx][v.pidx2];
		poly.pop();
		poly.splice( v.vidx, 1 );
		poly.push( poly[0] )
		if( poly.length < 4 ) poly.splice( 0, 1000 );
		changed = true;
		simplifySelected();
		drawBoxes();
	}

	function vertexMove( x, y )
	{
		removeSVG('brushCursor');
		var bsel = boxes[findIdx(selected)];
		var v = window.vertexMove;
		// console.log( 'vertexMove', x, y, v, bsel.shape, v.pidx, v.pidx2, v.vidx )
		var poly = bsel.shape[v.pidx][v.pidx2]
		poly[v.vidx] = [x,y];
		if( v.vidx == 0 ) poly[poly.length-1] = [x,y];
		var dp = bsel.drawParams;
		drawPolygon( bsel.id, polyToScreen(bsel.shape), dp.stroke, dp.color, dp.fill, dp.vertex);
		setVertexEvents( bsel.id );
	}

	function vertextSelectedStyle()
	{
		return {fill:'#ffffff',r:(15*compSize)/window.zoom};
	}

	function edgeEvent( ev )
	{
		var x = eventX(ev);
		var y = eventY(ev);
		removeSVG('brushCursor');
		removeSVG('brushArea');
		if( ev.type != 'mousedown' ) return;
		console.log( 'edgeEvent', ev.type, this.data, x, y )
		var bsel = boxes[findIdx(selected)];
		var shape = clone( bsel.shape );
		var v = this.data;
		var poly = shape[v.pidx][v.pidx2]
		poly.splice( v.vidx+1, 0, [x,y] );
		console.log( poly.length );
		bsel.shape = clone(shape);
		var dp = bsel.drawParams;
		// drawPolygon( bsel.id, polyToScreen(bsel.shape), dp.stroke, dp.color, dp.fill, dp.vertex);
		// setVertexEvents( bsel.id );

		// console.log( 'max', max, 'mid', mid )
		// poly.push( poly[0] );
		window.vertexMove =	window.vertexSelected = {pidx:v.pidx,pidx2:v.pidx2,vidx:v.vidx+1,id:v.id}
		$(document).off('mouseup').on('mouseup',mouseUp);
		mouseMoveStart();
		changed = true;
		drawBoxes();
	}

	function vertexEvent( ev )
	{
		// if( window.polyDraw ) return;
		removeSVG('brushCursor');
		removeSVG('brushArea');
		// console.log('vertexover', ev.type, this.data)
		if( ev.type == 'mouseover' ) {
			mouseMoveStart();
			removeSVG('brushCursor');
			// $(this).css({fill:'#ffffff',r: 15/window.zoom})
		}
		if( ev.type == 'mouseut' ) $(this).css(vertextSelectedStyle())
		if( ev.type == 'mousedown' )
		{
			$(this).css({fill:'#ffffff',r: 15*compSize/window.zoom})
			this.data.obj = this;
			window.vertexMove = this.data;
			window.vertexSelected = this.data;
			$(document).off('mouseup').on('mouseup',mouseUp);
			mouseMoveStart();
		}
		return false;
	}

	function drawPolygon( id, points, stroke, strokeColor, fillColor, vertex )
	{
		// vertex = 1;
		var radius = 10;
		// var compSize = 1;
		radius *= compSize;
		stroke *= compSize;
		function addVertex( id, x, y, r, stroke, fill, data )
		{
			// console.log( 'vertex', id, x, y, stroke, fill )
			if( !data ) data = {};
			var params = {
				id: id,
				cx: x,
				cy: y,
				r: r/window.zoom,
				stroke: stroke,
				'stroke-width': 1,
				fill: fill,
			};
			data.params = params;
			var vert = makeSVG( 'circle', params );
			vert.data = data;
			svg[0].append(vert);
			if( window.vertexSelected )
			{
				var isSel = true;
				for( var k of ['id','pidx','pidx2','vidx'] )
				// for( var k of ['id'] )
				{
					if( data[k] != window.vertexSelected[k] )
					{

						isSel = false;
						break;
					}
				}
				if( isSel ) $(vert).css(vertextSelectedStyle())
			}
			return vert
		}
		function addLine( id, a, b, stroke, strokeColor, data )
		{
			if( !data ) data = {};
			var params = {
				id: id,
				x1: a[0],
				y1: a[1],
				x2: b[0],
				y2: b[1],
				stroke: strokeColor,
				'stroke-width': stroke,
			};
			data.params = params;
			var line = makeSVG( 'line', params );
			line.data = data;
			svg[0].append(line);
		}

		try {
			removeSVG( id );
			removeSVG( id + '_outline' );
			removeSVG( id + '_vertex' );
			var pidx = 0;
			for( var plist of points )
			{
				var pts = [];
				var stack = []
				for( var i = 0 ; i < plist.length ; i++ )
				{
					if( stroke )
					{

						if( vertex )
						{
							for( var j = 0 ; j < plist[i].length-1 ; j++ )
							{
								addLine( id+'_outline', plist[i][j], plist[i][j+1], stroke, strokeColor, {id:id, pidx:pidx, pidx2:i,vidx:j} )
							}
						}
						else {
							var outline = makeSVG( 'polyline', {
								id: id+'_outline',
								points: plist[i],
								fill: 'none',
								stroke: strokeColor,
								'stroke-width': stroke,
							});
							outline.data = {id:id,pidx:pidx,pidx2:i}
							svg[0].append( outline );
						}
					}
					if( vertex )
					{
						for( var j = 0 ; j < plist[i].length-1 ; j++ )
						{
							addVertex( id+'_vertex', plist[i][j][0], plist[i][j][1], radius, strokeColor, fillColor, {id:id, pidx:pidx, pidx2:i,vidx:j} )
						}
					}
					if( pts.length )
					{
						stack.push( pts.pop() );
						stack.push( pts[pts.length-1] );
					}
					plist[i].forEach( p => pts.push( p ) );
				}
				while( stack.length) pts.push( stack.pop() );

				var style = {};
				if( fillColor > '' )
				{
					style.fill = fillColor;
					style['fill-rule'] = 'evenodd';
				}
				else style['fill-opacity'] = 0;
				// console.log( style );
				var sstyle = [];
				for( var k in style ) sstyle.push( k + ':' + style[k] + ';');
				var esvg = makeSVG( 'polygon', {
					id: id,
					points: pts,
					style: sstyle.join(' '),
				})
				svg[0].append( esvg );
				pidx++;
			}
		}
		catch(e){}
	}

	function polyOffset( o, x, y )
	{
		if( !o ) return;
		if( !x ) x = 0;
		if( !y ) y = 0;
		return o.map( pl => pl.map(p =>  p.map( pt => [(pt[0]+x),(pt[1]+y)] )) )
		// return o.map( p => [(p[0]+x),(p[1]+y)] )
	}

	function polyToScreen( o )
	{
		try{
			return o.map( pl => pl.map(p => p.map( pt => [pt[0]*origWidth,pt[1]*origHeight])) )
		}
		catch(error){
			console.error(error);
			
		}
		
	}

	function polyToNorm( o )
	{
		return o.map( pl => pl.map(p => p.map( pt => [pt[0]/origWidth,pt[1]/origHeight])) )
	}


	function polyToScreenBox( o )
	{
		return o.map( pl => pl.map(p => p.map( pt => [pt[0]*boxWidth,pt[1]*boxHeight])) )
	}

	function polyMaxRight( o, ymax )
	{
		var mr = 0;
		o.map( pl => pl.map(p => p.forEach( pt => {
			if(pt[1] < ymax )
			{
				if( !mr || mr < pt[0] ) mr = pt[0];
			}
		})) )
		return mr;
	}

	function pdist( a, b )
	{
		var dx = b[0]-a[0];
		var dy = b[1]-a[1];
		return Math.sqrt( dx*dx + dy*dy );
	}
	function pang( a, b, c )
	{
		var va = [b[0]-a[0], b[1]-a[1]];
		var vb = [c[0]-b[0], c[1]-b[1]];
		var la = Math.sqrt( va[0]*va[0] + va[1]*va[1] );
		var lb = Math.sqrt( vb[0]*vb[0] + vb[1]*vb[1] );
		va[0] /= la;
		va[1] /= la;
		vb[0] /= lb;
		vb[1] /= lb;
		var pab = va[0]*vb[0] + va[1]*vb[1];
		// console.log( 'ABCD', a, b, c, 'la', la, 'lb', lb, 'va', va, 'vb', vb, 'pab', pab )
		return pab;
	}
	window.pang = pang;

	function polySimplify( o, rate )
	{
		// return o;
		var lsplice = [];
		var n = polyToScreen( o );
		n.map( pl => {
			var lsplice = [];
			pl.map( (p,pidx) => {
				var olen = p.length;
				var splices = [];
				p.pop();
				do {
					var spliced = false;
					for( var i = 0 ; i < p.length ; i++ )
					{
						if( pdist( p[(i+1)%p.length], p[i] ) < 1.5 )
						{
							// console.log( 'splice dist', i, pdist( p[i+1], p[i] ) )
							splices.push( (i+1)%p.length );
							break;
						}
					}
					if( splices.length )
					{
						splices.sort();
						while( splices.length )
						{
							var i = splices.pop();
							p.splice( i, 1 );
						}
						spliced = true;
					}
					// break;
				} while( spliced )

				do {
					var spliced = false;
					for( var i = 0 ; i < p.length ; i++ )
					{
						var a = pang( p[i], p[(i+1)%p.length], p[(i+2)%p.length])
						var d = pdist( p[i], p[(i+2)%p.length] );
						// console.log( 'ang', i, a, 'len', p.length, 'pt', p[i], p[(i+1)%p.length], p[(i+2)%p.length], 'd', d, 'diff', (d-a*d) )
						if( (d-a*d) < 0.15 )
						{
							splices.push( (i+1)%p.length );
							// console.log( 'splice ang', i, d );
							i++;
							break;
						}
					}
					if( 1 && splices.length )
					{
						splices.sort();
						while( splices.length )
						{
							var i = splices.pop();
							p.splice( i, 1 );
						}
						spliced = true;
					}
				} while( spliced );
				p.push(p[0])
				if( p.length < 4 ) lsplice.push(pidx);
				// console.log( 'len change', olen, p.length )
			})
			// console.log( 'lsplice', lsplice )
			while( lsplice.length )
			{
				var i = lsplice.pop();
				pl.splice(i,1);
			}
		})
		// console.log( 'NNNNNNNNNNNNNNNN', n )
		return polyToNorm( n );
	}


	function polyNorm( o )
	{
		return o;
		// return o.map( pl => pl.map(p => {
		// 	var out = [];
		// 	var lastX = -9999999;
		// 	var lastY = -9999999;
		// 	for( var pt of p )
		// 	{
		// 		var nx = Math.round(pt[0]*origWidth);
		// 		var ny = Math.round(pt[1]*origHeight);
		// 		if( nx == lastX && ny == lastY )
		// 		{
		// 			console.log( 'simplify')
		// 			continue;
		// 		}
		//
		// 		lastX = nx;
		// 		lastY = ny;
		// 		out.push( [nx/origWidth,ny/origHeight] );
		// 		// p.map( pt => [pt[0]*origWidth,pt[1]*origHeight])
		// 	}
		// 	return out;
		// }) );
	}

	function polyArea( o )
	{
		// compute area
		var area = 0;
		var big = 999;
		var x1 = big;
		var x2 = -big;
		var y1 = big;
		var y2 = -big;
		function vdif( v, t )
		{
			// console.log( 'vdif', v, t )
			return [t[0]-v[0],t[1]-v[1]];
		}
		function cross( a, b )
		{
			return a[0]*b[1]-a[1]*b[0];
		}
		o.forEach( pl => pl.forEach((p,pidx) => {
			var n = p.length-1;
			// console.log( 'p', p, pidx )
			for( var i=0; i < n; i++ )
			{
				x1 = Math.min( x1, p[i][0] )
				x2 = Math.max( x2, p[i][0] )
				y1 = Math.min( y1, p[i][1] )
				y2 = Math.max( y2, p[i][1] )
				if( i == 0 ) continue;
				// if second or greater calc area
				var a = vdif(p[0],p[i]);
				var b = vdif(p[0],p[i+1]);

				var v = vdif(p[i-1],p[i])
				var t = vdif(p[i],p[i+1])
				var cr = cross(a, b);
				if( !pidx )	area += cr;
				else area -= cr;
			}
		}) );
		return {x:x1,y:y1,w:x2-x1,h:y2-y1,area:area/2};
	}


	function brushCircle()
	{
		// var arc = 20/origWidth;
		if( !origWidth ) return null;
		var r = window.brushSize/origWidth;
		// r /= window.zoom;
		r /= window.zoom;
		// console.log( 'RADIUS', r, window.zoom )
		if( !r ) return null;

		var circ = 2*Math.PI*r;
		// var steps = Math.round(circ/arc);
		var steps = Math.floor(Math.log( 1.2 + (window.brushSize-20)/180 )*100);
		// steps = 4;
		var out = [];
		var inc = Math.PI*2/steps;
		// var a = Math.PI/4;
		var a = 0;
		for( var i = 0 ; i < steps ; i++ )
		{
			var x = Math.cos(a)*r;
			var y = Math.sin(a)*r/origAspect;
			out.push( [x,y] );
			a += inc;
		}
		out.push( out[0] );
		// console.log( 'brushCircle', out );
		return [[out]];
	}

	function polyOver( x, y )
	{
		var inc = 0.00001;
		var p = [[ [x, y], [x+inc,y], [x+inc,y+inc], [x,y+inc], [x,y] ]];
		var ret = null;
		for( b of boxes )
		{
			if( b.type == 'polygon' && !b.locked)
			{
				var inter = window.polygonIntersection( b.shape, p );
				if( inter && inter.length ) ret = b;
				// console.log( b.id, b.shape, p, inter  );
				// && polygonIntersection( b.shape, p ).length > 0 )
				// return b;

			}
		}
		return ret;
	}
	//double click polygon finish the shape  dhinesh
	$(document).off('dblclick', '#drawimgpreview').on('dblclick', '#drawimgpreview', polyDrawClose);

	function polyDrawClose()
	{
		try{
			// var p = clone(window.polyDraw);
			// p.push( window.polyDraw[0]);
			var p = clone(window.polyDraw) || [];
			if (!Array.isArray(p)) {
				console.warn("Cloned polyDraw is not an array:", p);
				p = [];
			}
			p.push(window.polyDraw[0]);
			window.brushArea = [[p]]
			polyDrawReset();
			return polygonUp();
		}
		catch(error){
			console.error(error)
		}

	}

	function polyDrawReset()
	{
		removeSVG('polydrawVertex');
		removeSVG('polydraw_outline');
		removeSVG('polydraw_vertex');
		removeSVG('polydraw');
		window.polyDraw = null;
		window.brushDown = null;
	}

	function polyCircle( x, y, r )
	{

	}

	function polyDraw( x, y )
	{
		if( !window.polyDraw ) window.polyDraw = [window.brushDown];
		var p = clone(window.polyDraw);
		// while( p.length < 3 )

		//undo bug fix dhinesh
		if (x < 0 || x>1 || y <0 || y >1) {
			return ; //dhinesh
		}
		else{
			if( defined(x) ) p.push( [x,y] )
			p.push( window.polyDraw[0] );
		}	

		var scolor = '#ffffffcc';
		var fcolor = '#77777777';
		var ccolor = cursorFill().substr(0,7)

		if(  distCoord( [x,y], window.polyDraw[0]) < 15 ) scolor = ccolor;

		var poly = polyToScreen([[p]]);
		// console.log( p )
		// removeSVG('polydrawVertex');
		// var params = {
		// 	id: 'polydrawVertex',
		// 	cx: poly[0][0][0][0],
		// 	cy: poly[0][0][0][1],
		// 	r: 10/window.zoom,
		// 	stroke: ccolor,
		// 	'stroke-width': 1,
		// 	fill: scolor,
		// };
		// var start = makeSVG( 'circle', params )
		// svg[0].append(start);

		drawPolygon( 'polydraw', poly, 1/window.zoom, scolor, cursorFill(), 2 );
	}
	window.pd = polyDraw;


	function cursorFill()
	{
		return window.eraseMode ? '#ff000077' : '#00ff0077';
	}

	function brushMove( x, y )
	{
		x += Math.random()*0.00001;
		y += Math.random()*0.00001;
		if( !window.brushCursor ) window.brushCursor = brushCircle();
		if( !window.brushCursor ) return;

		if( !window.brushDown && !window.polyDraw && !selected && x >= -0.1 && x <= 1.1 && y >= -0.1 && y <= 1.1)
		// if( !window.brushDown && !window.polyDraw && !selected )
		{
			var o = polyOver( x, y );
			if( o ) o = o.id;
			// console.log( 'ooooo', o, over );
			if( o != over )
			{
				// console.log( 'change over', o );
				over = o;
				if( over )
				{
					lastOver = null;
					setOver(over)
					// console.log( 'detail', over, o )
					boxDetails(over);
				}
				else {
					// console.log( 'sem over')
					setOver( null );
					hideDetails();
				}
				boxList( boxes )
				drawBoxes();
			}
		}

		if( window.addMode == 'polymode' )
		{
			if( window.polyDraw || window.brushDown )
			{
				var d = distCoord( [x,y], window.brushDown );
				if( (window.polyDraw && window.polyDraw.length) || d > 30/window.zoom )
				{
					return polyDraw( x, y );
				}
			}
			return;
		}
		// console.log( 'brushCursor', window.brushCursor, window.brushDown, window.brushArea );
		var cursor = polyOffset(window.brushCursor, x, y );
		drawPolygon( 'brushCursor', polyToScreen(cursor), 1, '#ffffff77', '#00000077', 0 );
		if( window.brushDown )
		{
			var n = window.polygonUnion( window.brushArea, cursor )
			// if( Math.abs( n.length - window.brushArea.length ) < 2 )
			if( 1 )
			{
				window.brushArea = n;
				drawPolygon( 'brushArea', polyToScreen(window.brushArea), 0, '#ffffff99', cursorFill() );
			}
		}
	}


	function brushDown( x, y )
	{
		// console.log( 'brush Down', x, y, window.brushSize )
		$(document).off('mouseup').on('mouseup',mouseUp);

		if( window.addMode == 'brushmode' )
		{
			var cursor = polyOffset(window.brushCursor, x, y );
			window.brushArea = cursor;
		}
		window.brushDown = [x,y];
	}

	var clipScreen = [[[0,0],[1,0],[1,1],[0,1],[0,0]]];

	function distCoord( p0, p1 )
	{
		if( !p0 || !p1 ) return 0;
		var dx = p1[0]-p0[0];
		var dy = p1[1]-p0[1];
		var d = Math.sqrt( dx*dx + dy*dy )*origWidth;
		console.log('d-------->',d)
		return d;
	}

	function simplifySelected()
	{
		if( !selected ) return;
		var bsel = boxes[findIdx(selected)];
		bsel.shape = polySimplify(bsel.shape);

	}


	function brushUp( x, y )
	{
		// console.log( 'UP', x, y, window.brudhDown )
		if( window.vertexMove )
		{
			vertexMove( x, y );
			changed = true;
			window.vertexMove = null;
			// simplifySelected()
			drawBoxes();
			mouseMoveEnd();
		}
		if( window.addMode == 'polymode' && window.polyDraw && window.polyDraw.length )
		{
			if(  distCoord( [x,y], window.polyDraw[0]) < 15/window.zoom && window.polyDraw.length > 2 )
			{
				return polyDrawClose( x, y );
			}
			polyDraw( x, y );

			//undo bug fix dhinesh
			if (x < 0 || x>1 || y <0 || y >1){
				return ;
			} 
			else{
				window.polyDraw.push( [x, y] );
				window.brushDown = false;
				saveData();
				return;
			} 
		}
		if( !window.brushDown ) return;
		var d = distCoord( window.brushDown, [x,y]);
		// console.log( 'brush up', x, y, window.brushSize, 'dist', d )
		window.brushDown = false;

		if(window.GlobalVars.PDFProjectType ==="Segmentation"){    //duplicate prevent dhinesh
			if(window.addMode==="polymode"){
				if (d > 3 && d < 30) {
					return;
				}
			}

		}
		if( d > 6/window.zoom )
		{
			polygonUp();
			window.brushDown = false;
			return;
		}
		if( !checkForceLabel() )
		{
			var o = polyOver( x, y );
			if( o && o.id != selected ) selected = o.id;
			else if( !window.doubleClick ) selected = null;
			window.doubleClick = false;
			window.vertexSelected = false;
			if( o && o.id == window.selectedTimeId ) // if  doubleclick force selecte
			{
				if( window.selectedTime && (Date.now()-window.selectedTime) < 300 )
				{
					// console.log( 'DOUBLE!!!!!!!!!!!!!!!!!!!', o.id, (Date.now()-window.selectedTime) )
					selected = o.id;
					window.doubleClick = true;
					hideDetails();
					simplifySelected();
				}
			}
			if( o && o.id )
			{
				window.selectedTime = Date.now();
				window.selectedTimeId = o.id;
			}
			changed = true;
			boxDetails(selected)
			removeSVG('brushCursor');
			drawBoxes();
			boxList( boxes )
			if( selected ) checkForceLabel();
		}
	}

	function polygonUp()
	{
		// if( window.addMode == 'polymode' && (!window.polyDraw || window.polyDraw.length < 3) ) return;
		// console.log( 'polygonUp', 'selected', selected, 'boxes', clone(boxes), 'selectedIdx()', selectedIdx() )
		if( !window.brushArea ) return;
		if( !selected )
		{
			var id = tmpId();
			var bsel = {id: id, oid: id, label: '', shape:[], parent: null, sparent: '', type: 'polygon' };
			boxes.push( bsel );

			selected = id;
			console.log( 'NEWBOX', JSON.stringify(bsel));
		}
		else
		{
			var bsel = boxes[findIdx(selected)];
			boxDetails(selected);
		}
		if( !bsel.shape || bsel.shape.length == 0 ) bsel.shape = window.brushArea;
		if( window.eraseMode )
		{
			var n = polyNorm(window.polygonDiff( bsel.shape, window.brushArea ))
		}
		else {
			var n = polyNorm(window.polygonUnion( bsel.shape, window.brushArea ))
		}
		if( n.length )	n = polyNorm(window.polygonIntersection( n, clipScreen ));
		bsel.shape = polySimplify(n);
		var area = polyArea( bsel.shape )
		for( var k in area ) bsel[k] = area[k];

		if( bsel.shape.length == 0 )
		{
			delBox(selected);
			selected = null;
		}
		console.log( bsel )
		console.log( 'polygonUp', area );
		removeSVG('brushArea')
		// drawPolygon( 'tmpPoly', polyToScreen(bsel.shape), 4, '#ffffff99', '#00ffff33' );
		changed = true;
		drawBoxes();
		if( checkForceLabel() )
		{
			// window.doubleClick = true;
			drawBoxes();
		}

	}

	// mouse move event
	function mouseMove(ev)
	{
		var x = eventX(ev);
		var y = eventY(ev);
		// console.log( 'mouseMove', x, y, window.addMode )
		if (mode === 5) { // Rotation mode
			if (!window.rotationMode) return;
			var box = boxes[selectedIdx()];
			
			// Calculate current angle from center to mouse
			var angle = Math.atan2(
				y - centerPoint.y,
				x - centerPoint.x
			);
			
			// Update box rotation
			box.rotation = angle - rotationStartAngle;
			
			// Normalize rotation angle
			while (box.rotation < 0) box.rotation += Math.PI * 2;
			while (box.rotation >= Math.PI * 2) box.rotation -= Math.PI * 2;
			
			// Optional: Snap to angles when holding Shift
			// if (ev.shiftKey) {
			// 	var deg = (box.rotation * 180 / Math.PI) % 360;
			// 	if (deg < 0) deg += 360;
			// 	deg = Math.round(deg / 15) * 15; // Snap to 15-degree intervals
			// 	box.rotation = (deg * Math.PI / 180);
			// }
			
			changed = true;
			drawBoxes();
			return;
		}
		if( window.vertexMove  && !window.panMode ) return vertexMove( x, y );

		if( window.addMode.match(/(brushmode|polymode)/) && !window.panMode ) return brushMove( x, y );
		if( mode == 4 ) //pan
		{
			var offx = -window.lockX+ev.pageX;
			var offy = -window.lockY+ev.pageY;
			draw.css({ left:px(offx),top:px(offy) });
			svg.css({ left:px(offx),top:px(offy) });
			cfg.imageObj.css({ left:px(offx),top:px(offy) });
			reframeImage();
			return;
		}
		moveSelected(x,y);
		// changed = true;
		drawBoxes();
	}

	function placeHolderDiv( box )
	{
		if( !box || !box.pos ) return null;
		var div = $('<DIV>').css({position:'absolute',top:box.pos.y, left: box.pos.x, width: box.pos.w, height: box.pos.h}).prop('id','bbox_'+box.id).prop('bid',box.id)
		draw.append( div );
		// console.log( 'placeholder', div[0])
		return div;
	}

	window.checkForceLabel = checkForceLabel;
	function checkForceLabel()
	{
		var forceLabel = false;
		boxes.forEach( function(b, idx){
			if( !b ) return;
			// if( b.type == 'box'  && trackData.labels && b.label == '' )
			if( b.label == '' )
			{
				// console.log( 'FORCE', b.id );
				selected = b.id;
				forceLabel = true;
			}
		});
		// console.log( 'FORCELABEL', forceLabel, 'selected', selected, clone(boxes), boxes[selectedIdx()] )
		if( forceLabel && selected )
		{
			var div = $('#bbox_'+selected);
			if( !div.length )
			{
				div = placeHolderDiv(boxes[selectedIdx()]);
				if( div ) setTimeout( function(){ div.remove() }, 1 );
			}
			var nlabs = chooseLabel(div[0]);
			if( !nlabs )
			{
				delBox(selected);
				drawBoxes();
			}
		}
		return forceLabel;
	}

	function mouseMoveStart()
	{
		// console.log( 'mouseMoveStart' );
		$(document).off('mousemove').on('mousemove',mouseMove);
	}

	function mouseMoveEnd()
	{
		// console.log( 'mouseMoveEnd' );
		if( window.addMode.match(/(brushmode|polymode)/) ) return;
		if( draw ) draw.off('mousemove');
		$(document).off('mousemove')
	}

	// mouse up event
	function mouseUp(ev)
	{
		// console.log( 'up', window.panMode);
		var x = eventX(ev);
		var y = eventY(ev);
		if( window.addMode.match(/(brushmode|polymode)/) && !window.panMode ) return brushUp( x, y, );

		if( mode != 0 ) moveSelected(x,y);
		fixSelected();
		mouseMoveEnd();
		draw.off('mouseup');
		$(document).off('mouseup');
		draw.css({cursor:'auto'});
		changed = true;
		if( mode == 2 )
		{
			// if it was dragging, select the parentBox
			selected = null;
		}
		mode = 0;
		lastBox = null;
		drawBoxes();
		checkForceLabel();
	}

	function mergeBoxes()
	{
		if( boxesHidden )
		{
			boxesHidden.forEach(function(b){
				boxes.push( b );
			})
			boxesHidden = null;
		}
		drawBoxes();
	}

	function sortBoxes()
	{
		try {
			boxes.sort(function(a,b){
				var aarea = a.area || a.w*a.h;
				var barea = b.area || b.w*b.h;
				return aarea > barea ? -1 : 1;
			});
			function moveToEnd( idx )
			{
				var b = boxes[idx];
				boxes.splice(idx,1);
				boxes.push(b);
			}
			if( selected )
			{
				var movefront = [ selected ];
				var found = 1;
				moveToEnd(findIdx(selected));
				while( found )
				{
					found = 0;
					for( var i = 0 ; i < boxes.length && boxes[i].id != selected ; i++ )
					{
						var b = boxes[i];
						// console.log( 'checking', i, b.id,  movefront.indexOf( b.id ) )
						if( movefront.indexOf( b.parent ) != -1 )
						{
							// console.log( 'moving', b.id, 'parent', b.parent);
							moveToEnd( i );
							movefront.push(b.id);
							found = 1;
							break;
						}
					}
				}
			}
			// console.log( 'sortBoxes', selected, boxes.length );
			// boxes.forEach( (b,idx) => console.log( 'SORT', idx, b.label) )
			// console.log( 'sorted', boxe );
		}
		catch(e){}
	}

	// key down event
	function keyDownEvent(ev)
	{
		if( ev.target.tagName == 'INPUT' || ev.target.tagName == 'TEXTAREA' )
		{
			return true;
		}
		// console.log( 'keydown', ev.keyCode, ev )
		if( hotKeys[ev.keyCode ] ) return hotKeys[ev.keyCode](0);
		if( ev.keyCode == 68 && !window.moveMode )
		{
			$(document.body).css({cursor:'move'});
			window.moveMode = true;
			hideDetails();
			console.log( 'moveMode', window.moveMode );

			return true;
		}
		if( ev.keyCode == 72 && !window.tabPressed )
		{
			console.log( 'TABIN' );
			window.tabPressed = true;
			// boxesHidden = boxes;
			// boxes = [];
			boxes.forEach( function(b){
				b.hidden = true;
			})
			drawBoxes();
			return true;
		}

		if( ev.keyCode == 27 )
		{
			if( window.polyDraw ) return polyDrawReset();
			if( selected && boxes[findIdx(selected)].label == '' )
			{
				delBox( selected )
				selected = null;
				changed = true;
				drawBoxes();
				return;
			}
		}
		if( ev.keyCode == 13 )
		{
			if( window.polyDraw && window.polyDraw.length > 2 ) return polyDrawClose();
			if( mode == 3 )
			{
				mode = 0;
				drawBoxes();
				return false;
			}
		}
		if( ev.keyCode == 90 )
		{
			if( ev.ctrlKey )
			{
				if( ev.shiftKey ) redo();
				else undo();
			}
		}

		if( ev.keyCode == 32 )
		{
			console.log( 'PAMMODE')
			panMode( 1 )
			ev.preventDefault();
		}
		// if( ev.keyCode == 90  ) // Z = zoom
		// {
		// 	if( window.shiftPressed ) zoomOut();
		// 	else zoomIn();
		// }
		if( ev.keyCode == 83  ) // S
		{
			// $('#movelock').prop('checked', true);
			// cfg.movelock = true;
			// window.tabPressed = true;
		}
		if( ev.shiftKey && !window.shiftPressed ) panStart();
		// if( ev.ctrlKey && !window.keyPointMode ) keyPointStart();
		if( ev.keyCode == 67 && !window.keyPointMode ) keyPointStart();
	}

	// key up
	function keyUpEvent(ev) {
		try {
			if (ev.target.tagName === 'INPUT' || ev.target.tagName === 'TEXTAREA') {
				return true;
			}
	
			try {
				// Zoom in (key + or numpad +)
				if (ev.keyCode === 107 || ev.key === '+') {
					setPosImg(window.lastPageX, window.lastPageY);
					tboxPress('zoomin');
					zoomIn();
				}
	
				// Zoom out (key - or numpad -)
				if (ev.keyCode === 109 || ev.key === '-') {
					setPosImg(window.lastPageX, window.lastPageY);
					tboxPress('zoomout');
					zoomOut();
				}
	
				// Disable move mode (key D)
				if (ev.keyCode === 68 && window.moveMode) {
					$(document.body).css({ cursor: 'auto' });
					window.moveMode = false;
					console.log('moveMode disabled', window.moveMode);
					return true;
				}
	
				// Unhide boxes (key H)
				if (ev.keyCode === 72 && window.tabPressed) {
					console.log('TABOUT');
					window.tabPressed = false;
					boxes.forEach(function (b) {
						b.hidden = false;
					});
					drawBoxes();
					checkForceLabel();
					return false;
				}
	
				// Enter key handling
				if (ev.keyCode === 13) {
					if (mode === 3) return false;
					// Additional polyDraw logic can go here if needed
				}
	
				// End panning
				if (!ev.shiftKey && window.shiftPressed) {
					panEnd();
				}
	
				// End keypoint mode
				if (ev.keyCode === 67 && window.keyPointMode) {
					keyPointEnd();
				}
	
				// Spacebar for panning mode
				if (ev.keyCode === 32) {
					panMode(0);
				}
	
				// Update label in mode 3
				if (mode === 3 && labObj) {
					var lab = labObj.innerText.trim();
					boxes[selectedIdx()].label = lab;
					changed = true;
					return;
				}
	
				// Delete box (keys Delete or Backspace)
				if (
					(ev.keyCode === 46 || ev.key === 46 || ev.witch === 46 || 
					ev.keyCode === 8 || ev.key === 8 || ev.witch === 8) && 
					selected
				) {
					if (window.vertexSelected) {
						vertexDel();
					} else {
						delBox(selected);
					}
					changed = true;
					drawBoxes();
				}
	
				// Execute hotkey actions
				if (hotKeys[ev.keyCode]) {
					return hotKeys}
			} catch (innerErr) {
				console.error('Error processing key event:', innerErr);
			}
		} catch (err) {
			console.error('Error in keyUpEvent:', err);
		}
	}
	

	function findBoxChildren(id)
	{
		var idlist = {};
		var bids = {};
		idlist[id] = 1;
		var found = 1;
		var ct = 2000;
		while( found && ct-- > 0 )
		{
			found = 0;
			for( var i = 0 ; i < boxes.length ; i++ )
			{
				if( !( boxes[i].id in bids ) && boxes[i].parent && boxes[i].parent in idlist )
				{
					found = 1;
					// console.log( 'newchild', boxes[i].id, boxes[i].parent );
					idlist[boxes[i].id] = 1;
					bids[boxes[i].id] = 1;
				}
			}
		}
		return Object.keys(bids);
	}

	function delBox(id)
	{
		if( blockEdit ) return taskLocked();
		if( review_mode ) return;

		var b = boxes[id]; 
		var p = id == selected ? boxes[selectedIdx()].parent : null;
		var children = findBoxChildren(id)
		children.forEach( function(c){
			boxes.splice(findIdx(c),1);
		})
		boxes.splice(findIdx(id),1);
		hideDetails();
		hideChooseLabel();
		selected = p;
		sortBoxes();
		if( selected ) boxDetails( selected );
	}

	function setPosImg( pageX, pageY )
	{
		if( !defined(pageX))
		{
			pageX = draw.offset().left;
			pageY = draw.offset().top;
		}
		var ev = {pageX:pageX,pageY:pageY};
		var px = eventX(ev);
		var py = eventY(ev);
		window.posLoadImg = {act:'posImg', px: px, py:py, pageX:pageX, pageY:pageY};
	}

	var zooms = [1, 1.14, 1.32, 1.52, 1.74, 2.01, 2.31, 2.66, 3.05, 3.51, 4.04, 4.65, 5.35, 6.15, 7.07, 8.13, 9.35, 10.76, 12.37, 14.23, 16.36, 18.82, 21.64, 24.89, 28.62];

	function zoomIn() {
		if (window.zooming) return;
		if (checkForceLabel()) return;
		window.zooming = true;
		window.brushCursor = null;
		window.stackSave = { stack: stack, stackPos: stackPos };
		let zidx = zooms.findIndex(j => j > window.zoom);
		if (zidx <= 0) zidx = zooms.length - 1;
		window.zoom = zooms[zidx];
		updateZoom(window.lastPageX, window.lastPageY);
		reframeImage();
		clearTimeout(drawTid);
		hideDetails();
		window.zooming = false;
	}

	function trackMousePosition(event) {
		if (!window.zooming) {
			window.lastPageX = event.pageX;
			window.lastPageY = event.pageY;
		}
	}

	function clearStoredPosition() {
		window.lastPageX = null;
		window.lastPageY = null;
	}

	function zoomIn() {
		if (window.zooming) return;
		if (checkForceLabel()) return;
		window.zooming = true;
		window.brushCursor = null;
		window.stackSave = { stack: stack, stackPos: stackPos };
		let zidx = zooms.findIndex(j => j > window.zoom);
		if (zidx <= 0) zidx = zooms.length - 1;
		window.zoom = zooms[zidx];

		const mouseX = window.event ? window.event.pageX : window.lastPageX;
		const mouseY = window.event ? window.event.pageY : window.lastPageY;
		updateZoom(mouseX, mouseY);
		reframeImage();
		clearTimeout(drawTid);
		hideDetails();
		clearStoredPosition();
		window.zooming = false;
	}

	function zoomOut() {
		if (window.zooming) return;
		if (checkForceLabel()) return;
		window.zooming = true;
		window.brushCursor = null;
		window.stackSave = { stack: stack, stackPos: stackPos };
		let zidx = zooms.findIndex(j => j > window.zoom);
		if (zidx <= 0) zidx = zooms.length - 1;
		if (zidx > 1) zidx--;
		window.zoom = zooms[zidx - 1];
		const mouseX = window.event ? window.event.pageX : window.lastPageX;
		const mouseY = window.event ? window.event.pageY : window.lastPageY;
		updateZoom(mouseX, mouseY);
		reframeImage();
		clearTimeout(drawTid);
		hideDetails();
		clearStoredPosition();
		window.zooming = false;
	}

	function updateZoom(pageX, pageY) {
		const oldBoxWidth = boxWidth;
		const oldBoxHeight = boxHeight;
		boxWidth = baseWidth * window.zoom;
		boxHeight = baseHeight * window.zoom;
		$(cfg.imageObj).css({ width: px(boxWidth), height: px(boxHeight) });
		var drawid = 'draw' + cfg.imageObj.prop('id');
		var svgid = 'svg' + cfg.imageObj.prop('id');
		var draw = $('#' + drawid);
		var svg = $('#' + svgid);
		draw.css({ width: boxWidth, height: boxHeight });
		svg.css({ width: boxWidth, height: boxHeight });
		scale = boxWidth / origWidth;
		if (pageX && pageY) {
			posImg(pageX, pageY, oldBoxWidth, oldBoxHeight);
		} else {
			centerImage();
		}
		drawBoxes();
	}

	function posImg(pageX, pageY, oldWidth, oldHeight) {
		if (!pageX && !pageY) {
			centerImage();
			return;
		}

		const overlay = $('#imageoverlay');
		const overlayOffset = overlay.offset();
		const currentPos = cfg.imageObj.position();
		const currentWidth = oldWidth || cfg.imageObj.width();
		const currentHeight = oldHeight || cfg.imageObj.height();
		const relX = (pageX - overlayOffset.left - currentPos.left) / currentWidth;
		const relY = (pageY - overlayOffset.top - currentPos.top) / currentHeight;
		const newWidth = cfg.imageObj.width();
		const newHeight = cfg.imageObj.height();
		const newLeft = pageX - overlayOffset.left - (relX * newWidth);
		const newTop = pageY - overlayOffset.top - (relY * newHeight);

		const elements = [draw, svg, cfg.imageObj];
		elements.forEach(element => {
			element.css({
				left: px(newLeft),
				top: px(newTop)
			});
		});
		reframeImage();
	}

	function centerImage() {
		const overlay = $('#imageoverlay');
		const pw = overlay.width();
		const ph = overlay.height();
		const iw = cfg.imageObj.width();
		const ih = cfg.imageObj.height();
		const offx = (pw - iw) / 2;
		const offy = (ph - ih) / 2;
		const elements = [draw, svg, cfg.imageObj];
		elements.forEach(element => {
			element.css({
				left: px(offx),
				top: px(offy)
			});
		});

		reframeImage();
	}

	function initializeZoomHandlers() {
		const imageOverlay = $('#imageoverlay');
		imageOverlay.on('mousemove', trackMousePosition);
		imageOverlay.on('mouseleave', clearStoredPosition);
		imageOverlay.on('wheel', function (event) {
			event.preventDefault();
			if (event.originalEvent.deltaY < 0) {
				zoomIn();
			} else {
				zoomOut();
			}
		});
	}

	function keyPointStart()
	{
		window.keyPointMode = true;
		console.log( 'KP Start');
	}

	function keyPointEnd()
	{
		window.keyPointMode = false;
		console.log( 'KP End');
	}

	function panStart()
	{
		$('#movelock').prop('checked', true);
		cfg.movelock = true;
		window.shiftPressed = true;
		draw.css({cursor:"move"});
	}

	function panEnd()
	{
		$('#movelock').prop('checked', false);
		cfg.movelock = false;
		window.shiftPressed = false;
		draw.css({cursor:"auto"});
	}

	// set the configuration variables
	function loadConfig(config)
	{
		for( var c in config )
		{
			cfg[c] = config[c];
// 			console.log( 'CONFIG', c, cfg[c] );
		}
		changed = true;
		drawBoxes();
		return cfg;
	}
	this.config = loadConfig;
	this.getPoints = function(){ return boxes };
	this.reset = function()
	{
		reset();
		if( cfg.onchange ) cfg.onchange(jsonCode);
	}

	function removeClickHandler() {
		try {
			$('.bbox, .bboxsel, .bboxtarget').removeClass('bbox bboxsel bboxtarget');
			boxes.forEach(function(box) {
				if (box.parent === null) {
					delete box.pos;
					delete box.x;
					delete box.y;
					delete box.w;
					delete box.h;
				}
			});
			console.log('Updated boxes--->', boxes);
			window.setSelected($('#removeborder').prop('bid'));
			
		} catch (error) {
			console.error('An error occurred while removing the border:', error);
		}
	}

	document.getElementById('submitButton').onclick = function()

	{
		// removeClickHandler();
		var aexp = exportData(1);
		if( aexp ) {
			hideDetails();
			if( scriptMode == 'template' ) document.querySelector('crowd-form').submit();
			else {
				adlSubmit();
			}
		}
    };
	init();
	return this;
}

var updateBoxListTid = null;
function updateBoxList()
{
	clearTimeout( updateBoxListTid );
	updateBoxListTid = setTimeout( function(){
		boxList( window.getBoxes() );
	}, 200 );
}

function battr( b )
{
	if( !b.attrs ) return '';
	var alist = [];
	for( var k in b.attrs )
	{
		if( b.attrs[k] )
		alist.push( k +': ' + b.attrs[k] );
	}
	return alist.join( ', ');
}


function boxList( boxes )
{
	// console.log( 'boxlist')
	boxes.sort( function( a, b ){ return a.id < b.id ? -1 : 1}) 
	var selected = window.getSelected();

	$('#boxlist').html('');
	var list = $('<table class="table boxlisttable">');
	var head = $('<thead>');
	list.append(head);
	var tr = $('<tr bid="0"><th scope="col"><span>Annotations</span></th></tr>');
	var thvis = $('<th class="colstate colvisible" scope="col"><i class="fa fa-eye-slash" aria-hidden="true"></i></th>').on('click',visibleAll);
	var thlock = $('<th class="colstate collock" scope="col"><i class="fa fa-unlock" aria-hidden="true"></i></th>').on('click',lockedAll);
	tr.append(thvis,thlock);
	head.append(tr);
	$('#boxlist').append(list);
	var body = $('<tbody>');
	list.append( body );
	var ctVis = 0;
	var ctLock = 0;
	var ctBox = 0;
	var bids = [];
	boxes.forEach( (b,idx) => {
		window.allSubsMode =1;
		if( !b ) return;
		console.log('b.id',b.id,);
		
		if( b.parent || !b.spath ) return;
		ctBox++;	
		bids.push( b.id );
		var tr = $('<tr>').prop('bid',b.id).addClass('blist').addClass('blist_'+b.id);
		if( b.id == selected ) tr.addClass('bsel');
		tr.on('mouseover', listOver ).on('mouseout', listOut ).on('click', listClick);
		// trackData.fdesc = trackData.fdesc.filter(item => item.label !== b.label);  //select label name remove form list.
		var attrs = battr(b);
		console.log('b.label--->',b.label);
		var circ = '<i class="fa fa-circle" style="color: '+window.labelColor[b.label]+'"></i> '
		console.log("b.title",b.title,"b.spath",b.spath,'attrs',attrs);
		
		var tname = $('<td>').html('<div>'+circ+(b.title || b.spath)+'</div><div class="battrs">'+attrs+'</div>');
		console.log('tname->',tname);
		
		tr.append(tname);
		var tdvis = $('<td class="colstate colvisible" scope="col"><i class="fa fa-eye" aria-hidden="true"></i></td>').prop('bid',b.id).prop('state',b.invisible).on('mousedown', visible );
		if( !b.invisible ){
			tdvis.addClass('on');
			ctVis++;
		}
		else tdvis.html('<i class="fa fa-eye-slash" aria-hidden="true"></i>')
		tr.append(tdvis)
		var tdlock = $('<td class="colstate collock" scope="col"><i class="fa fa-unlock" aria-hidden="true"></i></td>').prop('bid',b.id).prop('state',b.locked).on('mousedown', locked );
		if( b.locked ){
			tdlock.addClass('on').html('<i class="fa fa-lock" aria-hidden="true"></i>');
			ctLock++;
		}
		tr.append(tdlock)
		body.append(tr);
	})
	
	// Ensure trackData and annotations exist
	if (trackData && trackData.annotations && trackData.annotations.boxes) {
		let validLabels = boxes.map(box => box.label);
		trackData.annotations.boxes = trackData.annotations.boxes.filter(item => validLabels.includes(item.label));
	}

	// if(window.addMode =='polymode' || window.addMode =='brushmode'){    //autoselect polygon tool.
	// 	listClick();          //if add 'boxmode' the bouding box delete option not work.
	// }
	if( !ctBox ) body.append('<tr><td colspan="3" class="empty">(no boxes created)</td></tr>')
	if( ctVis == ctBox ){
		thvis.prop('state',false);
		thvis.html('<i class="fa fa-eye" aria-hidden="true"></i>').addClass('on');
	}
	else {
		thvis.prop('state',true);
	}

	if( ctLock == ctBox ){
		thlock.prop('state',true);
		thlock.html('<i class="fa fa-lock" aria-hidden="true"></i>').addClass('on');
	}
	else {
		thlock.prop('state',false);
	}

	function visibleAll(ev)
	{
		var state = !thvis.prop('state');
		bids.forEach( id => window.setVisible( id, state ) );
	}
	function visible(ev)
	{
		ev.preventDefault();
		window.setVisible($(this).prop('bid'), $(this).prop('state') == false );
		return false;
	}


	function lockedAll(ev)
	{
		var state = !thlock.prop('state');
		bids.forEach( id => window.setLocked( id, state ) );
	}
	function locked(ev)
	{
		ev.preventDefault();
		window.setLocked($(this).prop('bid'), !$(this).prop('state') );
		return false;
	}



	function listOver()
	{
		
		// $(this).addClass( 'bover' );
		window.setOver( $(this).prop('bid') );
	}
	function listOut()
	{
		
		// $(this).removeClass( 'bover' );
		window.setOver( null );
	}
	function listClick(ev) 
	{
		if(window.addMode =='polymode' || window.addMode =='brushmode'){
			window.setSelected( $(this).prop('bid') )
		}
		else{
		console.log( 'target', ev.target )
		if($(ev.target).closest('td').hasClass('colstate') ) return;
		console.log( 'listClick', $(this).prop('bid') );
		window.setSelected( $(this).prop('bid') )
		}
	}
}


function showVersion(s)
{
	$('#version').remove();
	$('#controlpanel').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html('Version: '+s)
		.css({fontSize: '12px', color: '#aaaaaa'})
	);
}


window.opacityVal = 50;
window.brighVal = 50;

$(window).on('resize', function(){ showFrame(0)})

showVersion('developer');


function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) && !isarray(o)) return false;
	return Object.keys(o).length > 0;
}


function showHide( o, cond )
{
	if( cond ) o.show();
	else o.hide();
}

function displayMessages()
{
	var descriptor = trackData.scene;
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = trackData.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').unbind('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').unbind('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}

	trackData.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	show();
}


var questionMode = false;
var currentQuestion = 0;


var blockEdit = false;
var review_mode = false;
var declined = false;
var claimed = false;
var released = false;
var claimTask = false;
var releaseTask = false;
var initComplete = false;

function taskLocked() {
	descriptor = trackData;
	if( !initComplete ) return;
	if( descriptor.task_can_claim ) {
		var lockTxt = "You don't own this task on it's current state. Therefore annotations can't be created or modified.<br><br>You may <b>claim</b> the task and become the task owner as <b>"+descriptor.task_role+"</b>";
	}
	else var lockTxt = "You don't own this task on it's current state. Therefore annotations can't be created or modified.";
	// lockTxt = '<table class="alert-table"><tr><td><i class="fa fa-lock alert-icon"></i></td><td>'+lockTxt+'</td></tr></table>';
	myAlert( '<i class="fa fa-lock alert-icon"></i> Task Locked', lockTxt )
	// console.trace('locked');
	return false;
}


function fixButtons(descriptor) {
	$('.task-button').hide().css({width:'100%'});
	$('.claim-button').html('Claim Task as '+descriptor.task_role)
	if( descriptor.blockEdit ) {
		if( descriptor.task_can_claim ) {
			$('.claim-button').show();
			// $('#resumeLater').hide();
		}
		$('#resumeLater').hide();
	}
	else {
		$('.claim-button').hide();
		$('.submit-button').show();
		$('.autolabel-button').show();
		$('#resumeLater').show();
		if( descriptor.task_can_decline ) $('.decline-button').show();
		if( descriptor.task_can_release ) {
			$('.release-button').show();
		}
	}
	reviewMode = descriptor.reviewMode
	if( reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	blockEdit = descriptor.blockEdit;
	$('.maincontent').find('select').attr('disabled', blockEdit)
	
	
	// $('#right').find('select').attr('disabled', blockEdit)
}

function setButtons(descriptor,form) {
	$('#submitButton').removeClass('mt-2').addClass('mr-2').addClass('submit-button').addClass('task-button');
	var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim');
	$('#submitButton').before(claimBtn);
	claimBtn.on('click', function () {
		claimTask(descriptor);
	});
	var declineBtn = $('<button type="submit" class="btn btn-primary btn-danger mr-2 task-button decline-button">').html('Decline');
	$('#submitButton').after(declineBtn);
	declineBtn.on('click', function () {
		frm.myAlert('Decline Task', 'Please provide a reason for declining the task.<br><textarea id="decline_reason" placeholder="Enter reason" class="export-reason form-control mb-2"></textarea>', 'Ok', function(){
			declined = claimed = released = false;
			declined = true;
			if (form) form.submit();
			else {
				declined = true;
				adlSubmit();
			}
		}, 'Cancel' );
		
	});
	var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('Release');
	declineBtn.after(releaseBtn);
	releaseBtn.on('click', function () {
		releaseTask(descriptor);
	});
	descriptor.fixButtons = fixButtons;
	console.log('redd', descriptor)
	fixButtons(descriptor);
}


function start(desc) {
    var descriptor = trackData.scene;
    window.descriptor = descriptor;
	reviewMode = trackData.reviewMode ? true : false;

	if( trackData.metadata ) {
		var info = $('.media-metadata');
		info.html('');
		var out = [];
		for( var k in trackData.metadata ) {
			out.push( '<b>'+k+':</b>' );
			out.push( trackData.metadata[k] )
		}
		info.html(out.join(' '));
		info.attr('title', info.text()).off('click').on('click', function(ev) {
			if( ev.ctrlKey ){
				var md = trackData.metadata.TaskId;
				var msg = 'Task Id Saved to clipboard';
			}
			else {
				var md = JSON.stringify(trackData.metadata,null,'\t');
				var msg = 'The task matadata was copied to the clipboard';
			}
			saveClipboard( md );
			myAlert('Metadata Copied', msg, 'Ok')
			setTimeout( function(){
				$("#modal-close")[0].click();
			}, 3000  )
		})
	}


    if( scriptMode == 'template' ) $('#resumeLater').hide();
    $('#reviewer-fields').hide();
    $('#annotator_notes').show();
	if( reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !trackData.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	if( !exists( trackData.messages) ) $('#messages').hide();
	else displayMessages();
	var now = getsec();
	if( !trackData.scene.elapsedTime )
	{
		trackData.scene.elapsedTime = 0;
		if( !trackData.scene.jobStart ) trackData.scene.jobStart = now;
	}
    // else if( !descriptor.tsSeconds ) descriptor.elapsedTime /= 1000;
	trackData.scene.sessionStart = now;
	// console.log( 'TIME', trackData.scene.elapsedTime, trackData.scene.sessionStart )
	window.trackData = trackData;

    if( scriptMode != 'template' )
    {
        $(document.body).css({overflow:'hidden'});
    }
	if( descriptor.review ) {
		$('#reviewer_notes').val(descriptor.review.note)
		$('#reviewer_rate').val(descriptor.review.rate)
		
	}
	if( !descriptor.attributes ) descriptor.attributes = {};
	var addNotes = $('#annotator_notes');
    addNotes.val(descriptor.attributes["Aditional Notes"] || "" );
    addNotes.on('change', updateNotes ).on('blur', updateNotes );
    function updateNotes(){ descriptor.attributes["Aditional Notes"] = $(this).val(); updateAnnotations() };

	var form = document.querySelector('crowd-form');

	setButtons(trackData,form)
    // if (trackData.canDecline ) {
    //     $('#submitButton').removeClass('mt-2').addClass('mr-2');
    //     var decline = $('<button type="submit" class="btn btn-primary btn-danger mr-2 bbox-decline">').html('Decline Task');
    //     $('#submitButton').after(decline);
    //     decline.on('click', function () {
    //         declined = true;
    //         adlSubmit()();
    //     });
    // }
	initComplete = true;
}

var claimTask = function() {
	descriptor.blockEdit = blockEdit = false;
	fixButtons(descriptor);
	// alert( 'claim')
}

var releaseTask = function() {
	descriptor.blockEdit = blockEdit = true;
	fixButtons(descriptor);
}




// https://github.com/w8r/martinez
(function () {
  'use strict';

  function DEFAULT_COMPARE (a, b) { return a > b ? 1 : a < b ? -1 : 0; }

  var SplayTree = function SplayTree(compare, noDuplicates) {
    if ( compare === void 0 ) compare = DEFAULT_COMPARE;
    if ( noDuplicates === void 0 ) noDuplicates = false;

    this._compare = compare;
    this._root = null;
    this._size = 0;
    this._noDuplicates = !!noDuplicates;
  };

  var prototypeAccessors = { size: { configurable: true } };


  SplayTree.prototype.rotateLeft = function rotateLeft (x) {
    var y = x.right;
    if (y) {
      x.right = y.left;
      if (y.left) { y.left.parent = x; }
      y.parent = x.parent;
    }

    if (!x.parent)              { this._root = y; }
    else if (x === x.parent.left) { x.parent.left = y; }
    else                        { x.parent.right = y; }
    if (y) { y.left = x; }
    x.parent = y;
  };


  SplayTree.prototype.rotateRight = function rotateRight (x) {
    var y = x.left;
    if (y) {
      x.left = y.right;
      if (y.right) { y.right.parent = x; }
      y.parent = x.parent;
    }

    if (!x.parent)             { this._root = y; }
    else if(x === x.parent.left) { x.parent.left = y; }
    else                       { x.parent.right = y; }
    if (y) { y.right = x; }
    x.parent = y;
  };


  SplayTree.prototype._splay = function _splay (x) {
    while (x.parent) {
      var p = x.parent;
      if (!p.parent) {
        if (p.left === x) { this.rotateRight(p); }
        else            { this.rotateLeft(p); }
      } else if (p.left === x && p.parent.left === p) {
        this.rotateRight(p.parent);
        this.rotateRight(p);
      } else if (p.right === x && p.parent.right === p) {
        this.rotateLeft(p.parent);
        this.rotateLeft(p);
      } else if (p.left === x && p.parent.right === p) {
        this.rotateRight(p);
        this.rotateLeft(p);
      } else {
        this.rotateLeft(p);
        this.rotateRight(p);
      }
    }
  };


  SplayTree.prototype.splay = function splay (x) {
    var p, gp, ggp, l, r;

    while (x.parent) {
      p = x.parent;
      gp = p.parent;

      if (gp && gp.parent) {
        ggp = gp.parent;
        if (ggp.left === gp) { ggp.left= x; }
        else               { ggp.right = x; }
        x.parent = ggp;
      } else {
        x.parent = null;
        this._root = x;
      }

      l = x.left; r = x.right;

      if (x === p.left) { // left
        if (gp) {
          if (gp.left === p) {
            /* zig-zig */
            if (p.right) {
              gp.left = p.right;
              gp.left.parent = gp;
            } else { gp.left = null; }

            p.right = gp;
            gp.parent = p;
          } else {
            /* zig-zag */
            if (l) {
              gp.right = l;
              l.parent = gp;
            } else { gp.right = null; }

            x.left  = gp;
            gp.parent = x;
          }
        }
        if (r) {
          p.left = r;
          r.parent = p;
        } else { p.left = null; }

        x.right= p;
        p.parent = x;
      } else { // right
        if (gp) {
          if (gp.right === p) {
            /* zig-zig */
            if (p.left) {
              gp.right = p.left;
              gp.right.parent = gp;
            } else { gp.right = null; }

            p.left = gp;
            gp.parent = p;
          } else {
            /* zig-zag */
            if (r) {
              gp.left = r;
              r.parent = gp;
            } else { gp.left = null; }

            x.right = gp;
            gp.parent = x;
          }
        }
        if (l) {
          p.right = l;
          l.parent = p;
        } else { p.right = null; }

        x.left = p;
        p.parent = x;
      }
    }
  };


  SplayTree.prototype.replace = function replace (u, v) {
    if (!u.parent) { this._root = v; }
    else if (u === u.parent.left) { u.parent.left = v; }
    else { u.parent.right = v; }
    if (v) { v.parent = u.parent; }
  };


  SplayTree.prototype.minNode = function minNode (u) {
      if ( u === void 0 ) u = this._root;

    if (u) { while (u.left) { u = u.left; } }
    return u;
  };


  SplayTree.prototype.maxNode = function maxNode (u) {
      if ( u === void 0 ) u = this._root;

    if (u) { while (u.right) { u = u.right; } }
    return u;
  };


  SplayTree.prototype.insert = function insert (key, data) {
    var z = this._root;
    var p = null;
    var comp = this._compare;
    var cmp;

    if (this._noDuplicates) {
      while (z) {
        p = z;
        cmp = comp(z.key, key);
        if (cmp === 0) { return; }
        else if (comp(z.key, key) < 0) { z = z.right; }
        else { z = z.left; }
      }
    } else {
      while (z) {
        p = z;
        if (comp(z.key, key) < 0) { z = z.right; }
        else { z = z.left; }
      }
    }

    z = { key: key, data: data, left: null, right: null, parent: p };

    if (!p)                        { this._root = z; }
    else if (comp(p.key, z.key) < 0) { p.right = z; }
    else                           { p.left= z; }

    this.splay(z);
    this._size++;
    return z;
  };


  SplayTree.prototype.find = function find (key) {
    var z  = this._root;
    var comp = this._compare;
    while (z) {
      var cmp = comp(z.key, key);
      if    (cmp < 0) { z = z.right; }
      else if (cmp > 0) { z = z.left; }
      else            { return z; }
    }
    return null;
  };

  /**
   * Whether the tree contains a node with the given key
   * @param{Key} key
   * @return {boolean} true/false
   */
  SplayTree.prototype.contains = function contains (key) {
    var node     = this._root;
    var comparator = this._compare;
    while (node){
      var cmp = comparator(key, node.key);
      if    (cmp === 0) { return true; }
      else if (cmp < 0) { node = node.left; }
      else              { node = node.right; }
    }

    return false;
  };


  SplayTree.prototype.remove = function remove (key) {
    var z = this.find(key);

    if (!z) { return false; }

    this.splay(z);

    if (!z.left) { this.replace(z, z.right); }
    else if (!z.right) { this.replace(z, z.left); }
    else {
      var y = this.minNode(z.right);
      if (y.parent !== z) {
        this.replace(y, y.right);
        y.right = z.right;
        y.right.parent = y;
      }
      this.replace(z, y);
      y.left = z.left;
      y.left.parent = y;
    }

    this._size--;
    return true;
  };


  SplayTree.prototype.removeNode = function removeNode (z) {
    if (!z) { return false; }

    this.splay(z);

    if (!z.left) { this.replace(z, z.right); }
    else if (!z.right) { this.replace(z, z.left); }
    else {
      var y = this.minNode(z.right);
      if (y.parent !== z) {
        this.replace(y, y.right);
        y.right = z.right;
        y.right.parent = y;
      }
      this.replace(z, y);
      y.left = z.left;
      y.left.parent = y;
    }

    this._size--;
    return true;
  };


  SplayTree.prototype.erase = function erase (key) {
    var z = this.find(key);
    if (!z) { return; }

    this.splay(z);

    var s = z.left;
    var t = z.right;

    var sMax = null;
    if (s) {
      s.parent = null;
      sMax = this.maxNode(s);
      this.splay(sMax);
      this._root = sMax;
    }
    if (t) {
      if (s) { sMax.right = t; }
      else { this._root = t; }
      t.parent = sMax;
    }

    this._size--;
  };

  /**
   * Removes and returns the node with smallest key
   * @return {?Node}
   */
  SplayTree.prototype.pop = function pop () {
    var node = this._root, returnValue = null;
    if (node) {
      while (node.left) { node = node.left; }
      returnValue = { key: node.key, data: node.data };
      this.remove(node.key);
    }
    return returnValue;
  };


  /* eslint-disable class-methods-use-this */

  /**
   * Successor node
   * @param{Node} node
   * @return {?Node}
   */
  SplayTree.prototype.next = function next (node) {
    var successor = node;
    if (successor) {
      if (successor.right) {
        successor = successor.right;
        while (successor && successor.left) { successor = successor.left; }
      } else {
        successor = node.parent;
        while (successor && successor.right === node) {
          node = successor; successor = successor.parent;
        }
      }
    }
    return successor;
  };


  /**
   * Predecessor node
   * @param{Node} node
   * @return {?Node}
   */
  SplayTree.prototype.prev = function prev (node) {
    var predecessor = node;
    if (predecessor) {
      if (predecessor.left) {
        predecessor = predecessor.left;
        while (predecessor && predecessor.right) { predecessor = predecessor.right; }
      } else {
        predecessor = node.parent;
        while (predecessor && predecessor.left === node) {
          node = predecessor;
          predecessor = predecessor.parent;
        }
      }
    }
    return predecessor;
  };
  /* eslint-enable class-methods-use-this */


  /**
   * @param{forEachCallback} callback
   * @return {SplayTree}
   */
  SplayTree.prototype.forEach = function forEach (callback) {
    var current = this._root;
    var s = [], done = false, i = 0;

    while (!done) {
      // Reach the left most Node of the current Node
      if (current) {
        // Place pointer to a tree node on the stack
        // before traversing the node's left subtree
        s.push(current);
        current = current.left;
      } else {
        // BackTrack from the empty subtree and visit the Node
        // at the top of the stack; however, if the stack is
        // empty you are done
        if (s.length > 0) {
          current = s.pop();
          callback(current, i++);

          // We have visited the node and its left
          // subtree. Now, it's right subtree's turn
          current = current.right;
        } else { done = true; }
      }
    }
    return this;
  };


  /**
   * Walk key range from `low` to `high`. Stops if `fn` returns a value.
   * @param{Key}    low
   * @param{Key}    high
   * @param{Function} fn
   * @param{*?}     ctx
   * @return {SplayTree}
   */
  SplayTree.prototype.range = function range (low, high, fn, ctx) {
    var Q = [];
    var compare = this._compare;
    var node = this._root, cmp;

    while (Q.length !== 0 || node) {
      if (node) {
        Q.push(node);
        node = node.left;
      } else {
        node = Q.pop();
        cmp = compare(node.key, high);
        if (cmp > 0) {
          break;
        } else if (compare(node.key, low) >= 0) {
          if (fn.call(ctx, node)) { return this; } // stop if smth is returned
        }
        node = node.right;
      }
    }
    return this;
  };

  /**
   * Returns all keys in order
   * @return {Array<Key>}
   */
  SplayTree.prototype.keys = function keys () {
    var current = this._root;
    var s = [], r = [], done = false;

    while (!done) {
      if (current) {
        s.push(current);
        current = current.left;
      } else {
        if (s.length > 0) {
          current = s.pop();
          r.push(current.key);
          current = current.right;
        } else { done = true; }
      }
    }
    return r;
  };


  /**
   * Returns `data` fields of all nodes in order.
   * @return {Array<Value>}
   */
  SplayTree.prototype.values = function values () {
    var current = this._root;
    var s = [], r = [], done = false;

    while (!done) {
      if (current) {
        s.push(current);
        current = current.left;
      } else {
        if (s.length > 0) {
          current = s.pop();
          r.push(current.data);
          current = current.right;
        } else { done = true; }
      }
    }
    return r;
  };


  /**
   * Returns node at given index
   * @param{number} index
   * @return {?Node}
   */
  SplayTree.prototype.at = function at (index) {
    // removed after a consideration, more misleading than useful
    // index = index % this.size;
    // if (index < 0) index = this.size - index;

    var current = this._root;
    var s = [], done = false, i = 0;

    while (!done) {
      if (current) {
        s.push(current);
        current = current.left;
      } else {
        if (s.length > 0) {
          current = s.pop();
          if (i === index) { return current; }
          i++;
          current = current.right;
        } else { done = true; }
      }
    }
    return null;
  };

  /**
   * Bulk-load items. Both array have to be same size
   * @param{Array<Key>}  keys
   * @param{Array<Value>}[values]
   * @param{Boolean}     [presort=false] Pre-sort keys and values, using
   *                                       tree's comparator. Sorting is done
   *                                       in-place
   * @return {AVLTree}
   */
  SplayTree.prototype.load = function load (keys, values, presort) {
      if ( keys === void 0 ) keys = [];
      if ( values === void 0 ) values = [];
      if ( presort === void 0 ) presort = false;

    if (this._size !== 0) { throw new Error('bulk-load: tree is not empty'); }
    var size = keys.length;
    if (presort) { sort(keys, values, 0, size - 1, this._compare); }
    this._root = loadRecursive(null, keys, values, 0, size);
    this._size = size;
    return this;
  };


  SplayTree.prototype.min = function min () {
    var node = this.minNode(this._root);
    if (node) { return node.key; }
    else    { return null; }
  };


  SplayTree.prototype.max = function max () {
    var node = this.maxNode(this._root);
    if (node) { return node.key; }
    else    { return null; }
  };

  SplayTree.prototype.isEmpty = function isEmpty () { return this._root === null; };
  prototypeAccessors.size.get = function () { return this._size; };


  /**
   * Create a tree and load it with items
   * @param{Array<Key>}        keys
   * @param{Array<Value>?}      [values]

   * @param{Function?}          [comparator]
   * @param{Boolean?}           [presort=false] Pre-sort keys and values, using
   *                                             tree's comparator. Sorting is done
   *                                             in-place
   * @param{Boolean?}           [noDuplicates=false] Allow duplicates
   * @return {SplayTree}
   */
  SplayTree.createTree = function createTree (keys, values, comparator, presort, noDuplicates) {
    return new SplayTree(comparator, noDuplicates).load(keys, values, presort);
  };

  Object.defineProperties( SplayTree.prototype, prototypeAccessors );


  function loadRecursive (parent, keys, values, start, end) {
    var size = end - start;
    if (size > 0) {
      var middle = start + Math.floor(size / 2);
      var key    = keys[middle];
      var data   = values[middle];
      var node   = { key: key, data: data, parent: parent };
      node.left    = loadRecursive(node, keys, values, start, middle);
      node.right   = loadRecursive(node, keys, values, middle + 1, end);
      return node;
    }
    return null;
  }


  function sort(keys, values, left, right, compare) {
    if (left >= right) { return; }

    var pivot = keys[(left + right) >> 1];
    var i = left - 1;
    var j = right + 1;

    while (true) {
      do { i++; } while (compare(keys[i], pivot) < 0);
      do { j--; } while (compare(keys[j], pivot) > 0);
      if (i >= j) { break; }

      var tmp = keys[i];
      keys[i] = keys[j];
      keys[j] = tmp;

      tmp = values[i];
      values[i] = values[j];
      values[j] = tmp;
    }

    sort(keys, values,  left,     j, compare);
    sort(keys, values, j + 1, right, compare);
  }

  var NORMAL               = 0;
  var NON_CONTRIBUTING     = 1;
  var SAME_TRANSITION      = 2;
  var DIFFERENT_TRANSITION = 3;

  var INTERSECTION = 0;
  var UNION        = 1;
  var DIFFERENCE   = 2;
  var XOR          = 3;

  /**
   * @param  {SweepEvent} event
   * @param  {SweepEvent} prev
   * @param  {Operation} operation
   */
  function computeFields (event, prev, operation) {
    // compute inOut and otherInOut fields
    if (prev === null) {
      event.inOut      = false;
      event.otherInOut = true;

    // previous line segment in sweepline belongs to the same polygon
    } else {
      if (event.isSubject === prev.isSubject) {
        event.inOut      = !prev.inOut;
        event.otherInOut = prev.otherInOut;

      // previous line segment in sweepline belongs to the clipping polygon
      } else {
        event.inOut      = !prev.otherInOut;
        event.otherInOut = prev.isVertical() ? !prev.inOut : prev.inOut;
      }

      // compute prevInResult field
      if (prev) {
        event.prevInResult = (!inResult(prev, operation) || prev.isVertical())
          ? prev.prevInResult : prev;
      }
    }

    // check if the line segment belongs to the Boolean operation
    var isInResult = inResult(event, operation);
    if (isInResult) {
      event.resultTransition = determineResultTransition(event, operation);
    } else {
      event.resultTransition = 0;
    }
  }


  /* eslint-disable indent */
  function inResult(event, operation) {
    switch (event.type) {
      case NORMAL:
        switch (operation) {
          case INTERSECTION:
            return !event.otherInOut;
          case UNION:
            return event.otherInOut;
          case DIFFERENCE:
            // return (event.isSubject && !event.otherInOut) ||
            //         (!event.isSubject && event.otherInOut);
            return (event.isSubject && event.otherInOut) ||
                    (!event.isSubject && !event.otherInOut);
          case XOR:
            return true;
        }
        break;
      case SAME_TRANSITION:
        return operation === INTERSECTION || operation === UNION;
      case DIFFERENT_TRANSITION:
        return operation === DIFFERENCE;
      case NON_CONTRIBUTING:
        return false;
    }
    return false;
  }
  /* eslint-enable indent */


  function determineResultTransition(event, operation) {
    var thisIn = !event.inOut;
    var thatIn = !event.otherInOut;

    var isIn;
    switch (operation) {
      case INTERSECTION:
        isIn = thisIn && thatIn; break;
      case UNION:
        isIn = thisIn || thatIn; break;
      case XOR:
        isIn = thisIn ^ thatIn; break;
      case DIFFERENCE:
        if (event.isSubject) {
          isIn = thisIn && !thatIn;
        } else {
          isIn = thatIn && !thisIn;
        }
        break;
    }
    return isIn ? +1 : -1;
  }

  var SweepEvent = function SweepEvent (point, left, otherEvent, isSubject, edgeType) {

    /**
     * Is left endpoint?
     * @type {Boolean}
     */
    this.left = left;

    /**
     * @type {Array.<Number>}
     */
    this.point = point;

    /**
     * Other edge reference
     * @type {SweepEvent}
     */
    this.otherEvent = otherEvent;

    /**
     * Belongs to source or clipping polygon
     * @type {Boolean}
     */
    this.isSubject = isSubject;

    /**
     * Edge contribution type
     * @type {Number}
     */
    this.type = edgeType || NORMAL;


    /**
     * In-out transition for the sweepline crossing polygon
     * @type {Boolean}
     */
    this.inOut = false;


    /**
     * @type {Boolean}
     */
    this.otherInOut = false;

    /**
     * Previous event in result?
     * @type {SweepEvent}
     */
    this.prevInResult = null;

    /**
     * Type of result transition (0 = not in result, +1 = out-in, -1, in-out)
     * @type {Number}
     */
    this.resultTransition = 0;

    // connection step

    /**
     * @type {Number}
     */
    this.otherPos = -1;

    /**
     * @type {Number}
     */
    this.outputContourId = -1;

    this.isExteriorRing = true; // TODO: Looks unused, remove?
  };

  var prototypeAccessors$1 = { inResult: { configurable: true } };


  /**
   * @param{Array.<Number>}p
   * @return {Boolean}
   */
  SweepEvent.prototype.isBelow = function isBelow (p) {
    var p0 = this.point, p1 = this.otherEvent.point;
    return this.left
      ? (p0[0] - p[0]) * (p1[1] - p[1]) - (p1[0] - p[0]) * (p0[1] - p[1]) > 0
      // signedArea(this.point, this.otherEvent.point, p) > 0 :
      : (p1[0] - p[0]) * (p0[1] - p[1]) - (p0[0] - p[0]) * (p1[1] - p[1]) > 0;
      //signedArea(this.otherEvent.point, this.point, p) > 0;
  };


  /**
   * @param{Array.<Number>}p
   * @return {Boolean}
   */
  SweepEvent.prototype.isAbove = function isAbove (p) {
    return !this.isBelow(p);
  };


  /**
   * @return {Boolean}
   */
  SweepEvent.prototype.isVertical = function isVertical () {
    return this.point[0] === this.otherEvent.point[0];
  };


  /**
   * Does event belong to result?
   * @return {Boolean}
   */
  prototypeAccessors$1.inResult.get = function () {
    return this.resultTransition !== 0;
  };


  SweepEvent.prototype.clone = function clone () {
    var copy = new SweepEvent(
      this.point, this.left, this.otherEvent, this.isSubject, this.type);

    copy.contourId      = this.contourId;
    copy.resultTransition = this.resultTransition;
    copy.prevInResult   = this.prevInResult;
    copy.isExteriorRing = this.isExteriorRing;
    copy.inOut          = this.inOut;
    copy.otherInOut     = this.otherInOut;

    return copy;
  };

  Object.defineProperties( SweepEvent.prototype, prototypeAccessors$1 );

  function equals(p1, p2) {
    if (p1[0] === p2[0]) {
      if (p1[1] === p2[1]) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  // const EPSILON = 1e-9;
  // const abs = Math.abs;
  // TODO https://github.com/w8r/martinez/issues/6#issuecomment-262847164
  // Precision problem.
  //
  // module.exports = function equals(p1, p2) {
  //   return abs(p1[0] - p2[0]) <= EPSILON && abs(p1[1] - p2[1]) <= EPSILON;
  // };

  var epsilon = 1.1102230246251565e-16;
  var splitter = 134217729;
  var resulterrbound = (3 + 8 * epsilon) * epsilon;

  // fast_expansion_sum_zeroelim routine from oritinal code
  function sum(elen, e, flen, f, h) {
      var Q, Qnew, hh, bvirt;
      var enow = e[0];
      var fnow = f[0];
      var eindex = 0;
      var findex = 0;
      if ((fnow > enow) === (fnow > -enow)) {
          Q = enow;
          enow = e[++eindex];
      } else {
          Q = fnow;
          fnow = f[++findex];
      }
      var hindex = 0;
      if (eindex < elen && findex < flen) {
          if ((fnow > enow) === (fnow > -enow)) {
              Qnew = enow + Q;
              hh = Q - (Qnew - enow);
              enow = e[++eindex];
          } else {
              Qnew = fnow + Q;
              hh = Q - (Qnew - fnow);
              fnow = f[++findex];
          }
          Q = Qnew;
          if (hh !== 0) {
              h[hindex++] = hh;
          }
          while (eindex < elen && findex < flen) {
              if ((fnow > enow) === (fnow > -enow)) {
                  Qnew = Q + enow;
                  bvirt = Qnew - Q;
                  hh = Q - (Qnew - bvirt) + (enow - bvirt);
                  enow = e[++eindex];
              } else {
                  Qnew = Q + fnow;
                  bvirt = Qnew - Q;
                  hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                  fnow = f[++findex];
              }
              Q = Qnew;
              if (hh !== 0) {
                  h[hindex++] = hh;
              }
          }
      }
      while (eindex < elen) {
          Qnew = Q + enow;
          bvirt = Qnew - Q;
          hh = Q - (Qnew - bvirt) + (enow - bvirt);
          enow = e[++eindex];
          Q = Qnew;
          if (hh !== 0) {
              h[hindex++] = hh;
          }
      }
      while (findex < flen) {
          Qnew = Q + fnow;
          bvirt = Qnew - Q;
          hh = Q - (Qnew - bvirt) + (fnow - bvirt);
          fnow = f[++findex];
          Q = Qnew;
          if (hh !== 0) {
              h[hindex++] = hh;
          }
      }
      if (Q !== 0 || hindex === 0) {
          h[hindex++] = Q;
      }
      return hindex;
  }

  function estimate(elen, e) {
      var Q = e[0];
      for (var i = 1; i < elen; i++) { Q += e[i]; }
      return Q;
  }

  function vec(n) {
      return new Float64Array(n);
  }

  var ccwerrboundA = (3 + 16 * epsilon) * epsilon;
  var ccwerrboundB = (2 + 12 * epsilon) * epsilon;
  var ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;

  var B = vec(4);
  var C1 = vec(8);
  var C2 = vec(12);
  var D = vec(16);
  var u = vec(4);

  function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
      var acxtail, acytail, bcxtail, bcytail;
      var bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;

      var acx = ax - cx;
      var bcx = bx - cx;
      var acy = ay - cy;
      var bcy = by - cy;

      s1 = acx * bcy;
      c = splitter * acx;
      ahi = c - (c - acx);
      alo = acx - ahi;
      c = splitter * bcy;
      bhi = c - (c - bcy);
      blo = bcy - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acy * bcx;
      c = splitter * acy;
      ahi = c - (c - acy);
      alo = acy - ahi;
      c = splitter * bcx;
      bhi = c - (c - bcx);
      blo = bcx - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      B[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      B[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      B[2] = _j - (u3 - bvirt) + (_i - bvirt);
      B[3] = u3;

      var det = estimate(4, B);
      var errbound = ccwerrboundB * detsum;
      if (det >= errbound || -det >= errbound) {
          return det;
      }

      bvirt = ax - acx;
      acxtail = ax - (acx + bvirt) + (bvirt - cx);
      bvirt = bx - bcx;
      bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
      bvirt = ay - acy;
      acytail = ay - (acy + bvirt) + (bvirt - cy);
      bvirt = by - bcy;
      bcytail = by - (bcy + bvirt) + (bvirt - cy);

      if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
          return det;
      }

      errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
      det += (acx * bcytail + bcy * acxtail) - (acy * bcxtail + bcx * acytail);
      if (det >= errbound || -det >= errbound) { return det; }

      s1 = acxtail * bcy;
      c = splitter * acxtail;
      ahi = c - (c - acxtail);
      alo = acxtail - ahi;
      c = splitter * bcy;
      bhi = c - (c - bcy);
      blo = bcy - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acytail * bcx;
      c = splitter * acytail;
      ahi = c - (c - acytail);
      alo = acytail - ahi;
      c = splitter * bcx;
      bhi = c - (c - bcx);
      blo = bcx - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      var C1len = sum(4, B, 4, u, C1);

      s1 = acx * bcytail;
      c = splitter * acx;
      ahi = c - (c - acx);
      alo = acx - ahi;
      c = splitter * bcytail;
      bhi = c - (c - bcytail);
      blo = bcytail - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acy * bcxtail;
      c = splitter * acy;
      ahi = c - (c - acy);
      alo = acy - ahi;
      c = splitter * bcxtail;
      bhi = c - (c - bcxtail);
      blo = bcxtail - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      var C2len = sum(C1len, C1, 4, u, C2);

      s1 = acxtail * bcytail;
      c = splitter * acxtail;
      ahi = c - (c - acxtail);
      alo = acxtail - ahi;
      c = splitter * bcytail;
      bhi = c - (c - bcytail);
      blo = bcytail - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acytail * bcxtail;
      c = splitter * acytail;
      ahi = c - (c - acytail);
      alo = acytail - ahi;
      c = splitter * bcxtail;
      bhi = c - (c - bcxtail);
      blo = bcxtail - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      var Dlen = sum(C2len, C2, 4, u, D);

      return D[Dlen - 1];
  }

  function orient2d(ax, ay, bx, by, cx, cy) {
      var detleft = (ay - cy) * (bx - cx);
      var detright = (ax - cx) * (by - cy);
      var det = detleft - detright;

      if (detleft === 0 || detright === 0 || (detleft > 0) !== (detright > 0)) { return det; }

      var detsum = Math.abs(detleft + detright);
      if (Math.abs(det) >= ccwerrboundA * detsum) { return det; }

      return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
  }

  /**
   * Signed area of the triangle (p0, p1, p2)
   * @param  {Array.<Number>} p0
   * @param  {Array.<Number>} p1
   * @param  {Array.<Number>} p2
   * @return {Number}
   */
  function signedArea(p0, p1, p2) {
    var res = orient2d(p0[0], p0[1], p1[0], p1[1], p2[0], p2[1]);
    if (res > 0) { return -1; }
    if (res < 0) { return 1; }
    return 0;
  }

  /**
   * @param  {SweepEvent} e1
   * @param  {SweepEvent} e2
   * @return {Number}
   */
  function compareEvents(e1, e2) {
    var p1 = e1.point;
    var p2 = e2.point;

    // Different x-coordinate
    if (p1[0] > p2[0]) { return 1; }
    if (p1[0] < p2[0]) { return -1; }

    // Different points, but same x-coordinate
    // Event with lower y-coordinate is processed first
    if (p1[1] !== p2[1]) { return p1[1] > p2[1] ? 1 : -1; }

    return specialCases(e1, e2, p1);
  }


  /* eslint-disable no-unused-vars */
  function specialCases(e1, e2, p1, p2) {
    // Same coordinates, but one is a left endpoint and the other is
    // a right endpoint. The right endpoint is processed first
    if (e1.left !== e2.left)
      { return e1.left ? 1 : -1; }

    // const p2 = e1.otherEvent.point, p3 = e2.otherEvent.point;
    // const sa = (p1[0] - p3[0]) * (p2[1] - p3[1]) - (p2[0] - p3[0]) * (p1[1] - p3[1])
    // Same coordinates, both events
    // are left endpoints or right endpoints.
    // not collinear
    if (signedArea(p1, e1.otherEvent.point, e2.otherEvent.point) !== 0) {
      // the event associate to the bottom segment is processed first
      return (!e1.isBelow(e2.otherEvent.point)) ? 1 : -1;
    }

    return (!e1.isSubject && e2.isSubject) ? 1 : -1;
  }
  /* eslint-enable no-unused-vars */

  /**
   * @param  {SweepEvent} se
   * @param  {Array.<Number>} p
   * @param  {Queue} queue
   * @return {Queue}
   */
  function divideSegment(se, p, queue)  {
    var r = new SweepEvent(p, false, se,            se.isSubject);
    var l = new SweepEvent(p, true,  se.otherEvent, se.isSubject);

    /* eslint-disable no-console */
    if (equals(se.point, se.otherEvent.point)) {
      console.warn('what is that, a collapsed segment?', se);
    }
    /* eslint-enable no-console */

    r.contourId = l.contourId = se.contourId;

    // avoid a rounding error. The left event would be processed after the right event
    if (compareEvents(l, se.otherEvent) > 0) {
      se.otherEvent.left = true;
      l.left = false;
    }

    // avoid a rounding error. The left event would be processed after the right event
    // if (compareEvents(se, r) > 0) {}

    se.otherEvent.otherEvent = l;
    se.otherEvent = r;

    queue.push(l);
    queue.push(r);

    return queue;
  }

  //const EPS = 1e-9;

  /**
   * Finds the magnitude of the cross product of two vectors (if we pretend
   * they're in three dimensions)
   *
   * @param {Object} a First vector
   * @param {Object} b Second vector
   * @private
   * @returns {Number} The magnitude of the cross product
   */
  function crossProduct(a, b) {
    return (a[0] * b[1]) - (a[1] * b[0]);
  }

  /**
   * Finds the dot product of two vectors.
   *
   * @param {Object} a First vector
   * @param {Object} b Second vector
   * @private
   * @returns {Number} The dot product
   */
  function dotProduct(a, b) {
    return (a[0] * b[0]) + (a[1] * b[1]);
  }

  /**
   * Finds the intersection (if any) between two line segments a and b, given the
   * line segments' end points a1, a2 and b1, b2.
   *
   * This algorithm is based on Schneider and Eberly.
   * http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf
   * Page 244.
   *
   * @param {Array.<Number>} a1 point of first line
   * @param {Array.<Number>} a2 point of first line
   * @param {Array.<Number>} b1 point of second line
   * @param {Array.<Number>} b2 point of second line
   * @param {Boolean=}       noEndpointTouch whether to skip single touchpoints
   *                                         (meaning connected segments) as
   *                                         intersections
   * @returns {Array.<Array.<Number>>|Null} If the lines intersect, the point of
   * intersection. If they overlap, the two end points of the overlapping segment.
   * Otherwise, null.
   */
  function intersection (a1, a2, b1, b2, noEndpointTouch) {
    // The algorithm expects our lines in the form P + sd, where P is a point,
    // s is on the interval [0, 1], and d is a vector.
    // We are passed two points. P can be the first point of each pair. The
    // vector, then, could be thought of as the distance (in x and y components)
    // from the first point to the second point.
    // So first, let's make our vectors:
    var va = [a2[0] - a1[0], a2[1] - a1[1]];
    var vb = [b2[0] - b1[0], b2[1] - b1[1]];
    // We also define a function to convert back to regular point form:

    /* eslint-disable arrow-body-style */

    function toPoint(p, s, d) {
      return [
        p[0] + s * d[0],
        p[1] + s * d[1]
      ];
    }

    /* eslint-enable arrow-body-style */

    // The rest is pretty much a straight port of the algorithm.
    var e = [b1[0] - a1[0], b1[1] - a1[1]];
    var kross    = crossProduct(va, vb);
    var sqrKross = kross * kross;
    var sqrLenA  = dotProduct(va, va);
    //const sqrLenB  = dotProduct(vb, vb);

    // Check for line intersection. This works because of the properties of the
    // cross product -- specifically, two vectors are parallel if and only if the
    // cross product is the 0 vector. The full calculation involves relative error
    // to account for possible very small line segments. See Schneider & Eberly
    // for details.
    if (sqrKross > 0/* EPS * sqrLenB * sqLenA */) {
      // If they're not parallel, then (because these are line segments) they
      // still might not actually intersect. This code checks that the
      // intersection point of the lines is actually on both line segments.
      var s = crossProduct(e, vb) / kross;
      if (s < 0 || s > 1) {
        // not on line segment a
        return null;
      }
      var t = crossProduct(e, va) / kross;
      if (t < 0 || t > 1) {
        // not on line segment b
        return null;
      }
      if (s === 0 || s === 1) {
        // on an endpoint of line segment a
        return noEndpointTouch ? null : [toPoint(a1, s, va)];
      }
      if (t === 0 || t === 1) {
        // on an endpoint of line segment b
        return noEndpointTouch ? null : [toPoint(b1, t, vb)];
      }
      return [toPoint(a1, s, va)];
    }

    // If we've reached this point, then the lines are either parallel or the
    // same, but the segments could overlap partially or fully, or not at all.
    // So we need to find the overlap, if any. To do that, we can use e, which is
    // the (vector) difference between the two initial points. If this is parallel
    // with the line itself, then the two lines are the same line, and there will
    // be overlap.
    //const sqrLenE = dotProduct(e, e);
    kross = crossProduct(e, va);
    sqrKross = kross * kross;

    if (sqrKross > 0 /* EPS * sqLenB * sqLenE */) {
    // Lines are just parallel, not the same. No overlap.
      return null;
    }

    var sa = dotProduct(va, e) / sqrLenA;
    var sb = sa + dotProduct(va, vb) / sqrLenA;
    var smin = Math.min(sa, sb);
    var smax = Math.max(sa, sb);

    // this is, essentially, the FindIntersection acting on floats from
    // Schneider & Eberly, just inlined into this function.
    if (smin <= 1 && smax >= 0) {

      // overlap on an end point
      if (smin === 1) {
        return noEndpointTouch ? null : [toPoint(a1, smin > 0 ? smin : 0, va)];
      }

      if (smax === 0) {
        return noEndpointTouch ? null : [toPoint(a1, smax < 1 ? smax : 1, va)];
      }

      if (noEndpointTouch && smin === 0 && smax === 1) { return null; }

      // There's overlap on a segment -- two points of intersection. Return both.
      return [
        toPoint(a1, smin > 0 ? smin : 0, va),
        toPoint(a1, smax < 1 ? smax : 1, va)
      ];
    }

    return null;
  }

  /**
   * @param  {SweepEvent} se1
   * @param  {SweepEvent} se2
   * @param  {Queue}      queue
   * @return {Number}
   */
  function possibleIntersection (se1, se2, queue) {
    // that disallows self-intersecting polygons,
    // did cost us half a day, so I'll leave it
    // out of respect
    // if (se1.isSubject === se2.isSubject) return;
    var inter = intersection(
      se1.point, se1.otherEvent.point,
      se2.point, se2.otherEvent.point
    );

    var nintersections = inter ? inter.length : 0;
    if (nintersections === 0) { return 0; } // no intersection

    // the line segments intersect at an endpoint of both line segments
    if ((nintersections === 1) &&
        (equals(se1.point, se2.point) ||
         equals(se1.otherEvent.point, se2.otherEvent.point))) {
      return 0;
    }

    if (nintersections === 2 && se1.isSubject === se2.isSubject) {
      // if(se1.contourId === se2.contourId){
      // console.warn('Edges of the same polygon overlap',
      //   se1.point, se1.otherEvent.point, se2.point, se2.otherEvent.point);
      // }
      //throw new Error('Edges of the same polygon overlap');
      return 0;
    }

    // The line segments associated to se1 and se2 intersect
    if (nintersections === 1) {

      // if the intersection point is not an endpoint of se1
      if (!equals(se1.point, inter[0]) && !equals(se1.otherEvent.point, inter[0])) {
        divideSegment(se1, inter[0], queue);
      }

      // if the intersection point is not an endpoint of se2
      if (!equals(se2.point, inter[0]) && !equals(se2.otherEvent.point, inter[0])) {
        divideSegment(se2, inter[0], queue);
      }
      return 1;
    }

    // The line segments associated to se1 and se2 overlap
    var events        = [];
    var leftCoincide  = false;
    var rightCoincide = false;

    if (equals(se1.point, se2.point)) {
      leftCoincide = true; // linked
    } else if (compareEvents(se1, se2) === 1) {
      events.push(se2, se1);
    } else {
      events.push(se1, se2);
    }

    if (equals(se1.otherEvent.point, se2.otherEvent.point)) {
      rightCoincide = true;
    } else if (compareEvents(se1.otherEvent, se2.otherEvent) === 1) {
      events.push(se2.otherEvent, se1.otherEvent);
    } else {
      events.push(se1.otherEvent, se2.otherEvent);
    }

    if ((leftCoincide && rightCoincide) || leftCoincide) {
      // both line segments are equal or share the left endpoint
      se2.type = NON_CONTRIBUTING;
      se1.type = (se2.inOut === se1.inOut)
        ? SAME_TRANSITION : DIFFERENT_TRANSITION;

      if (leftCoincide && !rightCoincide) {
        // honestly no idea, but changing events selection from [2, 1]
        // to [0, 1] fixes the overlapping self-intersecting polygons issue
        divideSegment(events[1].otherEvent, events[0].point, queue);
      }
      return 2;
    }

    // the line segments share the right endpoint
    if (rightCoincide) {
      divideSegment(events[0], events[1].point, queue);
      return 3;
    }

    // no line segment includes totally the other one
    if (events[0] !== events[3].otherEvent) {
      divideSegment(events[0], events[1].point, queue);
      divideSegment(events[1], events[2].point, queue);
      return 3;
    }

    // one line segment includes the other one
    divideSegment(events[0], events[1].point, queue);
    divideSegment(events[3].otherEvent, events[2].point, queue);

    return 3;
  }

  /**
   * @param  {SweepEvent} le1
   * @param  {SweepEvent} le2
   * @return {Number}
   */
  function compareSegments(le1, le2) {
    if (le1 === le2) { return 0; }

    // Segments are not collinear
    if (signedArea(le1.point, le1.otherEvent.point, le2.point) !== 0 ||
      signedArea(le1.point, le1.otherEvent.point, le2.otherEvent.point) !== 0) {

      // If they share their left endpoint use the right endpoint to sort
      if (equals(le1.point, le2.point)) { return le1.isBelow(le2.otherEvent.point) ? -1 : 1; }

      // Different left endpoint: use the left endpoint to sort
      if (le1.point[0] === le2.point[0]) { return le1.point[1] < le2.point[1] ? -1 : 1; }

      // has the line segment associated to e1 been inserted
      // into S after the line segment associated to e2 ?
      if (compareEvents(le1, le2) === 1) { return le2.isAbove(le1.point) ? -1 : 1; }

      // The line segment associated to e2 has been inserted
      // into S after the line segment associated to e1
      return le1.isBelow(le2.point) ? -1 : 1;
    }

    if (le1.isSubject === le2.isSubject) { // same polygon
      var p1 = le1.point, p2 = le2.point;
      if (p1[0] === p2[0] && p1[1] === p2[1]/*equals(le1.point, le2.point)*/) {
        p1 = le1.otherEvent.point; p2 = le2.otherEvent.point;
        if (p1[0] === p2[0] && p1[1] === p2[1]) { return 0; }
        else { return le1.contourId > le2.contourId ? 1 : -1; }
      }
    } else { // Segments are collinear, but belong to separate polygons
      return le1.isSubject ? -1 : 1;
    }

    return compareEvents(le1, le2) === 1 ? 1 : -1;
  }

  function subdivide(eventQueue, subject, clipping, sbbox, cbbox, operation) {
    var sweepLine = new SplayTree(compareSegments);
    var sortedEvents = [];

    var rightbound = Math.min(sbbox[2], cbbox[2]);

    var prev, next, begin;

    while (eventQueue.length !== 0) {
      var event = eventQueue.pop();
      sortedEvents.push(event);

      // optimization by bboxes for intersection and difference goes here
      if ((operation === INTERSECTION && event.point[0] > rightbound) ||
          (operation === DIFFERENCE   && event.point[0] > sbbox[2])) {
        break;
      }

      if (event.left) {
        next  = prev = sweepLine.insert(event);
        begin = sweepLine.minNode();

        if (prev !== begin) { prev = sweepLine.prev(prev); }
        else                { prev = null; }

        next = sweepLine.next(next);

        var prevEvent = prev ? prev.key : null;
        var prevprevEvent = (void 0);
        computeFields(event, prevEvent, operation);
        if (next) {
          if (possibleIntersection(event, next.key, eventQueue) === 2) {
            computeFields(event, prevEvent, operation);
            computeFields(event, next.key, operation);
          }
        }

        if (prev) {
          if (possibleIntersection(prev.key, event, eventQueue) === 2) {
            var prevprev = prev;
            if (prevprev !== begin) { prevprev = sweepLine.prev(prevprev); }
            else                    { prevprev = null; }

            prevprevEvent = prevprev ? prevprev.key : null;
            computeFields(prevEvent, prevprevEvent, operation);
            computeFields(event,     prevEvent,     operation);
          }
        }
      } else {
        event = event.otherEvent;
        next = prev = sweepLine.find(event);

        if (prev && next) {

          if (prev !== begin) { prev = sweepLine.prev(prev); }
          else                { prev = null; }

          next = sweepLine.next(next);
          sweepLine.remove(event);

          if (next && prev) {
            possibleIntersection(prev.key, next.key, eventQueue);
          }
        }
      }
    }
    return sortedEvents;
  }

  var Contour = function Contour() {
    this.points = [];
    this.holeIds = [];
    this.holeOf = null;
    this.depth = null;
  };

  Contour.prototype.isExterior = function isExterior () {
    return this.holeOf == null;
  };

  /**
   * @param  {Array.<SweepEvent>} sortedEvents
   * @return {Array.<SweepEvent>}
   */
  function orderEvents(sortedEvents) {
    var event, i, len, tmp;
    var resultEvents = [];
    for (i = 0, len = sortedEvents.length; i < len; i++) {
      event = sortedEvents[i];
      if ((event.left && event.inResult) ||
        (!event.left && event.otherEvent.inResult)) {
        resultEvents.push(event);
      }
    }
    // Due to overlapping edges the resultEvents array can be not wholly sorted
    var sorted = false;
    while (!sorted) {
      sorted = true;
      for (i = 0, len = resultEvents.length; i < len; i++) {
        if ((i + 1) < len &&
          compareEvents(resultEvents[i], resultEvents[i + 1]) === 1) {
          tmp = resultEvents[i];
          resultEvents[i] = resultEvents[i + 1];
          resultEvents[i + 1] = tmp;
          sorted = false;
        }
      }
    }


    for (i = 0, len = resultEvents.length; i < len; i++) {
      event = resultEvents[i];
      event.otherPos = i;
    }

    // imagine, the right event is found in the beginning of the queue,
    // when his left counterpart is not marked yet
    for (i = 0, len = resultEvents.length; i < len; i++) {
      event = resultEvents[i];
      if (!event.left) {
        tmp = event.otherPos;
        event.otherPos = event.otherEvent.otherPos;
        event.otherEvent.otherPos = tmp;
      }
    }

    return resultEvents;
  }


  /**
   * @param  {Number} pos
   * @param  {Array.<SweepEvent>} resultEvents
   * @param  {Object>}    processed
   * @return {Number}
   */
  function nextPos(pos, resultEvents, processed, origPos) {
	try{
    var newPos = pos + 1,
        p = resultEvents[pos].point,
        p1;
    var length = resultEvents.length;

    if (newPos < length)
      { p1 = resultEvents[newPos].point; }

    while (newPos < length && p1[0] === p[0] && p1[1] === p[1]) {
      if (!processed[newPos]) {
        return newPos;
      } else   {
        newPos++;
      }
      p1 = resultEvents[newPos].point;
    }

    newPos = pos - 1;

    while (processed[newPos] && newPos > origPos) {
      newPos--;
    }

    return newPos;
}
catch(error){
	console.error(error);
	
}
  }


  function initializeContourFromContext(event, contours, contourId) {
    var contour = new Contour();
    if (event.prevInResult != null) {
      var prevInResult = event.prevInResult;
      // Note that it is valid to query the "previous in result" for its output contour id,
      // because we must have already processed it (i.e., assigned an output contour id)
      // in an earlier iteration, otherwise it wouldn't be possible that it is "previous in
      // result".
      var lowerContourId = prevInResult.outputContourId;
      var lowerResultTransition = prevInResult.resultTransition;
      if (lowerResultTransition > 0) {
        // We are inside. Now we have to check if the thing below us is another hole or
        // an exterior contour.
        var lowerContour = contours[lowerContourId];
        if (lowerContour.holeOf != null) {
          // The lower contour is a hole => Connect the new contour as a hole to its parent,
          // and use same depth.
          var parentContourId = lowerContour.holeOf;
          contours[parentContourId].holeIds.push(contourId);
          contour.holeOf = parentContourId;
          contour.depth = contours[lowerContourId].depth;
        } else {
          // The lower contour is an exterior contour => Connect the new contour as a hole,
          // and increment depth.
          contours[lowerContourId].holeIds.push(contourId);
          contour.holeOf = lowerContourId;
          contour.depth = contours[lowerContourId].depth + 1;
        }
      } else {
        // We are outside => this contour is an exterior contour of same depth.
        contour.holeOf = null;
        contour.depth = contours[lowerContourId].depth;
      }
    } else {
      // There is no lower/previous contour => this contour is an exterior contour of depth 0.
      contour.holeOf = null;
      contour.depth = 0;
    }
    return contour;
  }

  /**
   * @param  {Array.<SweepEvent>} sortedEvents
   * @return {Array.<*>} polygons
   */
  function connectEdges(sortedEvents) {
    var i, len;
    var resultEvents = orderEvents(sortedEvents);

    // "false"-filled array
    var processed = {};
    var contours = [];

    var loop = function (  ) {

      if (processed[i]) {
        return;
      }

      var contourId = contours.length;
      var contour = initializeContourFromContext(resultEvents[i], contours, contourId);

      // Helper function that combines marking an event as processed with assigning its output contour ID
      var markAsProcessed = function (pos) {
        processed[pos] = true;
        resultEvents[pos].outputContourId = contourId;
      };

      var pos = i;
      var origPos = i;

      var initial = resultEvents[i].point;
      contour.points.push(initial);

      /* eslint no-constant-condition: "off" */
      while (true) {
        markAsProcessed(pos);

        pos = resultEvents[pos].otherPos;

        markAsProcessed(pos);
        contour.points.push(resultEvents[pos].point);

        pos = nextPos(pos, resultEvents, processed, origPos);

        if (pos == origPos) {
          break;
        }
      }

      contours.push(contour);
    };

    for (i = 0, len = resultEvents.length; i < len; i++) loop(  );

    return contours;
  }

  var tinyqueue = TinyQueue;
  var default_1 = TinyQueue;

  function TinyQueue(data, compare) {
      if (!(this instanceof TinyQueue)) { return new TinyQueue(data, compare); }

      this.data = data || [];
      this.length = this.data.length;
      this.compare = compare || defaultCompare;

      if (this.length > 0) {
          for (var i = (this.length >> 1) - 1; i >= 0; i--) { this._down(i); }
      }
  }

  function defaultCompare(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
  }

  TinyQueue.prototype = {

      push: function (item) {
          this.data.push(item);
          this.length++;
          this._up(this.length - 1);
      },

      pop: function () {
          if (this.length === 0) { return undefined; }

          var top = this.data[0];
          this.length--;

          if (this.length > 0) {
              this.data[0] = this.data[this.length];
              this._down(0);
          }
          this.data.pop();

          return top;
      },

      peek: function () {
          return this.data[0];
      },

      _up: function (pos) {
          var data = this.data;
          var compare = this.compare;
          var item = data[pos];

          while (pos > 0) {
              var parent = (pos - 1) >> 1;
              var current = data[parent];
              if (compare(item, current) >= 0) { break; }
              data[pos] = current;
              pos = parent;
          }

          data[pos] = item;
      },

      _down: function (pos) {
          var data = this.data;
          var compare = this.compare;
          var halfLength = this.length >> 1;
          var item = data[pos];

          while (pos < halfLength) {
              var left = (pos << 1) + 1;
              var right = left + 1;
              var best = data[left];

              if (right < this.length && compare(data[right], best) < 0) {
                  left = right;
                  best = data[right];
              }
              if (compare(best, item) >= 0) { break; }

              data[pos] = best;
              pos = left;
          }

          data[pos] = item;
      }
  };
  tinyqueue.default = default_1;

  var max = Math.max;
  var min = Math.min;

  var contourId = 0;


  function processPolygon(contourOrHole, isSubject, depth, Q, bbox, isExteriorRing) {
    var i, len, s1, s2, e1, e2;
    for (i = 0, len = contourOrHole.length - 1; i < len; i++) {
      s1 = contourOrHole[i];
      s2 = contourOrHole[i + 1];
      e1 = new SweepEvent(s1, false, undefined, isSubject);
      e2 = new SweepEvent(s2, false, e1,        isSubject);
      e1.otherEvent = e2;

      if (s1[0] === s2[0] && s1[1] === s2[1]) {
        continue; // skip collapsed edges, or it breaks
      }

      e1.contourId = e2.contourId = depth;
      if (!isExteriorRing) {
        e1.isExteriorRing = false;
        e2.isExteriorRing = false;
      }
      if (compareEvents(e1, e2) > 0) {
        e2.left = true;
      } else {
        e1.left = true;
      }

      var x = s1[0], y = s1[1];
      bbox[0] = min(bbox[0], x);
      bbox[1] = min(bbox[1], y);
      bbox[2] = max(bbox[2], x);
      bbox[3] = max(bbox[3], y);

      // Pushing it so the queue is sorted from left to right,
      // with object on the left having the highest priority.
      Q.push(e1);
      Q.push(e2);
    }
  }


  function fillQueue(subject, clipping, sbbox, cbbox, operation) {
    var eventQueue = new tinyqueue(null, compareEvents);
    var polygonSet, isExteriorRing, i, ii, j, jj; //, k, kk;

    for (i = 0, ii = subject.length; i < ii; i++) {
      polygonSet = subject[i];
      for (j = 0, jj = polygonSet.length; j < jj; j++) {
        isExteriorRing = j === 0;
        if (isExteriorRing) { contourId++; }
        processPolygon(polygonSet[j], true, contourId, eventQueue, sbbox, isExteriorRing);
      }
    }

    for (i = 0, ii = clipping.length; i < ii; i++) {
      polygonSet = clipping[i];
      for (j = 0, jj = polygonSet.length; j < jj; j++) {
        isExteriorRing = j === 0;
        if (operation === DIFFERENCE) { isExteriorRing = false; }
        if (isExteriorRing) { contourId++; }
        processPolygon(polygonSet[j], false, contourId, eventQueue, cbbox, isExteriorRing);
      }
    }

    return eventQueue;
  }

  var EMPTY = [];


  function trivialOperation(subject, clipping, operation) {
    var result = null;
    if (subject.length * clipping.length === 0) {
      if        (operation === INTERSECTION) {
        result = EMPTY;
      } else if (operation === DIFFERENCE) {
        result = subject;
      } else if (operation === UNION ||
                 operation === XOR) {
        result = (subject.length === 0) ? clipping : subject;
      }
    }
    return result;
  }


  function compareBBoxes(subject, clipping, sbbox, cbbox, operation) {
    var result = null;
    if (sbbox[0] > cbbox[2] ||
        cbbox[0] > sbbox[2] ||
        sbbox[1] > cbbox[3] ||
        cbbox[1] > sbbox[3]) {
      if        (operation === INTERSECTION) {
        result = EMPTY;
      } else if (operation === DIFFERENCE) {
        result = subject;
      } else if (operation === UNION ||
                 operation === XOR) {
        result = subject.concat(clipping);
      }
    }
    return result;
  }


  function boolean(subject, clipping, operation) {
	if (subject[0] && subject[0][0] && subject[0][0][0] !== undefined) {
    if (typeof subject[0][0][0] === 'number') {
      subject = [subject];
    }
    if (typeof clipping[0][0][0] === 'number') {
      clipping = [clipping];
    }
}
    var trivial = trivialOperation(subject, clipping, operation);
    if (trivial) {
      return trivial === EMPTY ? null : trivial;
    }
    var sbbox = [Infinity, Infinity, -Infinity, -Infinity];
    var cbbox = [Infinity, Infinity, -Infinity, -Infinity];

    // console.time('fill queue');
    var eventQueue = fillQueue(subject, clipping, sbbox, cbbox, operation);
    //console.timeEnd('fill queue');

    trivial = compareBBoxes(subject, clipping, sbbox, cbbox, operation);
    if (trivial) {
      return trivial === EMPTY ? null : trivial;
    }
    // console.time('subdivide edges');
    var sortedEvents = subdivide(eventQueue, subject, clipping, sbbox, cbbox, operation);
    //console.timeEnd('subdivide edges');

    // console.time('connect vertices');
    var contours = connectEdges(sortedEvents);
    //console.timeEnd('connect vertices');

    // Convert contours to polygons
    var polygons = [];
    for (var i = 0; i < contours.length; i++) {
      var contour = contours[i];
      if (contour.isExterior()) {
        // The exterior ring goes first
        var rings = [contour.points];
        // Followed by holes if any
        for (var j = 0; j < contour.holeIds.length; j++) {
          var holeId = contour.holeIds[j];
          rings.push(contours[holeId].points);
        }
        polygons.push(rings);
      }
    }

    return polygons;
  }

  function union (subject, clipping) {
    return boolean(subject, clipping, UNION);
  }

  function diff (subject, clipping) {
    return boolean(subject, clipping, DIFFERENCE);
  }

  function xor (subject, clipping) {
    return boolean(subject, clipping, XOR);
  }

  function intersection$1 (subject, clipping) {
    return boolean(subject, clipping, INTERSECTION);
  }

  // loadData(path + file);
  window.polygonDiff = diff;
  window.polygonUnion = union;
  window.polygonIntersection = intersection$1;
  window.polygonXor = xor;
}());
// EXPORTEND

claimTask = function(d) {
	trackData.claimCallback(d);
}

releaseTask = function(d) {
	trackData.releaseCallback(d);
}

function adlSubmit() {
	if( blockEdit ) return taskLocked();
	window.onbeforeunload = null;
	var annotations = clone(exportData());
	console.log( 'SUBMIT', annotations );
    trackData.submit(annotations);;
}

window.ick = function(v){
    console.log(exportData(v));
}

var updateAnnotationsTid = null;
var lastUpdate = null;

var updateFlag = false;
function updating(){
	return updateFlag;
}

function showSave(s, ts){
	console.log('sessionh', s, ts)
	// descriptor.version = s;
	if( ts ) s += ' - ' + new Date(ts).toLocaleString()
	$('#version').remove();
	$('.rightcol').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html(s)
	);
}

function updateAnnotations() {
	updateFlag = true;
    clearTimeout( updateAnnotationsTid );
	window.onbeforeunload = function(){
		// Do something
		return false;
	 }
	// $(document.body).off('blur').on('blur', function(){
	// 	return false;
	// })

	updateAnnotationsTid = setTimeout(async function () {
		
		var annotations = clone(exportData(0));
		delete annotations.selected;
		delete annotations.updateTime;
		var blist = tree2List( annotations.boxes )
		blist.sort( (a,b) => a.id > b.id ? -1 : 1 )
		blist.push( annotations.review )
		blist.push( annotations.attributes )
		var sann = JSON.stringify(blist);
		window.onbeforeunload = null;
		updateFlag = false;
		if( !lastUpdate || sann == lastUpdate ) {
			lastUpdate = sann;
			return;
		}
		lastUpdate = sann;
		if( blockEdit ) return taskLocked();
		console.log( 'UPDATING' );
		// console.log( 'UPDATING\n'+sann+'\n'+lastUpdate);
		if( reviewMode ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
		showSave('Saving...');
		await trackData.update(annotations);
		showSave('Saved', Date.now() )

        // var now = getsec();
        // if( !window.descriptor.sessionStart ) window.descriptor.sessionStart = now;
    }, 2000 )
	console.log('dexx', window.descriptor)
	// showSave('Session started', window.descriptor.sessionStart * 1000)
};

myAlert = frm.myAlert;
myAlertClose = frm.myAlertClose;

var changeTid = null;
// changed = function()
// {
// 	clearTimeout( changeTid );
// 	changeTid = setTimeout( function(){
// 		var annotations = exportData(1);
// 		if( reviewMode ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
// 		descriptor.update(annotations);
// 	}, 200 );
// 	// return;
// }

// exports.textPDF = textPDF;
export default {preload,updating}
// ADLEND
